import React, { Component, useState, useEffect, useContext, Fragment } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "./Interview1003View.css"
import "../App.css"
import { SimpleTip } from "../Common/Tooltip"
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tabs } from 'antd-mobile'
import {
    Anchor,
    Dropdown,
    Space,
    Input,
    InputNumber,
    Checkbox,
    Select,
    Button,
    DatePicker,
    Spin,
    Alert,
    Skeleton,
    Radio,
    Tooltip
} from "antd"
import dayjs from "dayjs"
import IncomeCalculationModal from "./IncomeCalculationModal";
import BusinessIncomeCalculationModal from "./BusinessIncomeCalculationModal";
import AddressAutocomplete from "../Common/AddressAutocomplete"
import CreditSummaryReview from "../CrediReport/CreditSummaryReview"
import LinkModal from "../CrediReport/LinkModal"
import LenderLoanForm from "./lenderLoanForm"
import IncomeSourcesTable, {
    OtherAssetsTable,
    LiabilitiesTable,
    PropertyMortgagesTable,
    GiftsTable,
    OtherLiabilitiesTable,
    OwnedPropertyLoansTable,
} from "./tables"
import { DownOutlined, LeftOutlined, RightOutlined, MinusSquareOutlined, MinusCircleOutlined } from "@ant-design/icons"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import { withRouter } from "react-router-dom"
import CheckGroup from "../Common/components/CheckGroup"
import InputGroup from 'react-bootstrap/InputGroup'
import * as st from "../State"
import * as act from "../Store/actions"
import { updateStatus } from "../Store/status"
import { getCurrentState, mergeState } from "../Store"

import { connect } from "react-redux"
import {
    UpdateChangeProgress,
    UpdateChangeVisitedStage,
    UpdateChangeLastTouch,
} from "../Store/progress"
import * as com from "../Common.js"
import { get, throttle, update, isEmpty } from "lodash"
import { forEach } from "jszip"
import CheckboxExtended from "Common/components/CheckboxPreview"
import FormPreview from "Common/components/FormPreview"
import { checkAccess } from "Auth"
import { companyAddressForBroker } from "./brokerSeed"
const { Option } = Select
const deepcopy = require('deepcopy')

// 公用的计算函数，用于计算百分比
const calculatePercentage = (amount, propertyValue) => {
    return propertyValue > 0 ? Math.round((amount / propertyValue) * 100 * 100) / 100 : 0
}

// 公用的显示组件，用于在非编辑模式下显示金额和百分比
const ViewModeDisplay = ({ amount, percentage }) => (
    <div style={{ fontSize: '16px', marginTop: '4px' }}>
        ${(amount || 0).toLocaleString()} ({percentage}%)
    </div>
)

// 公用的显示组件，用于在非编辑模式下显示金额（无百分比）
const ViewModeDisplayAmount = ({ amount }) => (
    <div style={{ fontSize: '16px', marginTop: '4px' }}>
        ${(amount || 0).toLocaleString()}
    </div>
)

const mapStateToProps = (state) => {
    return {
        application: state.application,
        borrower: state.borrower,
        progress: state.progress,
        selection: state.application.selection,
        status: state.updateStatus.status,
        // isBetaCustomer: state.subscriptionReducer.currentInfo.configurations?.isBetaCustomer,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateBrokerInfo: (value, verb) => {
        dispatch(act.UpdateBrokerInfo(value, verb))
    },
    updateEqualOpportunitySub: (value, who, section, verb) => {
        dispatch(act.UpdateEqualOpportunitySub(value, who, section, verb))
    },
    addPreviousAddress: (event, who) => {
        dispatch(act.AddPreviousAddress(event.target.value, who))
    },
    updatePreviousAddress: (event, who, verb, n) => {
        dispatch(act.UpdatePreviousAddress(event.target.value, who, verb, n))
    },
    updateStatus: (status) => {
        dispatch(updateStatus(status))
    },
    changeBorrowerInfo: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb))
    },
    changePhoneInfo: (input, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(input, who, verb))
    },
    changeBorrowerInfoByValue: (val, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(val, who, verb))
    },
    changeBorrowerInfoByNumberValue: (val, who, verb) => {

        val = val === null ? '' : val.toString().replace(/\D/g, "")
        dispatch(act.ChangeBorrowerInfo(val, who, verb))
    },
    updateCoborrower: (event) => {
        dispatch(act.UpdateHasCoborrower(event))
    },
    changeOccupationInfo: (event, who, verb) => {
        dispatch(act.ChangeOccupationInfo(event.target.value, who, verb))
    },
    changeOccupationInfo2: (event, who, verb, orgVal) => {
        let val = ''
        if(Number(orgVal) < 25 && event.target.value === 'less'){
            val = orgVal
        }else if(Number(orgVal) > 24 && event.target.value === 'more'){
            val = orgVal
        }else {
            val = event.target.value === 'less' ? '24' : '25'
        }
        dispatch(act.ChangeOccupationInfo(val, who, verb))
    },
    changeOccupationInfo3: (value, who, verb, orgVal) => {
        // console.log('changeOccupationInfo3-------', value, who, verb, orgVal, typeof orgVal, 'a' + orgVal + 'a')
        if(orgVal.length) return
        dispatch(act.ChangeOccupationInfo('24', who, verb))
    },
    changeOccupationInfoByValue: (event, who, verb) => {
        dispatch(act.ChangeOccupationInfo(event, who, verb))
    },
    updateIncomeMonthly: (val, who, verb) => {
        dispatch(act.UpdateIncomeMonthly(val, who, verb))
    },
    updateIncomeMonthlyByVal: (event, who, verb) => {
        dispatch(act.UpdateIncomeMonthly(event, who, verb))
    },
    updateIncomeAtttribute: (t, who, verb) => {
        dispatch(act.UpdateIncomeAtttribute(t, who, verb))
    },
    addBorrowerOtherOccupation: (who) => {
        dispatch(act.AddBorrowerOtherOccupation(who))
    },
    removeBorrowerOtherOccupation: (who, index) => {
        dispatch(act.RemoveBorrowerOtherOccupation(who, index))
    },
    clearBorrowerOtherOccupations: (who) => {
        dispatch(act.ClearBorrowerOtherOccupations(who))
    },
    changeBorrowerOtherOccupationValue: (t, i, who, verb) => {
        dispatch(act.ChangeBorrowerOtherOccupationValue(t, i, who, verb))
    },
    changeBorrowerPreviousOccupationIncome: (t, i, who, verb) => {
        dispatch(act.ChangeBorrowerPreviousOccupationIncome(t, i, who, verb))
    },
    addBorrowerPreviousOccupation: (who) => {
        dispatch(act.AddBorrowerPreviousOccupation(who))
    },
    removeBorrowerPreviousOccupation: (who, index) => {
        dispatch(act.RemoveBorrowerPreviousOccupation(who, index))
    },
    clearBorrowerPreviousOccupations: (who) => {
        dispatch(act.ClearBorrowerPreviousOccupations(who))
    },
    changeBorrowerPreviousOccupationValue: (t, i, who, verb) => {
        dispatch(act.ChangeBorrowerPreviousOccupationValue(t, i, who, verb))
    },
    changeOccupationCheck: (event, who, verb) => {
        dispatch(act.ChangeOccupationInfo(event.target.checked, who, verb))
    },
    addAdditionaOccupation: (event, who) => {
        dispatch(act.AddAdditionaOccupation(event, who))
    },
    removeAdditionalOccupation: (event, who, i) => {
        dispatch(act.RemoveAdditionalOccupation(event.target.value, who, i))
    },
    clearAdditionalOccupations: (event, who) => {
        dispatch(act.ClearAdditionalOccupations(event, who))
    },
    bulkAddBorrowerOwnedProperties: (t) => {
        dispatch(act.BulkAddBorrowerOwnedProperties(t))
    },
    addBorrowerOwnedProperty: (t) => {
        dispatch(act.AddBorrowerOwnedProperty(t))
    },
    addCoborrowerOwnedProperty: (t) => {
        dispatch(act.AddCoborrowerOwnedProperty(t))
    },
    changeBorrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeBorrowerOwnedProperty(t, i, v))
    },
    changeCoborrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeCoborrowerOwnedProperty(t, i, v))
    },
    removeBorrowerOwnedProperty: (i) => {
        dispatch(act.RemoveBorrowerOwnedProperty(i))
    },
    removeCoborrowerOwnedProperty: (i) => {
        dispatch(act.RemoveCoborrowerOwnedProperty(i))
    },
    clearBorrowerOwnedProperty: (t) => {
        dispatch(act.ClearBorrowerOwnedProperty(t))
    },
    clearCoborrowerOwnedProperty: (t) => {
        dispatch(act.ClearCoborrowerOwnedProperty(t))
    },
    updateExpenses: (val, who, verb) => {
        dispatch(act.UpdateExpenses(val, who, verb))
    },
    updateBorrowerAdditionalIncome: (event, who, verb, n) => {
        dispatch(
            act.UpdateBorrowerAdditionalIncome(event.target.value, who, verb, n)
        )
    },
    changePastOccupationInfo: (event, who, verb, index) => {
        dispatch(
            act.ChangePastOccupationInfo(event.target.value, who, verb, index)
        )
    },
    changePastOccupationDate: (date, who, verb, index) => {
        dispatch(act.ChangePastOccupationInfo(date, who, verb, index))
    },
    changePastOccupationPhone: (phone, who, verb, index) => {
        dispatch(act.ChangePastOccupationInfo(phone, who, verb, index))
    },
    changePastOccupationCheck: (event, who, verb, index) => {
        dispatch(
            act.ChangePastOccupationInfo(event.target.checked, who, verb, index)
        )
    },
    addBorrowerAdditionalIncome: (t, who) => {
        dispatch(act.AddBorrowerAdditionalIncome(t, who))
    },
    removeBorrowerAdditionalIncome: (i, who) => {
        dispatch(act.RemoveBorrowerAdditionalIncome(i, who))
    },
    clearBorrowerAdditionalIncome: (who) => {
        dispatch(act.ClearBorrowerAdditionalIncome(who))
    },
    updateBorrowerAdditionalIncome: (event, who, verb, n) => {
        dispatch(
            act.UpdateBorrowerAdditionalIncome(event.target.value, who, verb, n)
        )
    },
    changeMobileHomeInfo: (value, verb) => {
        dispatch(act.ChangeMobileHomeInfo(value, verb))
    },
    changeMainProperty: (value, verb) => {
        dispatch(act.ChangeMainProperty(value, verb))
    },
    changeMainPropertyPurpose: (val) => {
        dispatch(act.ChangeMainPropertyPurpose(val))
    },

    changeMainPropertyAttribute: (t, verb) => {
        
        console.log('@-changeMainPropertyAttribute',t,verb);
        
        dispatch(act.ChangeMainPropertyAttribute(t, verb))
    },
    updateSelectField: (input, verb) => {
        dispatch(act.UpdateSelectField(input, verb))
    },
    updateSelectedLoanField: (input, verb) => {
        dispatch(act.UpdateSelectedLoanField(input, verb))
    },
    clearBorrowerGift: () => {
        dispatch(act.ClearBorrowerGift())
    },
    changeDeclaration: (event, who, verb) => {
        dispatch(act.ChangeDeclaration(event, who, verb))
    },
    updateEqualOpportunity: (value, who, verb) => {
        dispatch(act.UpdateEqualOpportunity(value, who, verb))
    },
    updateEqualOpportunitySub: (value, who, section, verb) => {
        dispatch(act.UpdateEqualOpportunitySub(value, who, section, verb))
    },
    updateChangeProgress: (step, stage) => {
        dispatch(UpdateChangeProgress(step, stage))
    },
    updateChangeLastTouch: (t) => {
        dispatch(UpdateChangeLastTouch(t))
    },
    updateChangeVisitedStage: (step, stage) => {
        dispatch(UpdateChangeVisitedStage(step, stage))
    },
    updateApplicationAttribute: (input, verb) => {
        dispatch(act.UpdateApplicationAttribute(input, verb))
    },
    changeBorrowerOtherOccupationIncome: (t, i, who, verb) => {
        dispatch(act.ChangeBorrowerOtherOccupationIncome(t, i, who, verb))
    },
    needUpdateLenderLoanForm: (value) => {
        dispatch(act.NeedUpdateLenderLoanForm(value))
    }
})

class Interview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentBusinessName: '',
            currentIncome: {type: '', index: ''},
            editMode: true,
            loanLimits: [],
            showOwnPropertyWarning1: false,
            showOwnPropertyWarning2: false,
            activeKey: 's1',
            offsetTop: '',
            handingOff: false,
            currentView: props.view || "borrower",
            bodependentages: [],
            codependentages: [],
            loading: false,
            companyInfo: {},
            loInfo: {},
            BusinessIncomeCalModal: false,
            IncomeCalModal: false,
            creditSummaryReviewOpen: false,
            linkModalOpen: false,
            linkType: 'property',
            creditLiability: [],
            requestedTime: '',
            creditReportLoading: false,
            creditCheckType: 'section2c'
        }
        // 使用 Intersection Observer 来监听section进入可视区域
        this.setupIntersectionObserver = () => {
            console.log('setupIntersectionObserver called')
            
            // 定义所有锚点ID
            const allAnchorIds = [
                's1', '1a', '1b', '1c', '1d', '1e',
                's2', '2a', '2b', '2c', '2d',
                's3', '3a', '3b', '3c',
                's4', '4a', '4b', '4c', '4d',
                's5', '5a', '5b',
                's6', 's7', 's8', 's9',
                'lenderLoanForm', 'L1', 'L2', 'L3', 'L4'
            ]
            
            // 检查滚动容器是否存在
            const scrollContainer = document.querySelector('.expanded.loans-left-anchor')
            console.log('Scroll container found:', scrollContainer)
            
            if (!scrollContainer) {
                console.log('Scroll container not found, retrying in 500ms...')
                setTimeout(() => this.setupIntersectionObserver(), 500)
                return
            }
            
            // 创建 Intersection Observer
            this.intersectionObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const anchorId = entry.target.id
                            // console.log(`Section ${anchorId} entered viewport`)
                            
                            if (this.state.activeKey !== anchorId) {
                                // console.log('Updating activeKey from', this.state.activeKey, 'to', anchorId)
                                this.setState({ activeKey: anchorId })
                                this.updateAnchorActiveState(anchorId)
                            }
                        }
                    })
                },
                {
                    root: scrollContainer, // 滚动容器
                    rootMargin: '-20% 0px -70% 0px', // 当section进入顶部20%区域时触发
                    threshold: 0
                }
            )
            
            let observedCount = 0
            // 观察所有section元素
            allAnchorIds.forEach(anchorId => {
                const element = document.getElementById(anchorId)
                if (element) {
                    this.intersectionObserver.observe(element)
                    observedCount++
                    console.log(`Observing section: ${anchorId}`)
                } else {
                    console.log(`Section not found: ${anchorId}`)
                }
            })
            
            console.log(`Total sections observed: ${observedCount}`)
        }
    }

    // 检查LTV并自动清零PMI - 参考EstimatedPayment逻辑
    checkAndClearPMI = () => {
        const property = this.props.application.property
        const selection = this.props.application.selection || {}
        const propertyValue = property.purpose === "purchase" ? parseFloat(property.salesprice) : parseFloat(property.appraisal)
        const loansize = parseFloat(selection.loansize) || 0
        const ltv = propertyValue > 0 ? loansize / propertyValue : 0
        
        // 如果LTV <= 0.8且当前PMI不为0，则自动清零PMI
        if (ltv <= 0.8) {
            const currentPMI = parseFloat(property.insurancepmi) || 0
            if (currentPMI > 0) {
                this.props.changeMainProperty(0, "insurancepmi")
                // 同步更新insurancemaintenancetaxes
                this.updateInsuranceMaintenancetaxesWithNewValue("insurancepmi", 0)
            }
        }
    }

    notifyBorrowerAboutNewAccount = e => {
        this.setState({ handingOff: true })
        let token = sessionStorage.getItem("ZeitroA")
        let id = this.props.borrower.id
        let body = { token: id, type: this.props.handingOffType }
        fetch('/borrower/handoff', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(
            response => {
                if (response.status !== 200) {
                    alert('Looks like there was a problem. Please try later.')
                    this.setState({ handingOff: false })
                    return
                }
                response.json().then(js => {
                    this.setState({ handingOff: false })
                    alert("An email has been sent to your borrower instructing them to log in and continue with the loan application.")
                })
            }
        ).catch((err) => {
            console.log('Fetch Error :', err)
        })
    }
    getCompanyProfile = () => {
        console.log("getting company profile")
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        fetch("/los/getcompanyprofilesetup", {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(res => {
            if (!res.ok) {
                this.setState({ loading: false })
            } else {
                res.json().then(js => {
                    let data = js
                    const { street, city, state, zip } = companyAddressForBroker(data)
                    let info = {
                        name: data.Name,
                        street: street,
                        city: city,
                        state: state,
                        zip: zip,
                        nmls: data.CompanyNMLS,
                        licenseid: data.LicenseId,
                    }

                    this.setState({ companyInfo: info, loading: false })
                    let brokerinfo = this.props.application.brokerinfo
                    Object.keys(info).forEach(key => {
                        if (key === "state"){
                            if (brokerinfo[key] === "" || com.convertAbbStateToFull(info[key]) === brokerinfo[key]) {
                                this.props.updateBrokerInfo(com.convertAbbStateToFull(info[key]), key)
                            }
                        }
                        else{
                            if (brokerinfo[key] === "" || info[key] === brokerinfo[key]) {
                                this.props.updateBrokerInfo(info[key], key)
                            }
                        }
                    })
                })
            }
        }).catch(err => {
            this.setState({ companyProfile: {} })
            console.log("Revalidate catch error " + err)
        })
    }

    getLOProfile = () => {
        console.log("getting lo profile")
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        const paths = window.location.pathname.split('/')
        fetch("/los/getloanprocessor", {
            body: JSON.stringify({ LoanID: paths[paths.length - 1] }),
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(res => {
            if (!res.ok) {
                this.setState({ loading: false })
            } else {
                res.json().then(js => {
                    this.setState({ loading: false, loInfo: js.CurrentLO })
                    let info = {
                        loanofficername: js.CurrentLO.FirstName + " " + js.CurrentLO.LastName,
                        phone: js.CurrentLO.Phone,
                        email: js.CurrentLO.Email,
                        loanofficernmls: js.CurrentLO.NMLS,
                        loanofficerlicenseid: js.CurrentLO.LicenseID,
                    }
                    let brokerinfo = this.props.application.brokerinfo
                    Object.keys(info).forEach(key => {
                        if (brokerinfo[key] === "" || info[key] === brokerinfo[key]) {
                            this.props.updateBrokerInfo(info[key], key)
                        }
                    })
                })
            }
        }).catch(err => {
            this.setState({ loading: false })
            console.log("Revalidate catch error " + err)
        })
    }


    getLoanLimits = () => {
        fetch("/data/loanlimits")
            .then((res) => {
                if (!res.ok) {
                    throw Error(res.statusText)
                }
                return res.json()
            })
            .then((res) => {
                this.setState({ loanLimits: res })
            })
            .catch((err) => {
                console.error(err)
            })
    };

    getCountyOptions = (st) => {
        let options = []
        options.push({value:"", label:""})
        let s = st.toUpperCase()
        if (st.length === 2) {
            s = com.convertAbbStateToFull(st).toUpperCase()
        }

        if (s in this.state.loanLimits) {
            let keys = Object.keys(this.state.loanLimits[s])

            keys.forEach((x) => {
                options.push({ value: com.capitalize(x), label: com.capitalize(x) })
            })
        }
        return options
    };

    getStateOptions = () => {
        let options = []
        options.push({value:"",label:""})
        let keys = Object.keys(this.state.loanLimits)

        keys.forEach((x) => {
            options.push({
                value: com.capitalize(x),
                label: com.capitalize(x),
            })
        })
        return options
    };

    updateIncomeMonthly = (val, who, attr) => {
        // this.props.updateIncomeMonthlyByVal("monthly", who, attr + "monthly")
        this.props.updateIncomeMonthly(val, who, attr)
    }

    dateField = (label, value, onChangeFunc, placeholder) => {
        let dateFormat = "MM/DD/YYYY"
        let earliest = "01/01/1900"
        return (
            <div>
                {label === null ? (
                    ""
                ) : (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                )}
                {this.state.editMode ? (
                    <DatePicker
                        size="large"
                        style={value === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                        value={value === "" ? value : dayjs(value, dateFormat)}
                        format={{
                            format: dateFormat,
                            type: 'mask',
                        }}
                        onChange={onChangeFunc}
                        
                    />
                ) : (
                    <div style={{ fontSize: 16 }}>{value}</div>
                )}
            </div>
        )
    };

    inputField = (label, value, onChangeFunc, placeholder, out) => {
        return (
            <div>
                {label === null ? (
                    ""
                ) : (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                )}
                {this.state.editMode ? (
                    <InputGroup>
                        <Form.Control
                            value={value}
                            defaultValue={value}
                            style={value === '' && !out && this.props.mode !== 'document' ? { border: '1px solid #faad14', borderRadius: '4px' } : {}}
                            onChange={onChangeFunc}
                            placeholder={typeof placeholder !== "undefined" ? placeholder : ""}
                            aria-describedby="basic-addon2"
                        />
                        {value === '' && !out && <div className="ExclamationCircleOutlined"><ExclamationCircleOutlined /></div>}

                    </InputGroup>
                ) : (
                    <div style={{ fontSize: 16 }}>{value}</div>
                )}
            </div>
        )
    };

    updateDependentsAges = (idx, age, ages, currentView, verb) => {
        let newages = ages
        if (age == "") {
            newages[idx] = " "
        } else {
            newages[idx] = age
        }
        let agelist = newages.join(",").trim();
        if (newages.every(age => age.trim() === "")) {
            agelist = "";
        }
        this.props.changeBorrowerInfo({target: {value: agelist}}, currentView, verb)
    }

    getAgesFields = (num, ages, currentView, verb) => {
        let fields = [];
        // Limit the maximum number of inputs to avoid browser freezes, please see https://zeitro.atlassian.net/browse/BOR-2673
        const safeNum = Math.min(parseInt(num) || 0, 20);
        for (let i = 0; i < safeNum; i++) {
            fields.push(
                <Col sm={6} className="mb-4">
                    {this.inputFieldWithPrefix(`Age of dependent ${i + 1}`, ages[i], (e) => this.updateDependentsAges(i,e.target.value, ages, currentView, verb), "Age")}
                </Col>
            )
        }
        return fields
    }

    inputFieldWithPrefix = (label, value, onChangeFunc, prefix, tipContent, out, onBlurFunc, errorText) => {
        const emptyWarn = value === '' && (prefix === 'Phone' || prefix === 'Email' || prefix === '$') && !out && this.props.mode !== 'document'
        return (
            <div>
                {label !== null ? (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                ) : (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        &nbsp;
                    </div>
                )}

                {this.state.editMode ? (
                    <>
                    <Input
                        value={value}
                        status={errorText ? 'error' : (emptyWarn ? 'warning' : null)}
                        onChange={onChangeFunc}
                        addonBefore={typeof tipContent !== "undefined" ? <div>{prefix}<SimpleTip content={tipContent} /> </div> : prefix}
                        size="large"
                        onBlur={onBlurFunc}
                    />
                    {errorText ? (
                        <div style={{ color: "#ff4d4f", fontSize: 13, marginTop: 6, lineHeight: 1.4 }}>{errorText}</div>
                    ) : null}
                    </>
                ) : (
                    <div style={{ fontSize: 16 }}>{prefix === "$" ? prefix + " " + value : prefix + ": " + value}</div>
                )}
            </div>
        )
    };

    /**
     * @name onDependentsQuantityChange 监听 "Dependents" 数量变化
     * @description 清理多余的 "Age Input" 值，并与服务器同步
     * @see https://zeitro.atlassian.net/browse/BOR-2936
     */
    onDependentsQuantityChange = (quantity, currentView) => {
        const KEY = currentView === "coborrower" ? "codependentages" : "bodependentages";
        const length = this.state[KEY]?.length;
        if (quantity < length) {
          this.setState((e) => {
              e[KEY].splice(quantity, length);
              return { ...e };
          },() => {
            const value = this.state[KEY]?.map(item => item.trimStart()).join(',') || '';
            this.props.changeBorrowerInfo({target: { value }}, currentView, 'dependentsages');
          });
        }
    };

    inputNumberFields = (label, values, onChangeFuncs, prefixes, suffixes) => {
        let inputFields = []
        for (let i = 0; i < values.length; i++) {
            inputFields.push(
                this.state.editMode ? (
                    <InputNumber
                        status={values[i] === '' && this.props.mode !== 'document' ? 'warning' : null}
                        value={values[i]}
                        defaultValue={values[i]}
                        onChange={onChangeFuncs[i]}
                        addonBefore={prefixes !== null ? prefixes[i] : ""}
                        addonAfter={suffixes !== null ? suffixes[i] : ""}
                        size="large"
                        className="pr-2"
                    />
                ) : (
                    <div style={{ fontSize: 16 }} className="pr-2">
                        {values[i] + " " + suffixes[i]}
                    </div>
                )
            )
        }

        return (
            <div>
                {label !== null ? (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                ) : (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        &nbsp;
                    </div>
                )}
                <div className="d-flex">{inputFields}</div>
            </div>
        )
    };
    inputFields = (label, values, onChangeFuncs, prefixes, suffixes, outs) => {
        let inputFields = []
        for (let i = 0; i < values.length; i++) {
            inputFields.push(
                this.state.editMode ? (
                    <Input
                        status={values[i] === '' && !outs[i] && this.props.mode !== 'document' ? 'warning' : null}

                        value={values[i]}
                        onChange={onChangeFuncs[i]}
                        addonBefore={prefixes !== null ? prefixes[i] : ""}
                        suffix={suffixes !== null ? suffixes[i] : ""}
                        className={i === values.length - 1 ? "" : "pr-4"}
                    />
                ) : (
                    <div
                        style={{ fontSize: 16 }}
                        className={i === values.length - 1 ? "" : "pr-4"}
                    >
                        {prefixes[i] + ": " + values[i] + " " + suffixes[i]}
                    </div>
                )
            )
        }

        return (
            <div>
                {label !== null && (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                )}
                <div className="d-flex">{inputFields}</div>
            </div>
        )
    };
    dropdownField = (label, value, options, onChangeFunc, out) => {
        if (!options) return ""
        let selected = options.filter((o) => o.value === value)
        return (
            <div>
                {label === null ? (
                    ""
                ) : (
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                )}
                {this.state.editMode ? (
                    <>

                        <Form.Control
                            as="select"
                            defaultValue={value}
                            value={value}
                            onChange={onChangeFunc}
                            style={value === '' && !out && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                        >
                            {options.map((o) => (
                                <option value={o.value}>{o.label}</option>
                            ))}
                        </Form.Control>
                    </>
                ) : (
                    <div style={{ fontSize: 16 }}>
                        {selected.length > 0 ? selected[0].label : ""}
                    </div>
                )}
            </div>
        )
    };
    horizontalDropdownField = (label, value, options, onChangeFunc) => {
        let selected = options.filter((o) => o.value === value)
        return (
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2 col-7">{label}</div>
                {this.state.editMode ? (
                    <Form.Control
                        as="select"
                        value={value}
                        onChange={onChangeFunc}
                    >
                        {options.map((o) => (
                            <option value={o.value}>{o.label}</option>
                        ))}
                    </Form.Control>
                ) : (
                    <div style={{ fontSize: 16 }}>
                        {selected.length > 0 ? selected[0].label : ""}
                    </div>
                )}
            </div>
        )
    };
    selectionField = (label, value, options, onChangeFunc, isHorizontal, isVerticalgroup) => {
        let selected = options.filter((o) => o.value === value)
        if (isHorizontal) {
            return (
                <div className="d-flex justify-content-between">
                    <div className="mr-2">{label}</div>
                    {this.state.editMode ? (
                        <CheckGroup
                            data={options}
                            onChangeSelect={onChangeFunc}
                            value={value}
                            type="radio"
                            style={{
                                width: "100%",
                                ...(value === '' && {
                                    padding: '11px 5px 0px 5px',
                                    ...(this.props.mode !== 'document' && { border: '1px solid #faad14' })
                                })
                            }}
                            direction="horizontal"
                        />
                    ) : (
                        <div style={{ fontSize: 16 }}>
                            {selected.length > 0 ? selected[0].label : ""}
                        </div>
                    )}
                </div>
            )
        } else {
            return (
                <div>
                    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                        {label}
                    </div>
                    {this.state.editMode ? (
                        <CheckGroup
                            mode={this.props.mode === 'document' ? 'document-checkGroup' : 'normal'}
                            data={options}
                            onChangeSelect={onChangeFunc}
                            value={value}
                            type="radio"
                            style={{
                                width: "100%",
                                ...((value === '' || value === null) && {
                                    padding: '11px 5px 0px 5px',
                                    ...(this.props.mode !== 'document' && { border: '1px solid #faad14' })
                                })
                            }}
                            direction={isVerticalgroup ? "vertical" : "horizontal"}
                        />
                    ) : (
                        <div style={{ fontSize: 16 }}>
                            {selected.length > 0 ? selected[0].label : ""}
                        </div>
                    )}
                </div>
            )
        }
    };

    ethnicityField = (value, onChangeFunc, hispanicOptions) => {
        const options = [
            { value: 'hispanic', label: 'Hispanic or Latino' },
            { value: 'nonhispanic', label: 'Not Hispanic or Latino' },
            { value: 'donttell', label: 'I do not wish to provide this information' },
        ]

        const selected = options.filter((o) => o.value === value)

        return (
            <div>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                    Ethnicity
                </div>
                {this.state.editMode ? (
                    <div
                        style={{
                            width: '100%',
                            ...((value === '' || value === null) && {
                                padding: '11px 5px 0px 5px',
                                ...(this.props.mode !== 'document' && {
                                    border: '1px solid #faad14',
                                }),
                            }),
                        }}
                    >
                        <div>
                            <CheckGroup
                                mode={this.props.mode === 'document' ? 'document-checkGroup' : 'normal'}
                                data={[options[0]]}
                                onChangeSelect={onChangeFunc}
                                value={value}
                                type="radio"
                                direction={'vertical'}
                            />
                            {value === 'hispanic' && (
                                <div className="mt-2">
                                    <div className="fontWeight500 mb-3">
                                        Check all that apply:
                                    </div>
                                    <Row className="justify-content-between">
                                        {hispanicOptions}
                                    </Row>
                                </div>
                            )}
                        </div>

                        <CheckGroup
                            mode={this.props.mode === 'document' ? 'document-checkGroup' : 'normal'}
                            data={options.slice(1)}
                            onChangeSelect={onChangeFunc}
                            value={value}
                            type="radio"
                            direction={'vertical'}
                        />
                    </div>
                ) : (
                    <div style={{ fontSize: 16 }}>
                        {selected.length > 0 ? selected[0].label : ''}
                    </div>
                )}
            </div>
        )
    }

    yesNoField = (label, value, onChangeFunc) => {
        let options = [
            {
                value: "yes",
                label: "Yes",
            },
            {
                value: "no",
                label: "No",
            },
        ]
        let selected = options.filter((o) => o.value === value)
        return (
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2 fontWeight500 col-7 pl-0">{label}</div>
                {this.state.editMode ? (
                    <CheckGroup
                        data={options}
                        onChangeSelect={onChangeFunc}
                        value={value}
                        type="radio"
                        style={{ width: "100%" }}
                        direction="horizontal"
                    />
                ) : (
                    <div style={{ fontSize: 16 }}>
                        {selected.length > 0 ? selected[0].label : ""}
                    </div>
                )}
            </div>
        )
    };
    onAddressChange = (e) => {
        let addr = e.target.value
        if (addr === "") {
            this.props.changeMainProperty(false, "lookupsuccessful")
        }
        return this.props.changeBorrowerInfo(
            e,
            "borrower",
            "presentaddressstreet"
        )
    };
    onStreetAddressCompletion = (address, who, isMaillingAddress) => {
        let num = com.getSubaddress(address, "street_number", "long_name")

        let city = com.getSubaddress(address, "locality", "long_name")
        let state = com.getSubaddress(
            address,
            "administrative_area_level_1",
            "short_name"
        )
        let zip = com.getSubaddress(address, "postal_code", "long_name")

        let county = com.getSubaddress(
            address,
            "administrative_area_level_2",
            "long_name"
        )
        let longstate = com.getSubaddress(
            address,
            "administrative_area_level_1",
            "long_name"
        )

        let prefix = "present"
        if (isMaillingAddress === true) {
            prefix = "mailing"
        }

        this.props.changePhoneInfo(city, who, prefix + "addresscity")
        this.props.changePhoneInfo(county, who, prefix + "addresscounty")
        this.props.changePhoneInfo(com.capitalize(com.convertAbbStateToFull(state)), who, prefix + "addressstate")
        this.props.changePhoneInfo(zip, who, prefix + "addresszip")
        let sfx = ""
        let short = com.getSubaddress(address, "route", "short_name")

        let stradd = num + " " + short
        this.props.changeBorrowerInfo(
            { target: { value: stradd } },
            who,
            prefix + "addressstreet"
        )

    };

    onPrevAddressCompletion = (address, who) => {
        let num = com.getSubaddress(address, "street_number", "long_name");
        let city = com.getSubaddress(address, "locality", "long_name");
        let state = com.getSubaddress(
          address,
          "administrative_area_level_1",
          "short_name"
        );
        let zip = com.getSubaddress(address, "postal_code", "long_name");

        let county = com.getSubaddress(
          address,
          "administrative_area_level_2",
          "long_name"
        );
        let longstate = com.getSubaddress(
          address,
          "administrative_area_level_1",
          "long_name"
        );

        this.props.updatePreviousAddress({target: {value : city}}, who, "city", 0)
        this.props.updatePreviousAddress({target: {value : county}}, who, "county", 0)
        this.props.updatePreviousAddress({target: {value : com.capitalize(com.convertAbbStateToFull(state))}}, who, "state", 0)
        this.props.updatePreviousAddress({target: {value : zip}}, who, "zip", 0)
        let short = com.getSubaddress(address, "route", "short_name");
        let stradd = num + " " + short;
        this.props.updatePreviousAddress({target: {value : stradd}}, who, "street", 0)

      }

    getTotalIncome = (who) => {
        let emp = this.props.application[who].occupation
        let i1 = parseFloat(emp.income.base === "" ? 0 : emp.income.base)
        let i2 = parseFloat(emp.income.bonuses === "" ? 0 : emp.income.bonuses)
        let i3 = parseFloat(emp.income.commissions === "" ? 0 : emp.income.commissions)
        let i4 = parseFloat(emp.income.overtime === "" ? 0 : emp.income.overtime)
        let i5 = parseFloat(emp.income.military === "" ? 0 : emp.income.military)
        let i6 = parseFloat(emp.income.other === "" ? 0 : emp.income.other)
        return i1 + i2 + i3 + i4 + i5 + i6
    }
    formatSSN = (value) => {
        const cleanedValue = value.replace(/\D/g, "")
        const firstPart = cleanedValue.slice(0, 3)
        const secondPart = cleanedValue.slice(3, 5)
        const thirdPart = cleanedValue.slice(5, 9)
        let formattedValue = ""
        if (firstPart) {
            formattedValue += firstPart
        }
        if (secondPart) {
            formattedValue += `-${secondPart}`
        }
        if (thirdPart) {
            formattedValue += `-${thirdPart}`
        }
        return formattedValue
    }
    renderOwnedProperty = (i, isSubjectProperty,isExtra, currentView) => {
        let isPurchase = this.props.application.property.purpose === "purchase"
        const property = isSubjectProperty ? this.props.application.property : this.props.application[currentView].ownedproperties[i]
        this.section1aDom('3a. Property You Own', property, ['address', 'state', "county", 'zipcode', "presentaddressstreet", 'insurancemaintenancetaxes'])
        const changeAttribute = (val, i, key) => {
            if (isSubjectProperty) {
                this.props.changeMainPropertyAttribute(val, key)
            } else {
                if (currentView === "borrower") {
                    this.props.changeBorrowerOwnedProperty(val, i, key)
                }
                if (currentView === "coborrower") {
                    this.props.changeCoborrowerOwnedProperty(val, i, key)
                }
            }
        }

        return (
            <>
                {isExtra && <div className="form1003Title d-flex justify-content-between">
                    <div>Extra Property {isPurchase ? (i - 2) : (i - 1)}</div>
                    <div className="text-right">
                        <MinusSquareOutlined
                            onClick={() => {
                                if (currentView === "borrower") {
                                    this.props.removeBorrowerOwnedProperty(i)
                                }
                                if (currentView === "coborrower") {
                                    this.props.removeCoborrowerOwnedProperty(i)
                                }
                            }}
                            style={{ color: "#325CEB", fontSize: 16, cursor: "pointer" }}
                        />
                    </div>
                </div>}
                <div className={isExtra ? "p-4" : ""}>
                    <Row className="">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id={isSubjectProperty ? "SubjectPropertyAddress" + i : "OwnedPropertyAddress" + i}
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                border={true}
                                style={property.address === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                                defaultValue={property.address}
                                onChange={(e) => changeAttribute(e.target.value, i, "address")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your street address."
                                onCompletion={e => {
                                    let address = e
                                    let state = com.getSubaddress(
                                        address,
                                        "administrative_area_level_1",
                                        "short_name"
                                    )
                                    let zip = com.getSubaddress(address, "postal_code", "long_name")
                                    let city = com.getSubaddress(address, "locality", "long_name")
                                    let county = com.getSubaddress(
                                        address,
                                        "administrative_area_level_2",
                                        "long_name"
                                    )
                                    let num = com.getSubaddress(address, "street_number", "long_name")
                                    let short = com.getSubaddress(address, "route", "short_name")
                                    let stradd = num + " " + short + ", " + city + ", " + state + " " + zip
                                    changeAttribute(com.capitalize(com.convertAbbStateToFull(state)), i, "state")
                                    changeAttribute(county, i, "county")
                                    changeAttribute(city, i, "city")
                                    changeAttribute(zip, i, "zipcode")
                                    changeAttribute(stradd, i, "address")
                                }}
                                size="md"
                            /> : <FormPreview title="Address" content={property.address} />}
                        </Col>

                        <Col sm={4}>
                            {this.inputField(
                                "Unit",
                                isSubjectProperty ? property.units : property.unit ,
                                (e) => changeAttribute(e.target.value, i, isSubjectProperty?  "units" : "unit"),
                                null,
                                true
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4} className="mb-4">
                            {this.dropdownField(
                                "State",
                                property.state,
                                this.getStateOptions(),
                                (e) => changeAttribute(e.target.value, i, "state")
                            )}
                        </Col>
                        <Col sm={4} className="mb-4">
                            {this.dropdownField(
                                "County",
                                property.county,
                                this.getCountyOptions(property.state),
                                (e) => changeAttribute(e.target.value, i, "county")
                            )}
                        </Col>
                        <Col sm={4} className="mb-4">
                            {this.inputField(
                                "Zip",
                                property.zipcode,
                                (e) => changeAttribute(e.target.value, i, "zipcode"),
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputFieldWithPrefix(
                                "Property value",
                                isSubjectProperty ? property.appraisal : property.marketvalue,
                                (e) =>
                                    changeAttribute(e.target.value, i, isSubjectProperty ? "appraisal" : "marketvalue"),
                                "$"
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Status",
                                property.status,
                                [
                                    { value: "sold", label: "Sold" },
                                    { value: "pending", label: "Pending Sale" },
                                    { value: "retained", label: "Retained" },
                                ],
                                (e) => changeAttribute(e.target.value, i, "status"),
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Intended occupancy",
                                property.occupancy,
                                [
                                    { value: "principal", label: "Primary Residence" },
                                    { value: "secondhome", label: "Second Home" },
                                    { value: "investment", label: "Investment" },
                                    isSubjectProperty ? { value: "fhasecond", label: "FHA Secondary Residence" }
                                    :
                                    { value: "other", label: "Other" },
                                ],
                                (e) => {
                                    changeAttribute(e.target.value, i, "occupancy")
                                    changeAttribute(0, i, "grossrentalincome")
                                },
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Property type",
                                property.propertytype,
                                [
                                    { value: isSubjectProperty ? "singlefamilyattached" : "singlefamily", label: "Single family" },
                                    { value: isSubjectProperty ? "singlefamilydetached" : "townhouse", label: "Townhouse" },
                                    { value: isSubjectProperty ? "twotofourfamily" : "twotofour", label: "Multi family" },
                                    { value: "condominium", label: "Condo" },
                                    { value: "mobilehome", label: "Manufactured home" },
                                ],
                                (e) =>{
                                    changeAttribute(e.target.value, i, "propertytype")
                                    changeAttribute(0, i, "grossrentalincome")
                                },
                            )}
                        </Col>
                    </Row>
                    {/* <Row className="mb-4">
                        <Col>
                            {this.inputFieldWithPrefix(
                                "Monthly insurance, taxes, association dues, etc.",
                                property.insurancemaintenancetaxes,
                                (e) => changeAttribute(e.target.value, i, "insurancemaintenancetaxes"),
                                "$"
                            )}
                        </Col>
                    </Row> */}
                    {/* Property Insurance and Tax Breakdown */}
                    <div className="mb-4 insurance-and-tax-breakdown">
                                <Row>
                                    <Col>
                                        {/* Warning Alert - Show when legacy data is detected */}
                                        {(() => {
                                            const insurancemaintenancetaxes = parseFloat(property.insurancemaintenancetaxes) || 0
                                            const insurance = parseFloat(property.insurancemain) || 0
                                            const tax = parseFloat(property.insurancetax) || 0
                                            const hoa = parseFloat(property.insurancehoa) || 0
                                            const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                            const total = insurance + tax + hoa + pmi
                                            // 显示Alert的条件：
                                            // 1. insurancemaintenancetaxes有值（大于0）
                                            // 2. 但子字段的和不等于insurancemaintenancetaxes（说明是老数据）
                                            // 3. 如果子字段都为0且insurancemaintenancetaxes大于0，肯定是老数据
                                            const isLegacyData = insurancemaintenancetaxes > 0 && (
                                                Math.abs(insurancemaintenancetaxes - total) > 0.01 || 
                                                (total === 0 && insurancemaintenancetaxes > 0)
                                            )
                                            
                                            return isLegacyData && (
                                                <Alert
                                                    message={`Amounts are now entered in separate fields for Insurance, Tax, and HOA fees. Previous total ($${insurancemaintenancetaxes.toLocaleString()}) moved to Insurance. Please review and update each amount to match actual costs.`}
                                                    type="warning"
                                                    showIcon
                                                    closable={{
                                                        closeIcon: (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M16.472 6.33968C16.8625 5.94915 17.4957 5.94915 17.8862 6.33968C18.2767 6.7302 18.2767 7.36336 17.8862 7.75389L7.9867 17.6534C7.59618 18.0439 6.96301 18.0439 6.57249 17.6534C6.18196 17.2629 6.18196 16.6297 6.57249 16.2392L16.472 6.33968Z" fill="#6E6E70"/>
                                                                <path d="M17.886 16.2458C18.2766 16.6363 18.2766 17.2695 17.886 17.66C17.4955 18.0505 16.8624 18.0505 16.4718 17.66L6.57234 7.76049C6.18181 7.36997 6.18181 6.7368 6.57234 6.34628C6.96286 5.95575 7.59603 5.95575 7.98655 6.34628L17.886 16.2458Z" fill="#6E6E70"/>
                                                            </svg>
                                                        )
                                                    }}
                                                    icon={
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                                            <rect x="0.234009" width="18" height="18" rx="9" fill="#CB8600"/>
                                                            <rect x="8.23401" y="4" width="2" height="7" rx="1" fill="white"/>
                                                            <rect x="10.234" y="12" width="2" height="2" rx="1" transform="rotate(90 10.234 12)" fill="white"/>
                                                        </svg>
                                                    }
                                                    className="insurance-and-tax-breakdown-alert"
                                                    onClose={() => {
                                                        // 当用户关闭Alert时，自动迁移老数据
                                                        // 将insurancemaintenancetaxes的值分配给insurance字段
                                                        if (insurancemaintenancetaxes > 0 && total === 0) {
                                                            changeAttribute(insurancemaintenancetaxes, i, "insurancemain")
                                                        }
                                                    }}
                                                />
                                            )
                                        })()}
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        {this.inputFieldWithPrefix(
                                            "Monthly insurance, taxes, association dues, etc.",
                                            property.insurancemaintenancetaxes,
                                            (e) => changeAttribute(e.target.value, i, "insurancemaintenancetaxes"),
                                            "$"
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            Insurance (monthly)
                                        </label>
                                        {(() => {
                                            // 公共的计算逻辑 - 只在viewing模式时使用
                                            // 在viewing模式下，应该使用与editing模式相同的数据源
                                            // 直接使用传入的isSubjectProperty参数
                                            const currentProperty = property
                                            const propertyValue = parseFloat(isSubjectProperty ? currentProperty.appraisal : currentProperty.marketvalue) || 300000
                                            const insurance = parseFloat(currentProperty.insurancemain) || 0
                                            const percentage = calculatePercentage(insurance, propertyValue)
                                            
                                            return this.state.editMode ? (
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <InputNumber
                                                        prefix="$"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ flex: 1 }}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        value={property.insurancemain || 0}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            // 先更新保险金额（允许空值）
                                                            changeAttribute(value, i, "insurancemain")
                                                            
                                                            // 计算新的总和并立即同步更新insurancemaintenancetaxes
                                                            const insurance = parseFloat(value) || 0  // 使用新输入的值
                                                            const tax = parseFloat(property.insurancetax) || 0
                                                            const hoa = parseFloat(property.insurancehoa) || 0
                                                            const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                                            const newTotal = insurance + tax + hoa + pmi
                                                            
                                                            // 立即同步更新insurancemaintenancetaxes以避免Alert闪烁
                                                            if (isSubjectProperty) {
                                                                // 对于subject property，更新property对象
                                                                this.props.changeMainProperty(newTotal, "insurancemaintenancetaxes")
                                                            } else {
                                                                // 对于owned properties，更新ownedproperties数组
                                                                changeAttribute(newTotal, i, "insurancemaintenancetaxes")
                                                            }
                                                        }}
                                                    />
                                                    <InputNumber
                                                        suffix="%"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ width: '74px' }}
                                                        min={0}
                                                        max={100}
                                                        step={0.01}
                                                        placeholder="%"
                                                        value={(() => {
                                                            // 在editing模式下，直接使用Property value输入框显示的值
                                                            const propertyValue = parseFloat(isSubjectProperty ? property.appraisal : property.marketvalue) || 300000
                                                            const insurance = parseFloat(property.insurancemain) || 0
                                                            return propertyValue > 0 ? Math.round((insurance / propertyValue) * 100 * 100) / 100 : 0
                                                        })()}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            if (value !== null && value !== undefined) {
                                                                // 在editing模式下，直接使用Property value输入框显示的值
                                                                const propertyValue = parseFloat(isSubjectProperty ? property.appraisal : property.marketvalue) || 300000
                                                                const amount = propertyValue > 0 ? (value / 100) * propertyValue : 0
                                                                
                                                                // 先更新保险金额
                                                                changeAttribute(Math.round(amount), i, "insurancemain")
                                                                
                                                                // 计算新的总和并立即同步更新insurancemaintenancetaxes
                                                                const insurance = parseFloat(Math.round(amount)) || 0  // 使用新计算的值
                                                                const tax = parseFloat(property.insurancetax) || 0
                                                                const hoa = parseFloat(property.insurancehoa) || 0
                                                                const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                                                const newTotal = insurance + tax + hoa + pmi
                                                                
                                                                // 立即同步更新insurancemaintenancetaxes以避免Alert闪烁
                                                                if (isSubjectProperty) {
                                                                    // 对于subject property，更新property对象
                                                                    this.props.changeMainProperty(newTotal, "insurancemaintenancetaxes")
                                                                } else {
                                                                    // 对于owned properties，更新ownedproperties数组
                                                                    changeAttribute(newTotal, i, "insurancemaintenancetaxes")
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <ViewModeDisplay
                                                    amount={insurance}
                                                    percentage={percentage}
                                                />
                                            )
                                        })()}
                                    </Col>
                                    
                                    <Col sm={4} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            Tax (monthly)
                                        </label>
                                        {(() => {
                                            // 公共的计算逻辑 - 只在viewing模式时使用
                                            // 在viewing模式下，应该使用与editing模式相同的数据源
                                            // 直接使用传入的isSubjectProperty参数
                                            const currentProperty = property
                                            const propertyValue = parseFloat(isSubjectProperty ? currentProperty.appraisal : currentProperty.marketvalue) || 300000
                                            const tax = parseFloat(currentProperty.insurancetax) || 0
                                            const percentage = calculatePercentage(tax, propertyValue)
                                            
                                            return this.state.editMode ? (
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <InputNumber
                                                        prefix="$"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ flex: 1 }}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        value={property.insurancetax || 0}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            // 先更新税费（允许空值）
                                                            changeAttribute(value, i, "insurancetax")
                                                            
                                                            // 计算新的总和并立即同步更新insurancemaintenancetaxes
                                                            const insurance = parseFloat(property.insurancemain) || 0
                                                            const tax = parseFloat(value) || 0  // 使用新输入的值
                                                            const hoa = parseFloat(property.insurancehoa) || 0
                                                            const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                                            const newTotal = insurance + tax + hoa + pmi
                                                            
                                                            // 立即同步更新insurancemaintenancetaxes以避免Alert闪烁
                                                            if (isSubjectProperty) {
                                                                // 对于subject property，更新property对象
                                                                this.props.changeMainProperty(newTotal, "insurancemaintenancetaxes")
                                                            } else {
                                                                // 对于owned properties，更新ownedproperties数组
                                                                changeAttribute(newTotal, i, "insurancemaintenancetaxes")
                                                            }
                                                        }}
                                                    />
                                                    <InputNumber
                                                        suffix="%"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ width: '74px' }}
                                                        min={0}
                                                        max={100}
                                                        step={0.01}
                                                        placeholder="%"
                                                        value={(() => {
                                                            // 在editing模式下，直接使用Property value输入框显示的值
                                                            const propertyValue = parseFloat(isSubjectProperty ? property.appraisal : property.marketvalue) || 300000
                                                            const tax = parseFloat(property.insurancetax) || 0
                                                            return propertyValue > 0 ? Math.round((tax / propertyValue) * 100 * 100) / 100 : 0
                                                        })()}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            if (value !== null && value !== undefined) {
                                                                // 在editing模式下，直接使用Property value输入框显示的值
                                                                const propertyValue = parseFloat(isSubjectProperty ? property.appraisal : property.marketvalue) || 300000
                                                                const amount = propertyValue > 0 ? (value / 100) * propertyValue : 0
                                                                
                                                                // 先更新税费
                                                                changeAttribute(Math.round(amount), i, "insurancetax")
                                                                
                                                                // 计算新的总和并立即同步更新insurancemaintenancetaxes
                                                                const insurance = parseFloat(property.insurancemain) || 0
                                                                const tax = parseFloat(Math.round(amount)) || 0  // 使用新计算的值
                                                                const hoa = parseFloat(property.insurancehoa) || 0
                                                                const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                                                const newTotal = insurance + tax + hoa + pmi
                                                                
                                                                // 立即同步更新insurancemaintenancetaxes以避免Alert闪烁
                                                                if (isSubjectProperty) {
                                                                    // 对于subject property，更新property对象
                                                                    this.props.changeMainProperty(newTotal, "insurancemaintenancetaxes")
                                                                } else {
                                                                    // 对于owned properties，更新ownedproperties数组
                                                                    changeAttribute(newTotal, i, "insurancemaintenancetaxes")
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <ViewModeDisplay
                                                    amount={tax}
                                                    percentage={percentage}
                                                />
                                            )
                                        })()}
                                    </Col>
                                    <Col sm={4} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            HOA fee (monthly)
                                        </label>
                                        {(() => {
                                            // 公共的计算逻辑 - 只在viewing模式时使用
                                            // 在viewing模式下，应该使用与editing模式相同的数据源
                                            const currentProperty = property
                                            const hoa = parseFloat(currentProperty.insurancehoa) || 0
                                            
                                            return this.state.editMode ? (
                                                <InputNumber
                                                    prefix="$"
                                                    className='estimated-monthly-payment-input'
                                                    style={{ width: '100%' }}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    value={property.insurancehoa || 0}
                                                    controls={false}
                                                    onChange={(value) => {
                                                        // 先更新HOA费用（允许空值）
                                                        changeAttribute(value, i, "insurancehoa")
                                                        
                                                        // 计算新的总和并立即同步更新insurancemaintenancetaxes
                                                        const insurance = parseFloat(property.insurancemain) || 0
                                                        const tax = parseFloat(property.insurancetax) || 0
                                                        const hoa = parseFloat(value) || 0  // 使用新输入的值
                                                        const pmi = isSubjectProperty ? (parseFloat(property.insurancepmi) || 0) : 0
                                                        const newTotal = insurance + tax + hoa + pmi
                                                        
                                                        // 立即同步更新insurancemaintenancetaxes以避免Alert闪烁
                                                        if (isSubjectProperty) {
                                                            // 对于subject property，更新property对象
                                                            this.props.changeMainProperty(newTotal, "insurancemaintenancetaxes")
                                                        } else {
                                                            // 对于owned properties，更新ownedproperties数组
                                                            changeAttribute(newTotal, i, "insurancemaintenancetaxes")
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <ViewModeDisplayAmount
                                                    amount={hoa}
                                                />
                                            )
                                        })()}
                                    </Col>
                                </Row>
                            </div>
                    
                    {(
                        property.occupancy === "investment" ||
                        property.propertytype === "twotofour"
                    ) && <Row className="mb-4">
                            <Col md={6}>
                                {this.inputFieldWithPrefix(
                                    "Expected monthly rental income",
                                    property.grossrentalincome,
                                    (e) =>
                                        changeAttribute(
                                            e.target.value,
                                            i,
                                            "grossrentalincome"
                                        ),
                                    "$",
                                    undefined,
                                    true
                                )}
                            </Col>
                        </Row>}
                    <Row className="mb-4">
                        <OwnedPropertyLoansTable i={i} isSubjectProperty={isSubjectProperty} currentView={this.state.currentView} editMode={this.state.editMode} />
                    </Row>
                </div>
            </>
        )
    }
    sectionS1 = () => {
        return (
            <div id="s1" className="p-4">
                <div className="fontWeight500" style={{ fontSize: 20 }}>
                    Section 1: Borrower Information
                </div>
                <div>
                    This section asks about your personal information and your income from
                    employment and other sources, such as retirement, that you want
                    considered to qualify for this loan.
                </div>
            </div>
        )
    };
    section2aDom = (data, list) => {
        const link = document.getElementById('leted')


        for (let i = 0; i < list.length; i++) {

            if (data[list[i]] === '' || data[list[i]] === null) {
                if (link === null) return

                link.style.display = 'inline'

                break
            } else {
                if (link === null) return
                link.style.display = 'none'
            }
        }
    }
    section1aDom = (title, data, list) => {
        const link = document.getElementsByClassName('ant-anchor-link-title')
        const flag = false

        for (let index = 0; index < link.length; index++) {

            if (link[index].title === title) {

                for (let i = 0; i < list.length; i++) {

                    if (list[i] === "homephone" || list[i] === "mobilephone" || list[i] === "workphone") {
                        if ((data["homephone"] !== null && data["homephone"] !== '') ||
                            (data["mobilephone"] !== null && data["mobilephone"] !== '') ||
                            (data["workphone"] !== null && data["workphone"] !== '')) {
                            link[index].style.color = '#000'
                            continue
                        } else {
                            link[index].style.color = '#faad14'
                            break
                        }
                    }

                    if (Array.isArray(list[i])) {
                        if (data[list[i][0]][list[i][1]] === '' || data[list[i][0]][list[i][1]] === null) {
                            link[index].style.color = '#faad14'
                            break
                        } else {
                            link[index].style.color = '#000'
                        }
                    } else {
                        if (data[list[i]] === '' || data[list[i]] === null) {
                            link[index].style.color = '#faad14'
                            break
                        } else {
                            link[index].style.color = '#000'
                        }
                    }
                }
            }
        }
    }

    /**
     * @name onCurrentAddressChange 当前地址年份变更
     * @description 超过1年，清空 "以前居住信息"
     * @see https://zeitro.atlassian.net/jira/software/c/projects/BOR/issues/BOR-3029
     */
    onCurrentAddressChange = (currentView) => {
        this.props.updatePreviousAddress({target:{value: ""}}, currentView, "street", 0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"state",0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"city",0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"zip",0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"years",0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"months",0);
        this.props.updatePreviousAddress({target:{value: st.O_Own}},currentView,"ownership",0);
        this.props.updatePreviousAddress({target:{value: ""}},currentView,"rent",0);
    }

    // showSection1aDom = ( data, list) => {
    //   let  flog=false
    //    for (let i = 0; i < list.length; i++) {

    //     if (data[list[i]] === '' || data[list[i]] === null) {
    //       // flog=false
    //       break
    //     } else {
    //       // flog=true
    //     }
    //     return flog
    // }
    section1a = (currentView) => {
        // mailingaddressstate
        // samemailingaddress
        let onPrevAddressChange = (e) => {
            com.touch();
            return this.props.updatePreviousAddress(e, currentView, "street", 0);
        }

        let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
        let who = currentView === "borrower" ? "borrower" : "coborrower"

        const roleList = ['presentaddressownership', "presentaddressmonths", 'presentaddressyears', "presentaddressstreet",  'email', 'homephone', "maritalstatus", 'hascoborrower', 'firstname', 'lastname', 'socialsecurity', 'dateofbirth']
        if (!b.samemailingaddress) roleList.push('mailingaddressstreet')
        this.section1aDom('1a. Personal Information', b, roleList)
        this.section2aDom(b, roleList)
        return (
            <div id="1a">
                <div className="form1003Title">1a. Personal Information    {this.props.mode !== 'document' && <span className="leted" id="leted">INCOMPLETE</span>}</div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col sm={4}>
                            {this.inputField(
                                "First name",
                                b.firstname,
                                (event) => this.props.changeBorrowerInfo(event, currentView, "firstname")
                            )}
                        </Col>
                        <Col sm={4}>
                            {this.inputField(
                                "Middle name",
                                b.middlename,
                                (event) => this.props.changeBorrowerInfo(event, currentView, "middlename"),
                                null,
                                true
                            )}
                        </Col>
                        <Col sm={4}>
                            {this.inputField(
                                "Last name",
                                b.lastname,
                                (event) => this.props.changeBorrowerInfo(event, currentView, "lastname")
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4} className="mb-4">
                            {this.dropdownField(
                                "Suffix",
                                b.suffix,
                                [
                                    { value: "", label: "-- No Suffix --" },
                                    { value: "Jr.", label: "Jr." },
                                    { value: "Sr.", label: "Sr." },
                                    { value: "I", label: "I" },
                                    { value: "II", label: "II" },
                                    { value: "III", label: "III" },
                                    { value: "IV", label: "IV" },
                                    { value: "Ph.D.", label: "Ph.D." },
                                    { value: "M.D.", label: "M.D." },
                                    { value: "Esq.", label: "Esq." },
                                    { value: "J.D.", label: "J.D." },
                                    { value: "CPA", label: "CPA" },
                                    { value: "DDS", label: "DDS" },
                                    { value: "KBE", label: "KBE" },
                                    { value: "OBE", label: "OBE" },
                                    { value: "MBE", label: "MBE" },
                                ],
                                (event) => this.props.changeBorrowerInfo(event, currentView, "suffix"),
                                true
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-3">
                            {this.inputField(
                                "Social security number",
                                this.formatSSN(b.socialsecurity),
                                (e) => {
                                    const formattedValue = this.formatSSN(e.target.value)
                                    this.props.changeBorrowerInfo(
                                        { target: { value: formattedValue } },
                                        currentView,
                                        "socialsecurity"
                                    )
                                }
                            )}
                        </Col>
                        <Col sm={6} className="mb-3">
                            {this.dateField(
                                "Date of birth",
                                b.dateofbirth,
                                (date, dateString) =>
                                    this.props.changeBorrowerInfo(
                                        { target: { value: dateString } },
                                        currentView,
                                        "dateofbirth"
                                    )
                            )}
                        </Col>
                    </Row>
                    <Row className="">
                        <Col sm={6}>
                            {this.dropdownField(
                                "Citizenship",
                                b.citizenship === null ? "" : b.citizenship,
                                [
                                    { value: "", label: "..." },
                                    { value: "citizen", label: "U.S. Citizen" },
                                    { value: "permanent", label: "Permanent Resident Alien" },
                                    { value: "alien", label: "Non-Permanent Resident Alien" },
                                ],
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "citizenship"
                                    ),
                                // true,
                            )}
                        </Col>
                        <Col className="pr-0"></Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col>
                            {this.selectionField(
                                "Type of credit",
                                this.props.application.hascoborrower,
                                [
                                    {
                                        value: "alone",
                                        label: "I am applying for individual credit",
                                    },
                                    {
                                        value: "withcoborrower",
                                        label: "I am applying for joint credit",
                                    },
                                ],
                                (e) => {this.props.updateCoborrower(e);if (e === 'alone') {this.setState({ currentView: 'borrower' })}}
                            )}
                        </Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col>
                            {this.selectionField(
                                "Marital status",
                                b.maritalstatus,
                                [
                                    { value: "married", label: "Married" },
                                    { value: "separated", label: "Separated" },
                                    { value: "unmarried", label: "Unmarried" },
                                ],
                                (e) => this.props.changeBorrowerInfoByValue( e, currentView, "maritalstatus")
                            )}
                        </Col>
                    </Row>
                    {
                        b.maritalstatus === "unmarried" && <>
                            <Row className='mb-4'>
                                <Col>
                                    {this.yesNoField(
                                        "If you select unmarried, is there a person who is not your legal spouse but who currently has real property rights similar to those of a legal spouse?",
                                        b.hasunmarriedrelationship,
                                        (e) => {
                                            this.props.changeBorrowerInfoByValue( e, currentView, "hasunmarriedrelationship")
                                        }
                                    )}
                                </Col>
                            </Row>
                            {
                                b.hasunmarriedrelationship === "yes" && <Row className='mb-4'>
                                    <Col>
                                        {this.selectionField(
                                            "If you select yes, please indicate the type of relationship and the state in which it was formed",
                                            b.unmarriedrelationship,
                                            [
                                                { value: "civilunion", label: "Civil union" },
                                                { value: "domesticpartnership", label: "Domestic partnership" },
                                                { value: "reciprocalrelationship", label: "Registered reciprocal beneficiary relationship" },
                                                { value: "other", label: "Other" },
                                            ],
                                            (e) => this.props.changeBorrowerInfoByValue( e, currentView, "unmarriedrelationship"),
                                            false,
                                            true
            
                                        )}
                                    </Col>
                                </Row>
                            }
                            {
                                b.unmarriedrelationship === "other" && <Row className='mb-4'>
                                    <Col>
                                        {this.inputField(
                                            "If you select other, please explain the type of relationship",
                                            b.otherunmarriedrelationship,
                                            (e) => this.props.changeBorrowerInfo( e, currentView, "otherunmarriedrelationship")
                                        )}
                                    </Col>
                                </Row>
                            }
                            {
                                b.hasunmarriedrelationship === "yes" && <Row className='mb-4'>
                                    <Col>
                                        {this.inputField(
                                            "State (abbreviation) in which the relationship was formed",
                                            b.stateofunmarriedrelationship,
                                            (e) => this.props.changeBorrowerInfo( e, currentView, "stateofunmarriedrelationship")
                                        )}
                                    </Col>
                                </Row>
                            }   
                        </>
                    }

                    <Row className="mb-4">
                        <Col sm={6} md={12}>
                            {this.inputFieldWithPrefix(
                                "Dependents (not listed by another borrower)",
                                b.numberofdependents,
                                (e) => {
                                        if(e.target.value >= 20) e.target.value = 20;
                                        this.onDependentsQuantityChange(e.target.value, currentView);
                                        this.props.changeBorrowerInfo(
                                        e,
                                        currentView,
                                        "numberofdependents"
                                    )
                                    },
                                "Number"
                            )}
                        </Col>
                    </Row>
                    {b.numberofdependents > 0 && <Row>
                        {this.getAgesFields(b.numberofdependents, currentView === "coborrower" ? this.state.codependentages : this.state.bodependentages, currentView, "dependentsages")}
                    </Row>}
                    {/* <Row>
                        <Col sm={6}>
                            {this.inputFieldWithPrefix(
                                null,
                                b.dependentsages,
                                (e) =>
                                    this.props.changeBorrowerInfo(
                                        e,
                                        currentView,
                                        "dependentsages"
                                    ),
                                "Ages",
                                `Divided ages by ",". For example, "12, 20, 39"`,
                            )}
                        </Col>
                    </Row> */}
                    <hr className="form1003Divider"></hr>
                    <Row>
                        <Col sm={6}>
                            {this.inputFieldWithPrefix(
                                "Contact",
                                b.email,
                                (e) => this.props.changeBorrowerInfo(e, currentView, "email"),
                                "Email"
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col sm={4}>
                            {this.inputFieldWithPrefix(
                                null,
                                com.fixPhoneInput(b.homephone),
                                (e) => {
                                    const phone = com.fixPhoneInput(e.target.value)
                                    this.props.changeBorrowerInfo({ target: { value: phone } }, who, "homephone")
                                },
                                "Home phone"
                            )}
                        </Col>
                        <Col sm={4}>
                            {this.inputFieldWithPrefix(
                                null,
                                com.fixPhoneInput(b.mobilephone),
                                (e) => {
                                    const phone = com.fixPhoneInput(e.target.value)
                                    this.props.changeBorrowerInfo({ target: { value: phone } }, who, "mobilephone")
                                },
                                "Mobile phone"
                            )}
                        </Col>
                        <Col sm={4}>
                            {this.inputFieldWithPrefix(
                                null,
                                com.fixPhoneInput(b.workphone),
                                (e) => {
                                    const phone = com.fixPhoneInput(e.target.value)
                                    this.props.changeBorrowerInfo({ target: { value: phone } }, who, "workphone")
                                },
                                "Work phone"
                            )}
                        </Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-1">
                        <Col sm={9}>
                            {this.state.editMode ? <AddressAutocomplete
                                id="Address"
                                border={true}
                                style={b.presentaddressstreet === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                                label={<div className="fontWeight500">Current residential address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={
                                    b.presentaddressstreet
                                }
                                onChange={(e) => this.props.changeBorrowerInfo(e, currentView, "presentaddressstreet")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your street address."
                                onCompletion={e => this.onStreetAddressCompletion(e, currentView)}
                                size="md"
                            /> : <FormPreview title="Address" content={b.presentaddressstreet} />}
                        </Col>
                        <Col sm={3}>
                            {this.inputField(
                                "Unit",
                                b.presentaddressunit,
                                (event) => this.props.changeBorrowerInfo(event, currentView, "presentaddressunit"),
                                null,
                                true
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "State",
                                b.presentaddressstate,
                                this.getStateOptions(),
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "presentaddressstate"
                                    ),
                                // true
                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "County",
                                b.presentaddresscounty,
                                this.getCountyOptions(
                                    b.presentaddressstate
                                ),
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "presentaddresscounty"
                                    )
                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "City",
                                b.presentaddresscity,
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "presentaddresscity"
                                    ),
                                null,
                                // true
                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "Zip",
                                b.presentaddresszip,
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "presentaddresszip"
                                    ),
                                null,
                                // true
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.inputNumberFields(
                                "How long have you been at your current address?",
                                [
                                    b.presentaddressyears,
                                    b.presentaddressmonths,
                                ],
                                [
                                    (event) => {
                                        console.log("check ! evet",event)
                                        if (event !== "" && parseInt(event) < 2 && b.previousaddresses.length === 0) {
                                          this.props.addPreviousAddress({target:{value: ""}},currentView)
                                        }
                                        event > 1 && this.onCurrentAddressChange(currentView);
                                        this.props.changeBorrowerInfoByNumberValue(
                                            event,
                                            currentView,
                                            "presentaddressyears"
                                        )
                                    },
                                    (event) => {
                                        this.props.changeBorrowerInfoByNumberValue(
                                            event,
                                            currentView,
                                            "presentaddressmonths"
                                        )
                                    }
                                ],
                                null,
                                ["Years", "Months"]
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.selectionField(
                                "Housing",
                                b.presentaddressownership,
                                [
                                    {
                                        value: st.O_Rentfree,
                                        label: "No primary housing expense",
                                    },
                                    {
                                        value: st.O_Own,
                                        label: "Own",
                                    },
                                    {
                                        value: st.O_Rent,
                                        label: "Rent",
                                    },
                                ],
                                (e) =>
                                    this.props.changeBorrowerInfoByValue(
                                        e,
                                        currentView,
                                        "presentaddressownership"
                                    )
                            )}
                        </Col>
                    </Row>
                    {/* b.presentaddressownership === st.O_Rent && */}
                    {b.presentaddressownership === st.O_Rent && <Row className="mb-4">
                        <Col md={6}>
                            {this.inputFieldWithPrefix(
                                "Monthly Rent",
                                b.expenses.currentrent,
                                (event) => {
                                    this.props.updateExpenses(
                                        event.target.value,
                                        currentView,
                                        "currentrent"
                                    )
                                },
                                "$"
                            )}
                        </Col>
                    </Row>}

                    {/*If current address less than 2 year, ask former address */}
                    { parseInt(b.presentaddressyears) <2 &&
                        <>
                        <hr className="form1003Divider"></hr>
                        <Row className="mb-1">
                            <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id="formerAddress"
                                border={true}
                                style={b.presentaddressstreet === '' ? { border: '1px solid #faad14' } : {}}
                                label={<div className="fontWeight500">Previous residential address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={
                                b.previousaddresses.length>0 ? b.previousaddresses[0].street:""
                                }
                                onChange={onPrevAddressChange}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your street address."
                                onCompletion={e => this.onPrevAddressCompletion(e, currentView)}
                                size="md"
                            /> : <FormPreview title="Address" content={b.presentaddressstreet} />}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "State",
                                b.previousaddresses.length>0?b.previousaddresses[0].state:"",
                                this.getStateOptions(),
                                (event) =>
                                this.props.updatePreviousAddress(
                                    event,
                                    currentView,
                                    "state",
                                    0
                                ),
                                true
                            )}
                            </Col>
                            {/* <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "County",
                                b.previousaddresses.length>0?b.previousaddresses[0].county:"",
                                this.getCountyOptions(
                                b.previousaddresses.length>0 ?b.previousaddresses[0].state: ""
                                ),
                                (event) =>
                                this.props.updatePreviousAddress(
                                    event,
                                    currentView,
                                    "county",
                                    0
                                )
                            )}
                            </Col> */}
                            <Col sm={3} className="mb-4">
                            {this.inputField(
                                "City",
                                b.previousaddresses.length>0?b.previousaddresses[0].city:"",
                                (event) =>
                                this.props.updatePreviousAddress(
                                    event,
                                    currentView,
                                    "city",
                                    0
                                ),
                                null,
                                true
                            )}
                            </Col>
                            <Col sm={3} className="mb-4">
                            {this.inputField(
                                "Zip",
                                b.previousaddresses.length>0?b.previousaddresses[0].zip:"",
                                (event) =>
                                this.props.updatePreviousAddress(
                                    event,
                                    currentView,
                                    "zip",
                                    0
                                ),
                                null,
                                true
                            )}
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col>
                            {this.inputNumberFields(
                                "How long have you been at your previous address?",
                                [
                                b.previousaddresses.length>0?b.previousaddresses[0].years:"",
                                b.previousaddresses.length>0?b.previousaddresses[0].months:"",
                                ],
                                [
                                (event) =>
                                    this.props.updatePreviousAddress(
                                    {target:{value: event}},
                                    currentView,
                                    "years",
                                    0
                                    ),
                                (event) =>
                                    this.props.updatePreviousAddress(
                                    {target:{value: event}},
                                    currentView,
                                    "months",
                                    0
                                    ),
                                ],
                                null,
                                ["Years", "Months"]
                            )}
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col>
                            {this.selectionField(
                                "Housing",
                                b.previousaddresses.length>0?b.previousaddresses[0].ownership:"",
                                [
                                {
                                    value: st.O_Rentfree,
                                    label: "No primary housing expense",
                                },
                                {
                                    value: st.O_Own,
                                    label: "Own",
                                },
                                {
                                    value: st.O_Rent,
                                    label: "Rent",
                                },
                                ],
                                (e) =>
                                this.props.updatePreviousAddress(
                                    {target:{value: e}},
                                    currentView,
                                    "ownership",
                                    0
                                )
                            )}
                            </Col>
                        </Row>
                        {b.previousaddresses.length>0 && b.previousaddresses[0].ownership === st.O_Rent && <Row className="mb-4">
                            <Col md={6}>
                                {this.inputFieldWithPrefix(
                                    "Monthly Rent",
                                    b.previousaddresses[0].rent,
                                    (e) => {
                                        this.props.updatePreviousAddress(
                                            {target:{value: e.target.value}},
                                            currentView,
                                            "rent",
                                            0
                                        )
                                    },
                                    "$"
                                )}
                            </Col>
                        </Row>}
                        </>
                    }
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={!b.samemailingaddress}
                                onChange={(e) => {
                                    this.props.changeBorrowerInfoByValue(
                                        !e.target.checked,
                                        currentView,
                                        "samemailingaddress"
                                    )
                                    if (!e.target.checked) {
                                        this.props.changeBorrowerInfoByValue(b.presentaddressstreet, currentView, "mailingaddressstreet")
                                        this.props.changeBorrowerInfoByValue(b.presentaddresscity, currentView, "mailingaddresscity")
                                        this.props.changeBorrowerInfoByValue(b.presentaddresscounty, currentView, "mailingaddresscounty")
                                        this.props.changeBorrowerInfoByValue(b.presentaddressstate, currentView, "mailingaddressstate")
                                        this.props.changeBorrowerInfoByValue(b.presentaddresszip, currentView, "mailingaddresszip")
                                    }
                                }
                                }
                                className="fontWeight500"
                            >
                                Mailing address is different from current address
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {!b.samemailingaddress && <Row className="mb-2">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id="mailingAddress"
                                border={true}
                                style={b.mailingaddressstreet === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                                label={<div className="fontWeight500">Mailing Address</div>}
                                required={true}
                                name="mailingaddessline"
                                defaultValue={
                                    b.mailingaddressstreet
                                }
                                onChange={(e) => this.props.changeBorrowerInfo(e, currentView, "mailingaddressstreet")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your mailling address."
                                onCompletion={e => this.onStreetAddressCompletion(e, currentView, true)}
                                size="md"
                            /> : <FormPreview title="Address" content={b.mailingaddressstreet} />}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "Unit",
                                b.mailingaddressunit,
                                (e) => {
                                    this.props.changeBorrowerInfo(
                                        e,
                                        currentView,
                                        "mailingaddressunit"
                                    )
                                },
                                null,
                                true
                            )}
                        </Col>
                    </Row>}
                    {!b.samemailingaddress && <Row className="mb-4">
                        <Col>
                            {this.dropdownField(
                                "State",
                                b.mailingaddressstate,
                                this.getStateOptions(),
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "mailingaddressstate"
                                    )
                            )}
                        </Col>
                        <Col className="">
                            {this.dropdownField(
                                "County",
                                b.mailingaddresscounty,
                                this.getCountyOptions(
                                    b.mailingaddressstate
                                ),
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "mailingaddresscounty"
                                    )
                            )}
                        </Col>
                        <Col>
                            {this.inputField(
                                "City",
                                b.mailingaddresscity,
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "mailingaddresscity"
                                    ),
                                null,
                                // true
                            )}
                        </Col>
                        <Col>
                            {this.inputField(
                                "Zip",
                                b.mailingaddresszip,
                                (event) =>
                                    this.props.changeBorrowerInfo(
                                        event,
                                        currentView,
                                        "mailingaddresszip"
                                    ),
                                null,
                                // true
                            )}
                        </Col>
                    </Row>}

                </div>
            </div>
        )
    };
    section1b = (currentView) => {
        const emp = currentView === "borrower" ? this.props.application.borrower.occupation : this.props.application.coborrower.occupation
        let checkouts = ['employername', 'phone', 'employeraddress', 'positiontitle', 'from', 'yearsatlineofwork', 'monthsatlineofwork', ['income', 'base']]
        if (emp.selfemployed) {
            checkouts = ['employername', 'phone', 'employeraddress', 'positiontitle', 'from', 'yearsatlineofwork', 'monthsatlineofwork', 'percentownership', 'incomeorloss']
        }
        this.section1aDom('1b. Current Employment/Self-Employment and Income', emp, checkouts)
        const who = currentView === "borrower" ? "borrower" : "coborrower"

        const getWorkDuration = (emp) => {
            const years = get(emp, 'yearsatlineofwork')
            const months = get(emp, 'monthsatlineofwork')
            
            if (years !== undefined && years !== '' && years !== null) {
                return { years, months: months || '' }
            }
            if (months !== undefined && months !== '' && months !== null) {
                return { years: years || '', months }
            }

            const fromDate = get(emp, 'from')
            if (fromDate) {
                const now = dayjs()
                const start = dayjs(fromDate)
                const diffMonths = now.diff(start, 'month')
                return {
                    years: Math.floor(diffMonths / 12),
                    months: diffMonths % 12,
                }
            }

            return { years: years || '', months: months || '' }
        }

        return (
            <div id="1b">
                <div className="form1003Title">1b. Employment and Income
                    {
                       this.state.editMode && emp.employername && (this.props.application[currentView].occupation.selfemployed === false || (this.props.application[currentView].occupation.selfemployed === true && this.props.application[currentView].occupation.percentownership > 24)) && (
                            <span 

                                className="income-calculation-btn"
                                onClick={() => {
                                        // console.log('--------1b ', emp)
                                        this.setState({currentBusinessName: emp.employername, currentIncome: {type: '1b', index: 0, currentEmpData: emp}});
                                        this.props.application[currentView].occupation.selfemployed ? this.setState({BusinessIncomeCalModal: true}) : this.setState({IncomeCalModal: true})
                                    }
                                }
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_1650_3575)">
                                    <path d="M2.64435 1.3999V3.88879M1.3999 2.64435H3.88879M3.26657 10.111V12.5999M2.02212 11.3555H4.51101M7.62213 1.3999L9.04435 5.66657L12.5999 6.9999L9.04435 8.33324L7.62213 12.5999L6.1999 8.33324L2.64435 6.9999L6.1999 5.66657L7.62213 1.3999Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1650_3575">
                                    <rect width="14" height="14" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                Income calculation
                            </span>
                        )
                    }
                    {
                        (!emp.employername || (this.props.application[currentView].occupation.selfemployed === true && this.props.application[currentView].occupation.percentownership < 25)) && (
                            <span 
                                disabled={true}
                                className="income-calculation-btn-disabled"
                            >
                                Income calculation
                            </span>
                        )
                    }
                </div>
                <div className="p-4">
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputField(
                                "Employer or business name",
                                emp.employername,
                                (e) => this.props.changeOccupationInfo(e, currentView, "employername")
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.inputField("Phone", com.fixPhoneInput(emp.phone), (e) => {
                                    let phone = com.fixPhoneInput(e.target.value)
                                    this.props.changeOccupationInfo({target: {value: phone}}, who, "phone")
                                }
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id="CEmploymentAddress"
                                border={true}
                                style={emp.employeraddress === '' && this.props.mode !== 'document' ? {
                                    border: '1px solid #faad14',
                                    fontSize: "16px"
                                } : {fontSize: "16px"}}
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={
                                    emp.employeraddress
                                }
                                onChange={(e) => this.props.changeOccupationInfo(e, currentView, "employeraddress")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback=""
                                badfeedback="Please provide address."
                            /> : <FormPreview title="Address" content={emp.employeraddress} />
                            }
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col sm={6} className="mb-4">
                            {this.inputField("Position or title", emp.positiontitle, (e) =>
                                this.props.changeOccupationInfo(
                                    e,
                                    currentView,
                                    "positiontitle"
                                )
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dateField(
                                "Start date",
                                emp.from,
                                (date, dateString) => {
                                    this.props.changeOccupationInfoByValue(
                                        dateString,
                                        currentView,
                                        "from"
                                    )
                                }
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.inputNumberFields(
                                "How long in this line of work?",
                                [getWorkDuration(emp).years, getWorkDuration(emp).months],
                                [
                                    (event) =>
                                        this.props.changeOccupationInfoByValue(
                                            event,
                                            currentView,
                                            "yearsatlineofwork"
                                        ),
                                    (event) =>
                                        this.props.changeOccupationInfoByValue(
                                            event,
                                            currentView,
                                            "monthsatlineofwork"
                                        ),
                                ],
                                null,
                                ["Years", "Months"]
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.employedbyagent}
                                onChange={(e) => this.props.changeOccupationInfoByValue(e.target.checked, currentView, "employedbyagent")}
                                className="fontWeight500"
                            >
                                You are employed by a family member, property seller, real estate agent, or other party
                                to the transaction.
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.selfemployed}
                                onChange={(e) => {
                                    this.props.changeOccupationInfoByValue(e.target.checked, currentView, "selfemployed")
                                    e.target.checked && this.props.changeOccupationInfo3('less', currentView, "percentownership", this.props.application[who].occupation.percentownership)
                                }}
                                className="fontWeight500"
                            >
                                Check if you are the business owner or self-employed
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {emp.selfemployed && (
                        <div>
                        <Row>
                            
                            <Col sm={12} className="mb-4">
                                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                                    I have an ownership share of
                                </div>
                                
                                <Radio.Group
                                    style={{ width: '100%' }}
                                    disabled={!this.state.editMode} 
                                    onChange={(e) => this.props.changeOccupationInfo2(e, currentView, "percentownership", this.props.application[who].occupation.percentownership)}
                                    value={typeof emp.percentownership === 'string' && (emp.percentownership === 'less' || emp.percentownership === 'more') ? emp.percentownership : (parseFloat(emp.percentownership || 0) < 25 ? 'less' : 'more')}
                                >
                                    <div style={{ display: 'flex', gap: 10, width: '100%' }}>
                                        <div style={{ border: '1px solid #ececec', borderRadius: 4, padding: '0 10px', backgroundColor: '#fcfcfc', height: 44, display: 'flex', alignItems: 'center', justifyContent: 'left', flex: 1 }}>
                                            <Radio style={{color:'#333333'}} value={ 'less' }>less than 25%</Radio>
                                        </div>
                                        <div style={{ border: '1px solid #ececec', borderRadius: 4, padding: '0 10px', backgroundColor: '#fcfcfc', height: 44, display: 'flex', alignItems: 'center', justifyContent: 'left', flex: 1 }}>
                                            <Radio style={{color:'#333333'}} value={ 'more' }>25% or more</Radio>
                                        </div>
                                    </div>
                                </Radio.Group>
                                {/* {this.inputField(
                                    "I have an ownership share of",
                                    emp.percentownership,
                                    (e) => this.props.changeOccupationInfo(e, currentView, "percentownership")
                                )} */}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.state.editMode ? this.inputField(
                                    "Monthly Income (or Loss)",
                                    emp.incomeorloss,
                                    (event) => this.props.changeOccupationInfoByValue(event.target.value, currentView, "incomeorloss")
                                ) : <div>
                                    <p style={{ fontWeight:'bold' }}>Monthly Income (or Loss)</p>
                                    <p style={{ fontSize: 16 }}>{emp.incomeorloss}</p>
                                    </div>}
                            </Col>
                        </Row>
                        </div>
                    )}

                    {!emp.selfemployed &&
                        <>
                            <hr className="form1003Divider"></hr>
                            <Row>
                                <Col className="mb-4">
                                    {this.inputFields(
                                        "Gross monthly income",
                                        [emp.selfemployed ? (emp.incomeorlossperiod === "monthly" ? emp.incomeorloss : emp.incomeorloss / 12) : (emp.income.basemonthly === 'monthly' ? emp.income.base : emp.income.base / 12), emp.income.overtimemonthly === "monthly" ? emp.income.overtime : emp.income.overtime / 12],
                                        [
                                            (e) => this.updateIncomeMonthly(emp.income.basemonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "base"),
                                            (e) => this.updateIncomeMonthly(emp.income.overtimemonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "overtime"),
                                        ],
                                        ["Base   ", "Overtime  "],
                                        ["/ month", "/ month"],
                                        [false, true]
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-4">
                                    {this.inputFields(
                                        null,
                                        [emp.income.bonusesmonthly === "monthly" ? emp.income.bonuses : emp.income.bonuses / 12, emp.income.commissionsmonthly === "monthly" ? emp.income.commissions : emp.income.commissions / 12],
                                        [
                                            (e) => this.updateIncomeMonthly(emp.income.bonusesmonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "bonuses"),
                                            (e) => this.updateIncomeMonthly(emp.income.commissionsmonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "commissions"),
                                        ],
                                        ["Bonus", "Commission"],
                                        ["/ month", "/ month"],
                                        [true, true]
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-4">
                                    {this.inputFields(
                                        null,
                                        [emp.income.militarymonthly === "monthly" ? emp.income.military : emp.income.military / 12, emp.income.othermonthly === "monthly" ? emp.income.other : emp.income.other / 12],
                                        [
                                            (e) => this.updateIncomeMonthly(emp.income.militarymonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "military"),
                                            (e) => this.updateIncomeMonthly(emp.income.othermonthly === "monthly" ? e.target.value : e.target.value * 12, currentView, "other"),
                                        ],
                                        ["Military", "Other"],
                                        ["/ month", "/ month"],
                                        [true, true]
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>
                                    {this.inputFields(
                                        "Total income",
                                        [this.getTotalIncome(who)],
                                        [],
                                        ["$"],
                                        ["/ month"]
                                    )}
                                </Col>
                            </Row>
                        </>
                    }

                </div>
            </div>
        )
    };
    section1c = (currentView) => {
        const changeVal = (i, t, useValue) => {
            return (e) =>
                this.props.changeBorrowerOtherOccupationValue(
                    useValue ? e : e.target.value,
                    i,
                    currentView,
                    t
                )
        }
        const changeChecked1 = (e, i, t) => {
            this.props.changeBorrowerOtherOccupationValue(
                e.target.checked,
                i,
                currentView,
                t
            )
            this.props.changeBorrowerOtherOccupationValue(
                e.target.checked ? '24' : '',
                i,
                currentView,
                'percentownership'
            ) 
        }
        const changeChecked = (i, t) => {
            return (e) =>
                this.props.changeBorrowerOtherOccupationValue(
                    e.target.checked,
                    i,
                    currentView,
                    t
                )
        }

        const addIncome = () => {
            let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower

            if (b.otheroccupations === null) {
                this.props.clearBorrowerOtherOccupations(currentView)
            }
            this.props.addBorrowerOtherOccupation(currentView)
        }
        const displayAdditionalOccupation = () => {
            let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower

            if (
                b.otheroccupations === null ||
                b.otheroccupations.length === 0
            ) {
                return ""
            }
            let out = []
            for (
                let i = 0;
                i < b.otheroccupations.length;
                i++
            ) {
                out.push(additonalIncome(i))
            }
            return out
        }

        /**
         * @name onPositionStartate 工作开始日期
         * @description 更新工作开始日期
         * @see https://zeitro.atlassian.net/browse/BOR-2780
         */
        const onPositionStartate = (i, date, dateString) => {
            const now = dayjs();
            const totalMonths = now.diff(date, 'month')
            this.props.changeBorrowerOtherOccupationValue(
                dateString,
                i,
                currentView,
                "from",
            )
        }

        const additonalIncome = (i) => {
            const emp = currentView === "borrower" ? this.props.application.borrower.otheroccupations[i] : this.props.application.coborrower.otheroccupations[i]
            
            const newarray = emp.selfemployed ? ['employername', 'phone', 'employeraddress', 'positiontitle', 'from', 'yearsatlineofwork', 'monthsatlineofwork'] : ['employername', 'phone', 'employeraddress', 'positiontitle', 'from', 'yearsatlineofwork', 'monthsatlineofwork', ['income', 'base'], ['income', 'overtime'], ['income', 'bonuses'], ['income', 'commissions']]

            this.section1aDom('1c. Additional Employment/Self-Employment and Income', emp, newarray)

            const getTotalIncome = () => {
                const i1 = parseFloat(emp.income.base === "" ? 0 : emp.income.base)
                const i2 = parseFloat(emp.income.bonuses === "" ? 0 : emp.income.bonuses)
                const i3 = parseFloat(emp.income.commissions === "" ? 0 : emp.income.commissions)
                const i4 = parseFloat(emp.income.overtime === "" ? 0 : emp.income.overtime)
                const i5 = parseFloat(emp.income.military === "" ? 0 : emp.income.military)
                const i6 = parseFloat(emp.income.other === "" ? 0 : emp.income.other)
                return i1 + i2 + i3 + i4 + i5 + i6
            }

            const onOwnershipShareChange = (event, verb) => {
                const orgVal = emp.percentownership;
                let val = "";
                if (Number(orgVal) < 25 && event.target.value === "less") {
                    val = orgVal;
                } else if (Number(orgVal) > 24 && event.target.value === "more") {
                    val = orgVal;
                } else {
                    val = event.target.value === "less" ? "24" : "25";
                }
                this.props.changeBorrowerOtherOccupationValue(
                    val,
                    i,
                    currentView,
                    "percentownership",
                );
            }

            return (
                <div className="p-4 removable">
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{flex: 1, textAlign: 'right', marginRight: 20}}>
                        {
                        this.state.editMode && emp.employername && (emp.selfemployed === false || (emp.selfemployed === true && emp.percentownership > 24)) && (
                            <span 
                                className="income-calculation-btn"
                                onClick={() => {
                                    this.setState({currentBusinessName: emp.employername, currentIncome: {type: '1c', index: i, currentEmpData: emp}});
                                    emp.selfemployed ? this.setState({BusinessIncomeCalModal: true}) : this.setState({IncomeCalModal: true})}
                                }
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_1650_3575)">
                                    <path d="M2.64435 1.3999V3.88879M1.3999 2.64435H3.88879M3.26657 10.111V12.5999M2.02212 11.3555H4.51101M7.62213 1.3999L9.04435 5.66657L12.5999 6.9999L9.04435 8.33324L7.62213 12.5999L6.1999 8.33324L2.64435 6.9999L6.1999 5.66657L7.62213 1.3999Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1650_3575">
                                    <rect width="14" height="14" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                Income calculation
                            </span>
                        )
                    }
                    {
                        !emp.employername || (emp.selfemployed === true && emp.percentownership < 25) && (
                            <span 
                                disabled={true}
                                className="income-calculation-btn-disabled"
                            >
                                Income calculation
                            </span>
                        )
                    }
                        </div>
                        <div className="text-right" style={{display: 'flex', alignItems: 'center'}}>
                            {this.state.editMode ? <MinusSquareOutlined
                                onClick={
                                    () => {
                                        if (currentView === "borrower") {
                                            this.props.removeBorrowerOtherOccupation("borrower", i)
                                        }
                                        if (currentView === "coborrower") {
                                            this.props.removeBorrowerOtherOccupation("coborrower", i)
                                        }
                                    }
                                }
                                style={{ color: "#325CEB", fontSize: 16, cursor: "pointer" }}
                            /> : null}
                        </div>
                    </div>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputField("Employer or business name", emp.employername, changeVal(i, "employername"))}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.inputField(
                                "Phone",
                                com.fixPhoneInput(emp.phone),
                                (e) => {
                                    const phone = com.fixPhoneInput(e.target.value)
                                    this.props.changeBorrowerOtherOccupationValue(phone, i, currentView, "phone")
                                }
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id={`AdditionEmploymentAddress${i}`}
                                border={true}
                                style={emp.employeraddress === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14', fontSize:"16px" } : {fontSize:"16px"}}
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={emp.employeraddress}
                                onChange={(e) => this.props.changeBorrowerOtherOccupationValue(
                                    e.target.value,
                                    i,
                                    currentView,
                                    "employeraddress"
                                )}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback=""
                                badfeedback="Please provide address."
                            /> : <FormPreview title="Address" content={emp.employeraddress} />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputField(
                                "Position or title",
                                emp.positiontitle,
                                changeVal(i, "positiontitle")
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dateField(
                                "Start date",
                                emp.from,
                                (date, dateString) => onPositionStartate(i, date, dateString)
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.inputNumberFields(
                                "How long have you been in this line of work?",
                                [emp.yearsatlineofwork, emp.monthsatlineofwork],
                                [
                                    changeVal(i, "yearsatlineofwork", true),
                                    changeVal(i, "monthsatlineofwork", true),
                                ],
                                null,
                                ["Years", "Months"]
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.employedbyagent}
                                onChange={changeChecked(i, "employedbyagent")}
                                className="fontWeight500"
                            >
                                You are employed by a family member, property seller, real estate
                                agent, or other party to the transaction.
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.selfemployed}
                                onChange={(e) => {
                                    console.log(e.target.checked)

                                    changeChecked1(e, i, "selfemployed")

                                }}
                                className="fontWeight500"
                            >
                                Check if you are the business owner or self-employed
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {emp.selfemployed && (
                    <>
                        <Row>
                            <Col sm={12} className="mb-4">
                                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
                                    I have an ownership share of
                                </div>
                                
                                <Radio.Group // @
                                    style={{ width: '100%' }}
                                    disabled={!this.state.editMode} 
                                    onChange={e => onOwnershipShareChange(e)}
                                    // onChange={(e) => this.props.changeOccupationInfo2(e, currentView, "percentownership", emp.percentownership)}
                                    value={typeof emp.percentownership === 'string' && (emp.percentownership === 'less' || emp.percentownership === 'more') ? emp.percentownership : (parseFloat(emp.percentownership || 0) < 25 ? 'less' : 'more')}
                                >
                                    <div style={{ display: 'flex', gap: 10, width: '100%' }}>
                                        <div style={{ border: '1px solid #ececec', borderRadius: 4, padding: '0 10px', backgroundColor: '#fcfcfc', height: 44, display: 'flex', alignItems: 'center', justifyContent: 'left', flex: 1 }}>
                                            <Radio style={{color:'#333333'}} value={ 'less' }>less than 25%</Radio>
                                        </div>
                                        <div style={{ border: '1px solid #ececec', borderRadius: 4, padding: '0 10px', backgroundColor: '#fcfcfc', height: 44, display: 'flex', alignItems: 'center', justifyContent: 'left', flex: 1 }}>
                                            <Radio style={{color:'#333333'}} value={ 'more' }>25% or more</Radio>
                                        </div>
                                    </div>
                                </Radio.Group>
                            </Col>
                        </Row>



                        <Row>
                            {/* <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "I have an ownership share of",
                                    emp.percentownership,
                                    changeVal(i, "percentownership")
                                )}
                            </Col> */}
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Monthly Income (or Loss)",
                                    emp.incomeorloss,
                                    (e) => this.props.changeBorrowerOtherOccupationValue(
                                        e.target.value,
                                        i,
                                        currentView,
                                        "incomeorloss"
                                    ),
                                )}
                            </Col>
                        </Row>
                    </>
                    )}
                    {!emp.selfemployed && <>
                        <hr className="form1003Divider"></hr>
                        <Row className="mb-4">
                            <Col>
                                {this.inputFields(
                                    "Gross monthly income",
                                    [emp.income.base, emp.income.overtime],
                                    [
                                        (e) => this.props.changeBorrowerOtherOccupationIncome(e.target.value, i, currentView, "base"),
                                        (e) =>
                                            this.props.changeBorrowerOtherOccupationIncome(e.target.value, i, currentView, "overtime"),
                                    ],
                                    ["Base   ", "Overtime  "],
                                    ["/ month", "/ month"],
                                    [false, true]
                                )}
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col>
                                {this.inputFields(
                                    null,
                                    [emp.income.bonuses, emp.income.commissions],
                                    [
                                        (e) => this.props.changeBorrowerOtherOccupationIncome(e.target.value, i, currentView, "bonuses"),
                                        (e) =>
                                            this.props.changeBorrowerOtherOccupationIncome(
                                                e.target.value,
                                                i,
                                                currentView,
                                                "commissions"
                                            ),
                                    ],
                                    ["Bonus", "Commission"],
                                    ["/ month", "/ month"],
                                    [true, true]
                                )}
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col>
                                {this.inputFields(
                                    null,
                                    [emp.income.military, emp.income.other],
                                    [
                                        (e) => this.props.changeBorrowerOtherOccupationIncome(e.target.value, i, currentView, "military"),
                                        (e) =>
                                            this.props.changeBorrowerOtherOccupationIncome(
                                                e.target.value,
                                                i,
                                                currentView,
                                                "other"
                                            ),
                                    ],
                                    ["Military", "Other"],
                                    ["/ month", "/ month"],
                                    [true, true]
                                )}
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col>
                                {this.inputFields(
                                    "Total income",
                                    [getTotalIncome(i)],
                                    [],
                                    ["$"],
                                    ["/ month"]
                                )}
                            </Col>
                        </Row>
                    </>}
                </div>
            )
        }

        return (
            <div id="1c">
                <div className="form1003Title">
                    1c. Additional Employment/Self-Employment and Income
                </div>
                <div>{displayAdditionalOccupation()}</div>
                {this.state.editMode ? <div
                    style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: "#325CEB",
                        cursor: "pointer",
                    }}
                    onClick={() => addIncome()}
                >
                    <img
                        src="/images/bluePlusInCircleMark.png"
                        style={{ width: 20, height: 20 }}
                        className="ml-4 mr-2 my-3"
                    />
                    Add additional income
                </div> : <div style={{ height: 52 }} />}

            </div>
        )
    };

    section1d = (currentView) => {
        const changeVal = (i, t) => {
            return (e) => {
                const val = e.target.value
                this.props.changeBorrowerPreviousOccupationValue(val, i, currentView, t)
            }
        }

        const displayPreviousOccupation = () => {
            const b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
            if (b.previousoccupations === null || b.previousoccupations.length === 0) {
                return ""
            }

            const out = []
            for (let i = 0; i < b.previousoccupations.length; i++) {
                out.push(previousIncome(i))
            }

            return out
        }

        const changeChecked = (i, t) => {
            return (e) => this.props.changeBorrowerPreviousOccupationValue(e.target.checked, i, currentView, t)
        }

        const previousIncome = (i) => {
            const emp = currentView === "borrower" ? this.props.application.borrower.previousoccupations[i] : this.props.application.coborrower.previousoccupations[i]
            this.section1aDom('1d. Previous Employment/Self-Employment and Income', emp, ['employername', 'employeraddress', 'positiontitle', 'from', 'to', 'income'])

            return (
                <div className="p-4 removable">
                    {/* <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{flex: 1, textAlign: 'right', marginRight: 20, }}>
                        {
                        this.props.isBetaCustomer && (emp.selfemployed === false || (emp.selfemployed === true && emp.percentownership > 24)) && (
                            <span 
                                className="income-calculation-btn"
                                onClick={() => {
                                    this.setState({currentBusinessName: emp.employername, currentIncome: {type: '1d', index: i, currentEmpData: emp}});
                                    // 1d 模块目前仅支持个人收入计算，不支持企业收入计算
                                    // emp.selfemployed ? this.setState({BusinessIncomeCalModal: true}) : this.setState({IncomeCalModal: true})
                                    this.setState({IncomeCalModal: true})
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_1650_3575)">
                                    <path d="M2.64435 1.3999V3.88879M1.3999 2.64435H3.88879M3.26657 10.111V12.5999M2.02212 11.3555H4.51101M7.62213 1.3999L9.04435 5.66657L12.5999 6.9999L9.04435 8.33324L7.62213 12.5999L6.1999 8.33324L2.64435 6.9999L6.1999 5.66657L7.62213 1.3999Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1650_3575">
                                    <rect width="14" height="14" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                                Income calculation
                            </span>
                        )
                    }
                    {
                        this.props.isBetaCustomer && (emp.selfemployed === true && emp.percentownership < 25) && (
                            <span 
                                disabled={true}
                                className="income-calculation-btn-disabled"
                            >
                                Income calculation
                            </span>
                        )
                    }
                        </div> */}
                        <div className="text-right">
                            {this.state.editMode ? <MinusSquareOutlined
                                onClick={() => this.props.removeBorrowerPreviousOccupation("borrower", i)}
                                style={{ color: "#325CEB", fontSize: 16, cursor: "pointer" }}
                            /> : null}
                        </div>
                    {/* </div> */}
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputField("Employer or business name", emp.employername, changeVal(i, "employername"))}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.inputField("Position or title", emp.positiontitle, changeVal(i, "positiontitle"))}
                        </Col>
                        {/* <Col sm={6} className="mb-4">
                            {this.inputField("Phone", emp.phone, (e) => {
                                let phone = com.fixPhoneInput(e.target.value)
                                this.props.changeBorrowerPreviousOccupationValue(phone, i, currentView, "phone")
                            }
                            )}
                        </Col> */}
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id={`PrevEmploymentAddress${i}`}
                                border={true}
                                style={emp.employeraddress === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14', fontSize:"16px" } : {fontSize:"16px"}}
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={emp.employeraddress}
                                onChange={(e) => this.props.changeBorrowerPreviousOccupationValue(e.target.value, i, currentView, "employeraddress")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback=""
                                badfeedback="Please provide address."
                            /> : <FormPreview title="Address" content={emp.employeraddress} />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.dateField(
                                "From",
                                emp.from,
                                (date, dateString) => this.props.changeBorrowerPreviousOccupationValue(dateString, i, currentView, "from")
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dateField(
                                "To",
                                emp.to,
                                (date, dateString) => this.props.changeBorrowerPreviousOccupationValue(dateString, i, currentView, "to")
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.employedbyagent}
                                onChange={changeChecked(i, "employedbyagent")}
                                className="fontWeight500"
                            >
                                You are employed by a family member, property seller, real estate agent, or other party to the transaction.
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={emp.selfemployed}
                                onChange={changeChecked(i, "selfemployed")}
                                className="fontWeight500"
                            >
                                Check if you are the Business Owner or Self-Employed
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md={6}>
                            {this.inputFields(
                                "Income",
                                [emp.incomeperiod === "monthly" ? emp.income : Math.round(emp.income / 12)],
                                [(e) => {
                                    const val = e.target.value
                                    this.props.changeBorrowerPreviousOccupationValue(
                                        val,
                                        i,
                                        currentView,
                                        "income"
                                    )
                                    this.props.changeBorrowerPreviousOccupationValue(
                                        "monthly",
                                        i,
                                        currentView,
                                        "incomeperiod"
                                    )
                                }],
                                ["$"],
                                ["/ month"],
                                [false]
                            )}
                        </Col>
                    </Row>
                </div>
            )
        }

        const addPreviousIncome = () => {
            const b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
            if (b.previousoccupations === null) {
                this.props.clearBorrowerPreviousOccupations(currentView)
            }
            this.props.addBorrowerPreviousOccupation(currentView)
        }

        return (
            <div id="1d">
                <div className="form1003Title">
                    1d. Previous Employment/Self-Employment and Income
                </div>
                <div>{displayPreviousOccupation()}</div>
                {this.state.editMode ? <div style={{ fontSize: 16, fontWeight: 500, color: "#325CEB", cursor: "pointer" }} onClick={() => addPreviousIncome()}>
                    <img
                        src="/images/bluePlusInCircleMark.png"
                        style={{ width: 20, height: 20 }}
                        className="ml-4 mr-2 my-3"
                    />
                    Add previous income
                </div> : <div style={{ height: 52 }} />}
            </div>
        )
    };

    section1e = (currentView) => {
        const inc = currentView === "borrower" ? this.props.application.borrower.income.otherincome : this.props.application.coborrower.income.otherincome

        const displayOtherIncomes = () => {
            if (inc === null || inc.length === 0) {
                return ""
            }

            const selectBefore = (i) => {
                return (
                    <Select
                        disabled={!this.state.editMode}
                        style={{ minWidth: 200 }}
                        onSelect={(e) => {
                            this.props.updateBorrowerAdditionalIncome(
                                { target: { value: e } },
                                currentView,
                                "incometype",
                                i
                            )
                            const description = com.othersouresofincome.find(item => item[0] === e)?.[1];
                            if (description) {
                                this.props.updateBorrowerAdditionalIncome(
                                    { target: { value: description } },
                                    currentView,
                                    'description',
                                    i
                                )
                            }
                        }}
                        value={inc[i].incometype}
                    >
                        {com.othersouresofincome.map((st) => (
                            <Option value={st[0]}>{st[1]}</Option>
                        ))}
                    </Select>
                )
            }

            const out = []
            for (let i = 0; i < inc.length; i++) {
                out.push(
                    <Row>
                        <Col className={`mx-2 my-2 ${this.state.editMode ? '' : 'other-income-view'}`}>
                            <Input
                                style={{ minWidth: 170 }}
                                disabled={!this.state.editMode}
                                addonBefore={selectBefore(i)}
                                suffix="/ month"
                                prefix="$"
                                value={inc[i].amount}
                                size="large"
                                onChange={(e) =>
                                    this.props.updateBorrowerAdditionalIncome(
                                        e,
                                        currentView,
                                        "amount",
                                        i
                                    )
                                }
                            />
                        </Col>
                        <Col className="text-left d-flex align-items-center">
                            {this.state.editMode ? <MinusCircleOutlined onClick={() => this.props.removeBorrowerAdditionalIncome(i, "borrower")} style={{ fontSize: 16, color: "#325CEB", cursor: "pointer" }} /> : null}
                        </Col>
                    </Row>
                )
            }
            return out
        }

        const addIncome = (e) => {
            this.props.addBorrowerAdditionalIncome(0, currentView)
        }

        return (
            <div id="1e">
                <div className="form1003Title mb-4">1e. Income from Other Sources</div>
                <div>{displayOtherIncomes()}</div>
                {this.state.editMode && (isEmpty(inc) || inc.length < 3) && (
                    <div
                        style={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: "#325CEB",
                            cursor: "pointer",
                        }}
                        onClick={addIncome}
                    >
                        <img
                            src="/images/bluePlusInCircleMark.png"
                            style={{ width: 20, height: 20 }}
                            className="ml-4 mr-2 my-3"
                        />
                        Add income from other resources
                    </div>
                )}
            </div>
        )
    };
    sectionS2 = () => {
        return (
            <div id="s2" className="p-4">
                <div className="fontWeight500" style={{ fontSize: 20 }}>
                    Section 2: Financial Information — Assets and Liabilities
                </div>
                <div>
                    This section asks about things you own that are worth money and that
                    you want considered to qualify for this loan. It then asks about your
                    liabilities (or debts) that you pay each month, such as credit cards,
                    alimony, or other expenses.
                </div>
            </div>
        )
    };
    section2a = () => {
        return (
            <div id="2a">
                <div className="form1003Title">
                    2a. Assets – Bank Accounts, Retirement, and Other Accounts You Have
                </div>
                <div className="p-4">
                    <Row>
                        <Col className="px-0">
                            <IncomeSourcesTable editMode={this.state.editMode} currentView={this.state.currentView} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    section2b = () => {
        return (
            <div id="2b">
                <div className="form1003Title">
                    2b. Other Assets and Credits You Have
                </div>
                <div className="p-4">
                    <Row>
                        <Col className="px-0">
                            <OtherAssetsTable editMode={this.state.editMode} currentView={this.state.currentView} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    importLiabilities = (type) => {
        // this.setState({ creditSummaryReviewOpen: true, creditCheckType: type })
        // this.getCreditReport()
        this.props.changeTab('creditReport')
    }
    creditReportBtn = (type, i = 0, isSubjectProperty = false) => {
        let data = [];
        
        // Get the correct loan data based on section type
        if (type === 'section2c') {
            data = this.props.application?.assetsandliabilities?.loans || [];
        } else if (type === 'section3') {
            const currentView = this.state.currentView;
            
            if (isSubjectProperty) {
                // 如果是主体房产，使用 property.loans
                data = this.props.application.property.loans || [];
            } else {
                // 如果是其他房产，使用 ownedproperties 中对应索引的 loans
                const ownedProperties = this.props.application[currentView].ownedproperties || [];
                if (ownedProperties.length > i) {
                    data = ownedProperties[i].loans || [];
                }
            }
        }

        const hasCreditReportData = data.some(loan => loan.dataSource === 'creditreport');
        const hasAvailableCreditReport = this.state.creditLiability && this.state.creditLiability.length > 0;
        
        // 获取已导入的时间和最新请求的时间
        const importedTime = data.find(loan => loan.dataSource === 'creditreport')?.updateTime;

        // 检查是否有新的信用报告
        const hasNewCreditReport = hasCreditReportData && this.state.requestedTime && importedTime && 
            dayjs(this.state.requestedTime).isAfter(dayjs(importedTime));

         if (hasCreditReportData) {
            // 已导入状态的逻辑
            const formattedDate = dayjs(importedTime).format('MM/DD/YYYY');
            return {
                button: (
                    <Button 
                        disabled={false} 
                        className="credit-report-button imported" 
                        onClick={() => this.importLiabilities(type)}
                    >
                        Import from Credit Report
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13.3332 7.33346C13.1701 6.16028 12.6259 5.07324 11.7843 4.23979C10.9426 3.40635 9.85034 2.87274 8.67562 2.72116C7.50089 2.56959 6.30892 2.80845 5.2833 3.40096C4.25769 3.99347 3.45534 4.90675 2.99984 6.00013M2.6665 3.33346V6.00013H5.33317M2.6665 8.66667C2.82954 9.83985 3.37379 10.9269 4.21541 11.7603C5.05703 12.5938 6.14933 13.1274 7.32406 13.279C8.49878 13.4305 9.69076 13.1917 10.7164 12.5992C11.742 12.0067 12.5443 11.0934 12.9998 10M13.3332 12.6667V10H10.6665" stroke="#325CEB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </Button>
                ),
                tooltip: (
                    <div className="last-imported-tooltip">
                        Last imported from credit report on {formattedDate}
                    </div>
                )
            };
        } else if (hasAvailableCreditReport && !hasCreditReportData) {
            // 信用报告可用但未导入的状态
            return {
                button: (
                    <Button 
                        disabled={false} 
                        className="credit-report-button" 
                        onClick={() => this.importLiabilities(type)}
                    >
                        Import from Credit Report
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.99935 4.00002H3.99935C3.64573 4.00002 3.30659 4.1405 3.05654 4.39054C2.80649 4.64059 2.66602 4.97973 2.66602 5.33335V12C2.66602 12.3536 2.80649 12.6928 3.05654 12.9428C3.30659 13.1929 3.64573 13.3334 3.99935 13.3334H10.666C11.0196 13.3334 11.3588 13.1929 11.6088 12.9428C11.8589 12.6928 11.9993 12.3536 11.9993 12V8.00002M7.33268 8.66669L13.3327 2.66669M13.3327 2.66669H9.99935M13.3327 2.66669V6.00002" stroke="#325CEB" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </Button>
                ),
                tooltip: "View credit report and import liabilities into 1003."
            };
        }

        // 默认状态
        return {
            button: (
                <Button 
                    disabled={true} 
                    className="credit-report-button" 
                    onClick={() => this.importLiabilities(type)}
                >
                    Import from Credit Report
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99935 4.00002H3.99935C3.64573 4.00002 3.30659 4.1405 3.05654 4.39054C2.80649 4.64059 2.66602 4.97973 2.66602 5.33335V12C2.66602 12.3536 2.80649 12.6928 3.05654 12.9428C3.30659 13.1929 3.64573 13.3334 3.99935 13.3334H10.666C11.0196 13.3334 11.3588 13.1929 11.6088 12.9428C11.8589 12.6928 11.9993 12.3536 11.9993 12V8.00002M7.33268 8.66669L13.3327 2.66669M13.3327 2.66669H9.99935M13.3327 2.66669V6.00002" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </Button>
            ),
            tooltip: "Credit report hasn't been pulled yet. Pull credit first to enable import."
        };
    };
    section2c = (currentView) => {
        const creditReportBtnData = this.creditReportBtn('section2c')
        return (
            <div id="2c">
                <div className="form1003Title liability-title">
                    2c. Liabilities – Credit Cards, Other Debts, and Leases that You Owe
                    <Tooltip 
                        overlayClassName='import-credit-report-tooltip' 
                        title={creditReportBtnData.tooltip} 
                        placement="bottomRight"
                    >
                        {creditReportBtnData.button}
                    </Tooltip>
                </div>
                <div className="p-4">
                    <Row>
                        <Col className="px-0">
                            <LiabilitiesTable editMode={this.state.editMode} who={currentView} onLinkClick={() => this.setState({ linkModalOpen: true, linkType: 'property' })} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };

    section2d = (currentView) => {
        return (
            <div id="2d">
                <div className="form1003Title">2d. Other Liabilities and Expenses</div>
                <div className="p-4">
                    <Row>
                        <Col className="px-0">
                            <OtherLiabilitiesTable who={currentView} editMode={this.state.editMode} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    sectionS3 = () => {
        return (
            <div id="s3" className="p-4">
                <div className="fontWeight500" style={{ fontSize: 20 }}>
                    Section 3: Financial Information — Real Estate
                </div>
                <div>
                    This section asks you to list all properties you currently own and
                    what you owe on them.
                </div>
            </div>
        )
    };
    section3a = (currentView) => {
        let count = this.props.application[currentView].ownedproperties.length
        let isPurchase = this.props.application.property.purpose === "purchase"
        const renderProperties = () => {
            // If you are refinancing, list the property you are refinancing FIRST
            if (!isPurchase) {
                return this.renderOwnedProperty(0, true, false, currentView)
            }
            if (count === 0) {
                return ""
            }
            return this.renderOwnedProperty(0, false, false, currentView)
        }
        
        const creditReportBtnData = this.creditReportBtn('section3', 0, !isPurchase)
        return (
            <div id="3a">
                <div className="form1003Title liability-title">
                    3a. Property You Own
                    <Tooltip 
                        overlayClassName='import-credit-report-tooltip' 
                        title={creditReportBtnData.tooltip} 
                        placement="bottomRight"
                    >
                        {creditReportBtnData.button}
                    </Tooltip>
                </div>
                <Row>
                    <Col>
                        <div className="p-4">
                            <CheckboxExtended
                                checked={
                                    isPurchase && count === 0
                                }
                                preview={!this.state.editMode}
                                className={!isPurchase ? "hide" : "fontWeight500 mb-4"}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        if (isPurchase) this.props.clearBorrowerOwnedProperty(0)
                                    } else {
                                        if (count === 0) {
                                            if (currentView === "borrower") {
                                                this.props.addBorrowerOwnedProperty()
                                            }
                                            if (currentView === "coborrower") {
                                                this.props.addCoborrowerOwnedProperty()
                                            }
                                        }
                                    }
                                }}
                            >
                                I do not own any real estate
                            </CheckboxExtended>
                            {renderProperties()}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    };
    section3b = (currentView) => {
        let count = this.props.application[currentView].ownedproperties.length
        let isPurchase = this.props.application.property.purpose === "purchase"
        const renderProperties = () => {
            if (!isPurchase) {
                if (count === 0) {
                    return ""
                }
                return this.renderOwnedProperty(0, false, false, currentView)
            } else {
                if (count <= 1) {
                    return ""
                }
                return this.renderOwnedProperty(1, false, false, currentView)
            }
        }
        const creditReportBtnData = this.creditReportBtn('section3', isPurchase ? 1 : 0, false)
        return (
            <div id="3b">
                <div className="form1003Title liability-title">
                    3b. Additional Property
                    {!(isPurchase ? count < 2 : count < 1) && (
                        <Tooltip 
                            overlayClassName='import-credit-report-tooltip' 
                            title={creditReportBtnData.tooltip} 
                            placement="bottomRight"
                        >
                            {creditReportBtnData.button}
                        </Tooltip>
                    )}
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                checked={
                                    isPurchase ? count < 2 : count < 1
                                }
                                preview={!this.state.editMode}
                                className="fontWeight500"
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        if (isPurchase) {
                                            if (count === 0) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: true })
                                            } else if (count === 1) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false })
                                            }
                                        } else {
                                            if (count === 0) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false })
                                            }
                                        }
                                    } else {
                                        let indexToClear = isPurchase ? 1 : 0
                                        if (count > indexToClear) {
                                            for (let i = indexToClear; i < count; i++) {
                                                if (currentView === "borrower") {
                                                    this.props.removeBorrowerOwnedProperty(i)
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.removeCoborrowerOwnedProperty(i)
                                                }
                                            }
                                        }
                                        this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: false })
                                    }
                                }}
                            >
                                Does not apply
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {this.state.showOwnPropertyWarning1 && <Row>
                        <Col className="mb-3">
                            <Alert
                                message="Warning"
                                description="Please fill the property information in section 3a first"
                                type="warning"
                                showIcon
                                closable
                            />
                        </Col>
                    </Row>}
                    {renderProperties()}
                </div>
            </div>
        )
    };
    section3c = (currentView) => {
        let count = this.props.application[currentView].ownedproperties.length
        let isPurchase = this.props.application.property.purpose === "purchase"
        const renderProperties = () => {
            if (!isPurchase) {
                if (count <= 1) {
                    return ""
                }
                return this.renderOwnedProperty(1, false, false, currentView)
            } else {
                if (count <= 2) {
                    return ""
                }
                return this.renderOwnedProperty(2, false, false, currentView)
            }
        }
        const creditReportBtnData = this.creditReportBtn('section3', isPurchase ? 2 : 1, false)
        return (
            <div id="3c">
                <div className="form1003Title liability-title">
                    3c. Additional Property
                    {!(isPurchase ? count < 2 : count < 1) && (
                        <Tooltip 
                            overlayClassName='import-credit-report-tooltip' 
                            title={creditReportBtnData.tooltip} 
                            placement="bottomRight"
                        >
                            {creditReportBtnData.button}
                        </Tooltip>
                    )}
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={isPurchase ? count < 3 : count < 2}
                                className="fontWeight500"
                                onChange={(e) => {

                                    if (!e.target.checked) {
                                        if (isPurchase) {
                                            if (count === 0) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                    this.props.addBorrowerOwnedProperty()
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                    this.props.addCoborrowerOwnedProperty()
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: true, showOwnPropertyWarning2: true })
                                            } else if (count === 1) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: true })
                                            } else if (count === 2) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: false })
                                            }
                                        } else {
                                            if (count === 0) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: true })
                                            } else if (count === 1) {
                                                if (currentView === "borrower") {
                                                    this.props.addBorrowerOwnedProperty()
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.addCoborrowerOwnedProperty()
                                                }
                                                this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: false })
                                            }
                                        }
                                    } else {
                                        let indexToClear = isPurchase ? 2 : 1
                                        if (count > indexToClear) {
                                            for (let i = indexToClear; i < count; i++) {
                                                if (currentView === "borrower") {
                                                    this.props.removeBorrowerOwnedProperty(i)
                                                }
                                                if (currentView === "coborrower") {
                                                    this.props.removeCoborrowerOwnedProperty(i)
                                                }
                                            }
                                        }
                                        this.setState({ showOwnPropertyWarning1: false, showOwnPropertyWarning2: false })
                                    }
                                }}
                            >
                                Does not apply
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {this.state.showOwnPropertyWarning2 && <Row>
                        <Col className="mb-3">
                            <Alert
                                message="Warning"
                                description="Please fill the property information in section 3a and 3b first"
                                type="warning"
                                showIcon
                                closable
                            />
                        </Col>
                    </Row>}
                    {renderProperties()}
                </div>
            </div>
        )
    };
    section3Extra = (currentView) => {
        let count = this.props.application[currentView].ownedproperties.length
        let isPurchase = this.props.application.property.purpose === "purchase"

        const renderProperties = (num) => {
            let properties = []
            if (!isPurchase) {
                if (count <= 2) {
                    return ""
                }
                for (let i = num + 1; i > 0; i--) {
                    properties.push(this.renderOwnedProperty(count - i, false, true, currentView))
                }
                return properties
            } else {
                if (count <= 3) {
                    return ""
                }
                for (let i = num; i > 0; i--) {
                    properties.push(this.renderOwnedProperty(count - i, false, true, currentView))
                }
                return properties
            }
        }
        return (
            <div id="3extra">
                { ((!isPurchase && count > 2) || (isPurchase && count> 3)) && <div className="">
                    {renderProperties(count-3)}
                </div>}
                {this.state.editMode ? <div
                    style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: "#325CEB",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        if (currentView === "borrower") {
                            this.props.addBorrowerOwnedProperty()
                        }
                        if (currentView === "coborrower") {
                            this.props.addCoborrowerOwnedProperty()
                        }
                    }}
                >
                    <img
                        src="/images/bluePlusInCircleMark.png"
                        style={{ width: 20, height: 20 }}
                        className="ml-4 mr-2 my-3"
                    />
                    Add property
                </div> : null}
            </div>
        )
    };
    sectionS4 = () => {
        return (
            <div id="s4" className="p-4">
                <div className="fontWeight500" style={{ fontSize: 20 }}>
                    Section 4: Loan and Property Information
                </div>
                <div>
                    This section asks about the loan's purpose and the property you want
                    to purchase or refinance.
                </div>
            </div>
        )
    };

    section4a = () => {
        this.section1aDom('4a. Loan and Property Information', {
            ...this.props.application.selection,
            ...this.props.application.property,
        }, ['loansize',"loanbalance", 'purpose', 'address', 'zipcode', 'appraisal', 'occupancy'])
        return (


            <div id="4a">
                <div className="form1003Title">4a. Loan and Property Information</div>
                <div className="p-4">
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Loan purpose",
                                this.props.application.property.purpose,
                                [
                                    { value: "", label: "Select loan purpose" },
                                    { value: "purchase", label: "Purchase" },
                                    { value: "refinance", label: "Rate/Term refinance" },
                                    { value: "cashoutrefinance", label: "Cash-out refinance" },
                                ],
                                (e) => {
                                    this.props.changeMainPropertyPurpose(e.target.value)
                                    this.props.needUpdateLenderLoanForm(true)
                                    if (e.target.value === "purchase") {
                                        this.props.changeMainPropertyAttribute(true, "hascontract")
                                    }
                                }
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Intended occupancy",
                                this.props.application.property.occupancy,
                                [
                                    { value: "principal", label: "Primary Residence" },
                                    { value: "secondhome", label: "Second Home" },
                                    { value: "investment", label: "Investment" },
                                    { value: "fhasecond", label: "FHA Secondary Residence" },
                                ],
                                (e) =>
                                    this.props.changeMainProperty(e.target.value, "occupancy")
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.inputFieldWithPrefix(
                                "Property value",
                                this.props.application.property.purpose === "purchase" ? this.props.application.property.salesprice : this.props.application.property.appraisal, 
                                (e) => {
                                    this.props.application.property.purpose === "purchase" ? this.props.changeMainProperty(e.target.value, "salesprice") : this.props.changeMainProperty(e.target.value, "appraisal")
                                    if (this.props.application.property.purpose === "purchase") {

                                        // let loansize = com.safeParseInt(this.props.application.property.salesprice)- com.safeParseInt(this.props.selection.downpayment)
                                        let loansize = this.props.application.selection.loansize;
                                        let salesprice = com.safeParseInt(e.target.value)
                                        let downpay = salesprice - loansize
                                        // console.log("downpay", loansize, downpay)
                                        if (downpay >= 0) {
                                            this.props.updateSelectField(downpay, "downpayment")
                                            this.props.changeMainProperty(e.target.value, "salesprice")
                                        }else{
                                            this.props.updateSelectField(0, "downpayment")
                                        }
                                    }
                                    
                                    // 检查LTV变化并自动清零PMI
                                    setTimeout(() => {
                                        this.checkAndClearPMI()
                                    }, 100)
                                },
                                "$"
                            )}
                        </Col>
                        {(this.props.application.property.purpose === "refinance" || this.props.application.property.purpose === "cashoutrefinance") && <Col sm={6} className="mb-4">
                            {this.inputFieldWithPrefix(
                                "Current balance",
                                this.props.application.loanbalance,
                                (e) => {
                                    this.props.updateApplicationAttribute(e.target.value,"loanbalance")
                                    if (this.props.application.property.purpose === "purchase") {
                                        let salesprice = com.safeParseInt(this.props.application.property.salesprice)
                                        let loansize = this.props.application.selection.loansize
                                        if (salesprice >= loansize) {
                                            this.props.updateSelectField(salesprice - loansize, "downpayment")
                                        }
                                    } else if (this.props.application.property.purpose === "cashoutrefinance") {
                                        let salesprice = com.safeParseInt(this.props.application.property.appraisal)
                                        let loanbalance = e.target.value
                                        let loansize = this.props.application.selection.loansize
                                        if (salesprice >= loansize && loansize >= loanbalance) {
                                            this.props.updateSelectField(loansize - loanbalance, "cashout")
                                        }
                                    } else {
                                        let salesprice = com.safeParseInt(this.props.application.property.appraisal)
                                        let loanbalance = e.target.value
                                        let loansize = this.props.application.selection.loansize
                                        if (salesprice >= loansize && loanbalance >= loansize) {
                                            this.props.updateSelectField(loanbalance - loansize, "paydown")
                                        }
                                    }
                                },
                                "$",
                            )}
                        </Col>}
                        <Col sm={6} className="mb-4">
                            {this.inputFieldWithPrefix(
                                "Loan amount",
                                this.props.application.selection.loansize,
                                (e) => {
                                    this.props.updateSelectField(e.target.value, "loansize")
                                    this.props.updateSelectedLoanField(com.safeParseInt(e.target.value), "loansize")
                                    if (this.props.application.property.purpose === "purchase") {
                                        let salesprice = com.safeParseInt(this.props.application.property.salesprice)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (salesprice >= loansize) {
                                            this.props.updateSelectField(salesprice - loansize, "downpayment")
                                        }
                                    } else if (this.props.application.property.purpose === "cashoutrefinance") {
                                        let salesprice = com.safeParseInt(this.props.application.property.appraisal)
                                        let loanbalance = com.safeParseInt(this.props.application.loanbalance)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (salesprice >= loansize && loansize >= loanbalance) {
                                            this.props.updateSelectField(loansize - loanbalance, "cashout")
                                        }
                                    } else {
                                        let salesprice = com.safeParseInt(this.props.application.property.appraisal)
                                        let loanbalance = com.safeParseInt(this.props.application.loanbalance)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (salesprice >= loansize && loanbalance >= loansize) {
                                            this.props.updateSelectField(loanbalance - loansize, "paydown")
                                        }
                                    }
                                    
                                    // 检查LTV变化并自动清零PMI
                                    setTimeout(() => {
                                        this.checkAndClearPMI()
                                    }, 100)
                                },
                                "$",
                                undefined,
                                undefined,
                                (e) => {
                                    if (this.props.application.property.purpose === "purchase") {
                                        let appraisedvalue = com.safeParseInt(this.props.application.property.salesprice)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (appraisedvalue < loansize) {
                                            alert("Loan amount cannot be greater than the property value. Please enter a suitable loan amount!")
                                        }
                                    }
                                    else if (this.props.application.property.purpose === "cashoutrefinance") {
                                        let loanbalance = com.safeParseInt(this.props.application.loanbalance)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (loansize < loanbalance) {
                                            alert("Loan amount cannot be less than the current loan balance. Please enter a suitable loan amount!")
                                        }
                                    }
                                    else if (this.props.application.property.purpose === "refinance") {
                                        let loanbalance = com.safeParseInt(this.props.application.loanbalance)
                                        let loansize = com.safeParseInt(e.target.value)
                                        if (loanbalance < loansize) {
                                            alert("Loan amount cannot be more than the current loan balance. Please enter a suitable loan amount!")
                                        }
                                    }
                                },
                                (() => {
                                    const purpose = this.props.application.property.purpose
                                    const loansize = com.safeParseInt(this.props.application.selection.loansize)
                                    const loanbalance = com.safeParseInt(this.props.application.loanbalance)
                                    if (!loansize) return ""
                                    if (purpose === "purchase") {
                                        const salesprice = com.safeParseInt(this.props.application.property.salesprice)
                                        if (salesprice > 0 && salesprice < loansize) {
                                            return "Loan amount cannot be greater than the property value. Please enter a suitable loan amount!"
                                        }
                                    }
                                    if (purpose === "cashoutrefinance" && loanbalance > 0 && loansize < loanbalance) {
                                        return "Loan amount cannot be less than the current loan balance. Please enter a suitable loan amount!"
                                    }
                                    if (purpose === "refinance" && loanbalance > 0 && loanbalance < loansize) {
                                        return "Loan amount cannot be more than the current loan balance. Please enter a suitable loan amount!"
                                    }
                                    return ""
                                })()

                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6} className="mb-4">
                            {this.dropdownField(
                                "Property type",
                                this.props.application.property.propertytype,
                                [
                                    { value: "singlefamilyattached", label: "Single family" },
                                    { value: "singlefamilydetached", label: "Townhouse" },
                                    { value: "twotofourfamily", label: "Multi family" },
                                    { value: "condominium", label: "Condo" },
                                    { value: "mobilehome", label: "Manufactured home" },
                                ],
                                (e) =>{
                                    this.props.changeMainProperty(e.target.value, "propertytype")
                                },
                            )}
                        </Col>
                        <Col sm={6} className="mb-4">
                            {this.inputField(
                                "Number of units",
                                this.props.application.property.numberofunits,
                                (e) => this.props.changeMainProperty(e.target.value, "numberofunits"),
                                null,
                                true
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={this.props.application.property.buyforsomeoneelse  }
                                onChange={(e) => {
                                    this.props.changeMainProperty(e.target.checked, "buyforsomeoneelse")
                                }
                                }
                                className="fontWeight500"
                            >
                                Buying the property for someone else
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="">
                        <Col>
                            {this.state.editMode ? <AddressAutocomplete
                                id="PropertyAddress"
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                border={true}
                                style={this.props.application.property.address === '' && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                                defaultValue={this.props.application.property.address}
                                onChange={(e) => this.props.changeMainProperty(e.target.value, "address")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your street address."
                                onCompletion={e => {
                                    let address = e
                                    let state = com.getSubaddress(
                                        address,
                                        "administrative_area_level_1",
                                        "short_name"
                                    )
                                    let zip = com.getSubaddress(address, "postal_code", "long_name")

                                    let county = com.getSubaddress(
                                        address,
                                        "administrative_area_level_2",
                                        "long_name"
                                    )
                                    let num = com.getSubaddress(address, "street_number", "long_name")
                                    let short = com.getSubaddress(address, "route", "short_name")
                                    let city = com.getSubaddress(address, "locality", "long_name")
                                    let stradd = num + " " + short + ", " + city + ", " + state + " " + zip
                                    this.props.changeMainProperty(com.capitalize(com.convertAbbStateToFull(state)), "state")
                                    this.props.changeMainProperty(county, "county")
                                    this.props.changeMainProperty(city, "city")
                                    this.props.changeMainProperty(zip, "zipcode")
                                    this.props.changeMainProperty(stradd, "address")
                                }}
                                size="md"
                            /> : <div className="fontSize16" style={{marginBottom: 10}}>{this.props.application.property.address}</div>}

                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "Unit",
                                this.props.application.property.units,
                                (e) => {
                                    this.props.changeMainProperty(e.target.value, "units")
                                },
                                null,
                                true
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "State",
                                this.props.application.property.state,
                                this.getStateOptions(),
                                (e) => this.props.changeMainProperty(e.target.value, "state"),
                                // true
                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.dropdownField(
                                "County",
                                this.props.application.property.county,
                                this.getCountyOptions(this.props.application.property.state),
                                (e) => this.props.changeMainProperty(e.target.value, "county"),
                                // true
                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "City",
                                this.props.application.property.city,
                                (e) => this.props.changeMainProperty(e.target.value, "city"),

                            )}
                        </Col>
                        <Col sm={3} className="mb-4">
                            {this.inputField(
                                "Zip",
                                this.props.application.property.zipcode,
                                (e) => this.props.changeMainProperty(e.target.value, "zipcode"),

                            )}
                        </Col>
                    </Row>
                    
                    {/* Property Insurance and Tax Breakdown */}
                    <div className="mb-4 insurance-and-tax-breakdown">
                                {/* <Row>
                                    <Col>
                                        {(() => {
                                            const property = this.props.application.property
                                            const insurancemaintenancetaxes = parseFloat(property.insurancemaintenancetaxes) || 0
                                            const insurance = parseFloat(property.insurancemain) || 0
                                            const tax = parseFloat(property.insurancetax) || 0
                                            const hoa = parseFloat(property.insurancehoa) || 0
                                            const pmi = parseFloat(property.insurancepmi) || 0
                                            const total = insurance + tax + hoa + pmi
                                            
                                            // 显示Alert的条件：
                                            // 1. insurancemaintenancetaxes有值（大于0）
                                            // 2. 但子字段的和不等于insurancemaintenancetaxes（说明是老数据）
                                            // 3. 如果子字段都为0且insurancemaintenancetaxes大于0，肯定是老数据
                                            const isLegacyData = insurancemaintenancetaxes > 0 && (
                                                Math.abs(insurancemaintenancetaxes - total) > 0.01 || 
                                                (total === 0 && insurancemaintenancetaxes > 0)
                                            )
                                            
                                            return isLegacyData && (
                                                <Alert
                                                    message={`Amounts are now entered in separate fields for Insurance, Tax, HOA fees, and PMI. Previous total ($${insurancemaintenancetaxes.toLocaleString()}) moved to Insurance. Please review and update each amount to match actual costs.`}
                                                    type="warning"
                                                    showIcon
                                                    closable={{
                                                        closeIcon: (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M16.472 6.33968C16.8625 5.94915 17.4957 5.94915 17.8862 6.33968C18.2767 6.7302 18.2767 7.36336 17.8862 7.75389L7.9867 17.6534C7.59618 18.0439 6.96301 18.0439 6.57249 17.6534C6.18196 17.2629 6.18196 16.6297 6.57249 16.2392L16.472 6.33968Z" fill="#6E6E70"/>
                                                                <path d="M17.886 16.2458C18.2766 16.6363 18.2766 17.2695 17.886 17.66C17.4955 18.0505 16.8624 18.0505 16.4718 17.66L6.57234 7.76049C6.18181 7.36997 6.18181 6.7368 6.57234 6.34628C6.96286 5.95575 7.59603 5.95575 7.98655 6.34628L17.886 16.2458Z" fill="#6E6E70"/>
                                                            </svg>
                                                        )
                                                    }}
                                                    icon={
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                                            <rect x="0.234009" width="18" height="18" rx="9" fill="#CB8600"/>
                                                            <rect x="8.23401" y="4" width="2" height="7" rx="1" fill="white"/>
                                                            <rect x="10.234" y="12" width="2" height="2" rx="1" transform="rotate(90 10.234 12)" fill="white"/>
                                                        </svg>
                                                    }
                                                    className="insurance-and-tax-breakdown-alert"
                                                    onClose={() => {
                                                        // 当用户关闭Alert时，自动迁移老数据
                                                        // 将insurancemaintenancetaxes的值分配给insurance字段
                                                        if (insurancemaintenancetaxes > 0 && total === 0) {
                                                            this.props.changeMainProperty(insurancemaintenancetaxes, "insurancemain")
                                                        }
                                                    }}
                                                />
                                            )
                                        })()}
                                    </Col>
                                </Row> */}
                                
                                <Row>
                                    <Col sm={6} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            Insurance (monthly)
                                        </label>
                                        {(() => {
                                            // 公共的计算逻辑 - 与Property value字段保持一致
                                            const property = this.props.application.property
                                            const propertyValue = parseFloat(property.purpose === "purchase" ? property.salesprice : property.appraisal)
                                            const insurance = parseFloat(property.insurancemain) || 0
                                            const percentage = calculatePercentage(insurance, propertyValue)
                                            
                                            return this.state.editMode ? (
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <InputNumber
                                                        prefix="$"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ flex: 1 }}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        value={insurance}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            this.props.changeMainProperty(value, "insurancemain")
                                                            // 直接使用新值更新 insurancemaintenancetaxes
                                                            this.updateInsuranceMaintenancetaxesWithNewValue("insurancemain", value)
                                                        }}
                                                    />
                                                    <InputNumber
                                                        suffix="%"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ width: '74px' }}
                                                        min={0}
                                                        max={100}
                                                        step={0.01}
                                                        placeholder="%"
                                                        value={percentage}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            if (value !== null && value !== undefined) {
                                                                const amount = propertyValue > 0 ? (value / 100) * propertyValue : 0
                                                                this.props.changeMainProperty(Math.round(amount), "insurancemain")
                                                                // 直接使用新值更新 insurancemaintenancetaxes
                                                                this.updateInsuranceMaintenancetaxesWithNewValue("insurancemain", Math.round(amount))
                                                            }
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <ViewModeDisplay
                                                    amount={insurance}
                                                    percentage={percentage}
                                                />
                                            )
                                        })()}
                                    </Col>
                                    
                                    <Col sm={6} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            Tax (monthly)
                                        </label>
                                        {(() => {
                                            // 公共的计算逻辑 - 与Property value字段保持一致
                                            const property = this.props.application.property
                                            const propertyValue = parseFloat(property.purpose === "purchase" ? property.salesprice : property.appraisal)
                                            const tax = parseFloat(property.insurancetax) || 0
                                            const percentage = calculatePercentage(tax, propertyValue)
                                            
                                            return this.state.editMode ? (
                                                <Space.Compact style={{ width: '100%' }}>
                                                    <InputNumber
                                                        prefix="$"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ flex: 1 }}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        value={tax}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            this.props.changeMainProperty(value, "insurancetax")
                                                            // 直接使用新值更新 insurancemaintenancetaxes
                                                            this.updateInsuranceMaintenancetaxesWithNewValue("insurancetax", value)
                                                        }}
                                                    />
                                                    <InputNumber
                                                        suffix="%"
                                                        className='estimated-monthly-payment-input'
                                                        style={{ width: '74px' }}
                                                        min={0}
                                                        max={100}
                                                        step={0.01}
                                                        placeholder="%"
                                                        value={percentage}
                                                        controls={false}
                                                        onChange={(value) => {
                                                            if (value !== null && value !== undefined) {
                                                                const amount = propertyValue > 0 ? (value / 100) * propertyValue : 0
                                                                this.props.changeMainProperty(Math.round(amount), "insurancetax")
                                                                // 直接使用新值更新 insurancemaintenancetaxes
                                                                this.updateInsuranceMaintenancetaxesWithNewValue("insurancetax", Math.round(amount))
                                                            }
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <ViewModeDisplay
                                                    amount={tax}
                                                    percentage={percentage}
                                                />
                                            )
                                        })()}
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col sm={6} className="mb-4">
                                        <label className="insurance-and-tax-breakdown-label">
                                            HOA fee (monthly)
                                        </label>
                                        {(() => {
                                            const hoa = this.props.application.property.insurancehoa || 0
                                            
                                            return this.state.editMode ? (
                                                <InputNumber
                                                    prefix="$"
                                                    className='estimated-monthly-payment-input'
                                                    style={{ width: '100%' }}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    value={hoa}
                                                    controls={false}
                                                    onChange={(value) => {
                                                        this.props.changeMainProperty(value, "insurancehoa")
                                                        // 直接使用新值更新 insurancemaintenancetaxes
                                                        this.updateInsuranceMaintenancetaxesWithNewValue("insurancehoa", value)
                                                    }}
                                                />
                                            ) : (
                                                <ViewModeDisplayAmount
                                                    amount={hoa}
                                                />
                                            )
                                        })()}
                                    </Col>
                                    
                                    {(() => {
                                        const property = this.props.application.property
                                        const propertyValue = property.purpose === "purchase" ? parseFloat(property.salesprice) : parseFloat(property.appraisal)
                                        
                                        // 直接使用 loansize 计算 LTV
                                        const loansize = parseFloat(this.props.application.selection.loansize) || 0
                                        const ltv = propertyValue > 0 ? loansize / propertyValue : 0
                                        const needsPMI = ltv > 0.8
                                        
                                        return needsPMI && (
                                            <Col sm={6} className="mb-4">
                                                <label className="insurance-and-tax-breakdown-label">
                                                    PMI (monthly)
                                                </label>
                                                {(() => {
                                                    // 公共的计算逻辑 - 与Property value字段保持一致
                                                    const property = this.props.application.property
                                                    const propertyValue = parseFloat(property.purpose === "purchase" ? property.salesprice : property.appraisal)
                                                    const pmi = parseFloat(property.insurancepmi) || 0
                                                    const percentage = calculatePercentage(pmi, propertyValue)
                                                    
                                                    return this.state.editMode ? (
                                                        <Space.Compact style={{ width: '100%' }}>
                                                            <InputNumber
                                                                prefix="$"
                                                                className='estimated-monthly-payment-input'
                                                                style={{ flex: 1 }}
                                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                                value={pmi}
                                                                controls={false}
                                                                onChange={(value) => {
                                                                    this.props.changeMainProperty(value, "insurancepmi")
                                                                    // 直接使用新值更新 insurancemaintenancetaxes
                                                                    this.updateInsuranceMaintenancetaxesWithNewValue("insurancepmi", value)
                                                                }}
                                                            />
                                                            <InputNumber
                                                                suffix="%"
                                                                className='estimated-monthly-payment-input'
                                                                style={{ width: '74px' }}
                                                                min={0}
                                                                max={100}
                                                                step={0.01}
                                                                placeholder="%"
                                                                value={percentage}
                                                                controls={false}
                                                                onChange={(value) => {
                                                                    if (value !== null && value !== undefined) {
                                                                        const amount = propertyValue > 0 ? (value / 100) * propertyValue : 0
                                                                        this.props.changeMainProperty(Math.round(amount), "insurancepmi")
                                                                        // 直接使用新值更新 insurancemaintenancetaxes
                                                                        this.updateInsuranceMaintenancetaxesWithNewValue("insurancepmi", Math.round(amount))
                                                                    }
                                                                }}
                                                            />
                                                        </Space.Compact>
                                                    ) : (
                                                        <ViewModeDisplay
                                                            amount={pmi}
                                                            percentage={percentage}
                                                        />
                                                    )
                                                })()}
                                            </Col>
                                        )
                                    })()}
                                </Row>
                         
                        
                    </div>
                    
                    <hr className="form1003Divider"></hr>

                    <Row className="mb-4">
                        <Col>
                            <div>
                                <div
                                    style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}
                                >
                                    1. Mixed-use property
                                </div>
                                <div>
                                    {this.selectionField(
                                        "If you will occupy the property, will you set aside space within the property to operate your own business?",
                                        this.props.application.property.isMixedUse === true
                                            ? true
                                            : false,
                                        [
                                            {
                                                value: true,
                                                label: "Yes",
                                            },
                                            {
                                                value: false,
                                                label: "No",
                                            },
                                        ],
                                        (e) => this.props.changeMainProperty(e, "isMixedUse"),
                                        true
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <div>
                                <div
                                    style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}
                                >
                                    2. Manufactured home
                                </div>
                                <div>
                                    {this.selectionField(
                                        "Is the property a manufactured home? (e.g., a factory built dwelling built on a permanent chassis)",
                                        this.props.application.property.isManufacturedHome === true
                                            ? true
                                            : false,
                                        [
                                            {
                                                value: true,
                                                label: "Yes",
                                            },
                                            {
                                                value: false,
                                                label: "No",
                                            },
                                        ],
                                        (e) => {
                                            this.props.changeMainProperty(e, "isManufacturedHome")
                                            if (e) {
                                                this.props.changeMainProperty("mobilehome", "propertytype")
                                            } else {
                                                this.props.changeMainProperty("singlefamilydetached", "propertytype")
                                            }
                                        },
                                        true
                                    )}

                                </div>
                            </div>
                        </Col>
                    </Row>
                    {this.props.application.property.isManufacturedHome === true &&
                    <div>
                        <Row className="mb-4">
                            <Col>
                                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>Manufactured home details</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Manufactured home park full name",
                                    this.props.application.property.mobilehomeinfo.mobilehomeparkfullname,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "mobilehomeparkfullname"),
                                    null,
                                    true
                                )}
                            </Col>
                            <Col sm={6} className="mb-4">
                                {this.state.editMode ? (
                                    <AddressAutocomplete
                                        id="parkAddress"
                                        border={true}
                                        // style={
                                        //     this.props.application.property.mobilehomeinfo.parkAddress === '' &&
                                        //     this.props.mode !== 'document' ?
                                        //     { border: '1px solid #faad14' } : {}
                                        // }
                                        label={<div className="fontWeight500">Park Address</div>}
                                        required={true}
                                        name="parkAddress"
                                        defaultValue={this.props.application.property.mobilehomeinfo.parkAddress}
                                        onChange={(e) => this.props.changeMobileHomeInfo(e.target.value, "parkAddress")}
                                        pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                        placeholder="Please enter the park address."
                                        goodfeedback="Looks good!"
                                        badfeedback="Please provide the park address."
                                        onCompletion={(e) => {
                                            const num = com.getSubaddress(e, "street_number", "long_name")
                                            const street = com.getSubaddress(e, "route", "short_name")
                                            const city = com.getSubaddress(e, "locality", "long_name")
                                            const state = com.getSubaddress(e, "administrative_area_level_1", "short_name")
                                            const zip = com.getSubaddress(e, "postal_code", "long_name")

                                            const fullAddress = `${num} ${street}, ${city}, ${state} ${zip}`
                                            this.props.changeMobileHomeInfo(fullAddress, "parkAddress")
                                        }}
                                        size="md"
                                    />
                                ) : (
                                    <div className="fontSize16">
                                        {this.props.application.property.mobilehomeinfo.parkAddress}
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.inputFieldWithPrefix(
                                    "Monthly space rent",
                                    this.props.application.property.mobilehomeinfo.leasedSpaceRentAmount,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "leasedSpaceRentAmount"),
                                    "$",
                                    undefined,
                                    true,
                                )}
                            </Col>
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Space number",
                                    this.props.application.property.mobilehomeinfo.space,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "space"),
                                    null,
                                    true
                                )}
                            </Col>
                        </Row>
                        <Row >
                            <Col sm={6} className="mb-4">
                                <Form.Group className="inputSection">
                                    <Form.Label style={{fontSize: 14, fontWeight: 500, marginBottom: 10}}>
                                        Width
                                    </Form.Label>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div style={{ width: "49%" }}>
                                            {this.state.editMode ? (
                                                <Input
                                                    value={this.props.application.property.mobilehomeinfo.widthft}
                                                    onChange={(e) => this.props.changeMobileHomeInfo(e.target.value, "widthft")}
                                                    suffix="ft"
                                                    size="large"
                                                />
                                            ) : (
                                                <div style={{ fontSize: 16 }}>
                                                    {this.props.application.property.mobilehomeinfo.widthft} ft
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ width: "49%" }}>
                                            {this.state.editMode ? (
                                                <Input
                                                    value={this.props.application.property.mobilehomeinfo.widthinch}
                                                    onChange={(e) => this.props.changeMobileHomeInfo(e.target.value, "widthinch")}
                                                    suffix="inch"
                                                    size="large"
                                                />
                                            ) : (
                                                <div style={{ fontSize: 16 }}>
                                                    {this.props.application.property.mobilehomeinfo.widthinch} inch
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col sm={6} className="mb-4">
                                <Form.Group className="inputSection">
                                    <Form.Label style={{fontSize: 14, fontWeight: 500, marginBottom: 10}}>
                                        Length
                                    </Form.Label>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div style={{ width: "49%" }}>
                                            {this.state.editMode ? (
                                                <Input
                                                    value={this.props.application.property.mobilehomeinfo.lengthft}
                                                    onChange={(e) => this.props.changeMobileHomeInfo(e.target.value, "lengthft")}
                                                    suffix="ft"
                                                    size="large"
                                                />
                                            ) : (
                                                <div style={{ fontSize: 16 }}>
                                                    {this.props.application.property.mobilehomeinfo.lengthft} ft
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ width: "49%" }}>
                                            {this.state.editMode ? (
                                                <Input
                                                    value={this.props.application.property.mobilehomeinfo.lengthinch}
                                                    onChange={(e) => this.props.changeMobileHomeInfo(e.target.value, "lengthinch")}
                                                    suffix="inch"
                                                    size="large"
                                                />
                                            ) : (
                                                <div style={{ fontSize: 16 }}>
                                                    {this.props.application.property.mobilehomeinfo.lengthinch} inch
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.dropdownField(
                                    "Condition",
                                    this.props.application.property.mobilehomeinfo.mobilehomedescription,
                                    [
                                        { value: "New", label: "New" },
                                        { value: "Used", label: "Used" },
                                        { value: "Repo", label: "Repo" },
                                    ],
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "mobilehomedescription"),
                                )}
                            </Col>
                            <Col sm={6} className="mb-4">
                                {this.dropdownField(
                                    "Type",
                                    this.props.application.property.mobilehomeinfo.mobilehometype,
                                    [
                                        { value: "SingleWide", label: "Single Wide" },
                                        { value: "DoubleWide", label: "Double Wide" },
                                        { value: "TripleWide", label: "Triple Wide" },
                                    ],
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "mobilehometype"),
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Manufacturer make",
                                    this.props.application.property.mobilehomeinfo.manufacturerMake,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "manufacturerMake"),
                                    null,
                                    true
                                )}
                            </Col>
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Manufacturer model",
                                    this.props.application.property.mobilehomeinfo.manufacturerModel,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "manufacturerModel"),
                                    null,
                                    true
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className="mb-4">
                                {this.inputField(
                                    "Year built",
                                    this.props.application.property.mobilehomeinfo.year,
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "year"),
                                    null,
                                    true
                                )}
                            </Col>
                            <Col sm={6} className="mb-4">
                                {this.dropdownField(
                                    "Location",
                                    this.props.application.property.mobilehomeinfo.mobilehomelocation,
                                    [
                                        { value: "Park", label: "Park" },
                                        { value: "LandorHome", label: "Land/home" },
                                        { value: "CoopPark", label: "Co-op park" },
                                        { value: "SharedPark", label: "Shared park" },
                                    ],
                                    (e) => this.props.changeMobileHomeInfo(e.target.value, "mobilehomelocation"),
                                )}
                            </Col>
                        </Row>
                    </div>}
                </div>
            </div>
        )
    };
    section4b = () => {
        return (
            <div id="4b">
                <div className="form1003Title">
                    4b. Other New Mortgage Loans on the Property You are Buying or
                    Refinancing
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <PropertyMortgagesTable editMode={this.state.editMode} />
                    </Row>
                </div>
            </div>
        )
    };
    section4c = () => {
        return (
            <div id="4c">
                <div className="form1003Title">
                    4c. Rental Income on the Property You Want to Purchase (For Purchase Only)
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                checked={
                                    this.props.application.property.propertytype === "twotofourfamily"
                                }
                                preview={!this.state.editMode}
                                className="fontWeight500"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.props.changeMainProperty("twotofourfamily", "propertytype")
                                    } else {
                                        this.props.changeMainProperty("singlefamilydetached", "propertytype")
                                    }
                                }}
                            >
                                This is a 2-4 unit property
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <CheckboxExtended
                                preview={!this.state.editMode}
                                checked={this.props.application.property.occupancy === "investment"}
                                className="fontWeight500"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.props.changeMainProperty("investment", "occupancy")
                                    } else {
                                        this.props.changeMainProperty("principal", "occupancy")
                                    }
                                }}
                            >
                                This is a investment property
                            </CheckboxExtended>
                        </Col>
                    </Row>
                    {this.props.application.property.purpose === "purchase" && (
                        this.props.application.property.occupancy === "investment" ||
                        (this.props.application.property.propertytype === "twotofourfamily" && this.props.application.property.occupancy === "principal")
                    ) && <Row className="mb-4">
                            <Col className="pl-0">
                                {this.inputFieldWithPrefix(
                                    "Expected monthly rental income",
                                    this.props.application.property.purchase
                                        .expectedgrossmonthlyrentalincome,
                                    (e) =>
                                        this.props.changeMainProperty(
                                            e.target.value,
                                            "purchase|expectedgrossmonthlyrentalincome"
                                        ),
                                    "$",
                                    undefined,
                                    true
                                )}
                            </Col>
                            <Col className="pl-0">
                                {this.inputFieldWithPrefix(
                                    "Expected net monthly income",
                                    this.props.application.property.purchase.expectednetmonthlyrentalincome,
                                    (e) =>
                                        this.props.changeMainProperty(
                                            e.target.value,
                                            "purchase|expectednetmonthlyrentalincome"
                                        ),
                                    "$",
                                    undefined,
                                    true
                                )}
                            </Col>
                        </Row>}
                </div>
            </div>
        )
    };
    section4d = () => {
        return (
            <div id="4d">
                <div className="form1003Title">
                    4d. Gifts or Grants You Have Been Given or Will Receive for this Loan
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col className="px-0">
                            <GiftsTable editMode={this.state.editMode} currentView={this.state.currentView} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    sectionS5 = () => {
        return (
            <div id="s5" className="p-4">
                <div className="fontWeight500" style={{ fontSize: 20 }}>
                    Section 5: Declarations
                </div>
                <div>
                    This section asks you specific questions about the property, your
                    funding, and your past financial history
                </div>
            </div>
        )
    };
    section5aDom = (title, data, list) => {
        const link = document.getElementsByClassName('ant-anchor-link-title')
        const flag = false
        for (let index = 0; index < link.length; index++) {

            if (link[index].title === title) {

                for (let i = 0; i < list.length; i++) {
                    if (data[list[i][0]][list[i][1]] === '' || data[list[i][0]][list[i][1]] === null) {
                        link[index].style.color = '#faad14'
                        break
                    } else {
                        link[index].style.color = '#000'
                    }
                }
            }
        }
    }
    section5a = (currentView) => {
        let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
        // this.section5aDom('5a. About this Property and Your Money for this Loan', b,
        //  [['declarations','occupyasprimary'],['declarations','ownershipinterest'],['declarations','propertyowned'],['declarations','titleheld'],['declarations','familyrelationship'],['declarations','downpaymentborrowed'],['declarations','applyingonanother'],['declarations','applyingnewcredit'],['declarations','cleanenergylien']])
        return (
            <div id="5a">
                <div className="form1003Title">
                    5a. About this Property and Your Money for this Loan
                </div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "A. Will you occupy the property as your primary residence?",
                                b.declarations.occupyasprimary ===
                                    "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(e, currentView, "occupyasprimary")
                            )}
                        </Col>
                    </Row>
                    {b.declarations.occupyasprimary ===
                        "yes" && (
                            <Row className="mb-4">
                                <Col className="px-0">
                                    {this.yesNoField(
                                        "Have you had an ownership interest in another property in the last three years?",
                                        b.declarations
                                            .ownershipinterest === "yes"
                                            ? "yes"
                                            : "no",
                                        (e) =>
                                            this.props.changeDeclaration(
                                                e,
                                                currentView,
                                                "ownershipinterest"
                                            )
                                    )}
                                </Col>
                            </Row>
                        )}
                    {b.declarations.occupyasprimary === "yes" && b.declarations.ownershipinterest ===
                        "yes" && (
                            <Row className="mb-4">
                                <Col className="px-0">
                                    {this.horizontalDropdownField(
                                        "(1) What type of property did you own: primary residence (PR), FHA secondary residence (SR), second home (SH), or investment property (IP)?",
                                        b.declarations.propertyowned ===
                                            null
                                            ? ""
                                            : b.declarations
                                                .propertyowned,
                                        [
                                            { value: "", label: "..." },
                                            { value: "principal", label: "Primary residence" },
                                            { value: "secondhome", label: "Second Home" },
                                            { value: "fhasecond", label: "FHA Second Home" },
                                            { value: "investment", label: "Investment property" },
                                        ],
                                        (e) =>
                                            this.props.changeDeclaration(e.target.value, currentView, "propertyowned")
                                    )}
                                </Col>
                            </Row>
                        )}
                    {b.declarations.occupyasprimary === "yes" && b.declarations.ownershipinterest ===
                        "yes" && (
                            <Row className="mb-4">
                                <Col className="px-0">
                                    {this.horizontalDropdownField(
                                        "(2) How did you hold title to the property: by yourself (S), jointly with your spouse (SP), or jointly with another person (O)?",
                                        b.declarations.titleheld ===
                                            null
                                            ? ""
                                            : b.declarations.titleheld,
                                        [
                                            { value: "", label: "..." },
                                            { value: "yourself", label: "By Yourself" },
                                            {
                                                value: "jointwithspouse",
                                                label: "Jointly with Your Spouse",
                                            },
                                            {
                                                value: "jointwithother",
                                                label: "Jointly with Another Person",
                                            },
                                        ],
                                        (e) =>
                                            this.props.changeDeclaration(e.target.value, currentView, "titleheld")
                                    )}
                                </Col>
                            </Row>
                        )}
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "B. If this is a Purchase Transaction: Do you have a family relationship or business affiliation with the seller of the property?",
                                b.declarations
                                    .familyrelationship === "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(
                                        e,
                                        currentView,
                                        "familyrelationship"
                                    )
                            )}
                        </Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "C. Are you borrowing any money for this real estate transaction or obtaining any money from another party, such as the seller or realtor, that you have not disclosed on this loan application?",
                                b.declarations
                                    .downpaymentborrowed === "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(
                                        e,
                                        currentView,
                                        "downpaymentborrowed"
                                    )
                            )}
                        </Col>
                    </Row>
                    {b.declarations.downpaymentborrowed === "yes" && (
                        <Row className="mb-4 align-items-center">
                            <Col md={7}>
                                What is the amount of this money?
                            </Col>
                            <Col md={5} className="px-0">
                                {this.inputFieldWithPrefix(
                                "Amount:",
                                b.declarations.moneyborrowed,
                                (e) =>
                                    this.props.changeDeclaration(e.target.value, currentView, "moneyborrowed"),
                                "$",
                                )}
                            </Col>
                        </Row>
                    )}
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "D. 1. Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application?",
                                b.declarations
                                    .applyingonanother === "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(
                                        e,
                                        currentView,
                                        "applyingonanother"
                                    )
                            )}
                        </Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "D. 2. Have you or will you be applying for any new credit on or before closing this loan that is not disclosed on this application?",
                                b.declarations
                                    .applyingnewcredit === "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(
                                        e,
                                        currentView,
                                        "applyingnewcredit"
                                    )
                            )}
                        </Col>
                    </Row>
                    <hr className="form1003Divider"></hr>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "E. Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid through your property taxes (e.g., the Property Assessed Clean Energy Program)?",
                                b.declarations.cleanenergylien ===
                                    "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(e, currentView, "cleanenergylien")
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    section5b = (currentView) => {
        let chaptersLabelMap = {
            "chapter7": "Chapter 7",
            "chapter11": "Chapter 11",
            "chapter12": "Chapter 12",
            "chapter13": "Chapter 13",
        }
        let questions = [
            [
                "F. Are you a co-signer or guarantor on any debt or loan that is not disclosed on this application?",
                "comakeronnote",
            ],
            ["G. Are there any outstanding judgments against you?", "judgements"],
            [
                "H. Are you currently delinquent or in default on a Federal debt?",
                "delinquentondebt",
            ],
            [
                "I. Are you a party to a lawsuit in which you potentially have any personal financial liability?",
                "lawsuit",
            ],
            [
                "J. Have you conveyed title to any property in lieu of foreclosure in the past 7 years?",
                "conveyedtitle",
            ],
            [
                "K. Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?",
                "loanforeclosure",
            ],
            [
                "L. Have you had property foreclosed upon in the last 7 years?",
                "propertyforeclosure",
            ],
            ["M. Have you declared bankruptcy within the past 7 years?", "bancrupt"],
        ]
        let fields = []
        let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower

        // this.section1aDom('5b. About Your Finances', b,
        // [['declarations','comakeronnote'],['declarations','delinquentondebt'],['declarations','lawsuit'],['declarations','conveyedtitle'],['declarations','loanforeclosure'],['declarations','propertyforeclosure'],['declarations','bancrupt']])

        for (let i = 0; i < questions.length; i++) {
            fields.push(
                <Row className="mb-4">
                    <Col className="px-0">
                        {this.yesNoField(
                            questions[i][0],
                            b.declarations[questions[i][1]] ===
                                "yes"
                                ? "yes"
                                : "no",
                            (e) =>
                                this.props.changeDeclaration(e, currentView, questions[i][1])
                        )}
                    </Col>
                </Row>
            )
            if (i < questions.length - 1) {
                fields.push(<hr className="form1003Divider"></hr>)
            }
        }

        return (
            <div id="5b">
                <div className="form1003Title">5b. About Your Finances</div>
                <div className="px-4 pt-4">{fields}</div>
                {b.declarations.bancrupt === "yes" && <Row className="mb-4 px-4">
                    <Col className="px-0">
                        <div className= "d-flex justify-content-between align-items-center">
                            <div className="mr-2 fontWeight500 col-7 pl-0">Identify the type(s) of bankruptcy</div>
                            {["chapter7", "chapter11", "chapter12", "chapter13"].map(s => (
                                <CheckboxExtended
                                    preview={!this.state.editMode}
                                    checked={b.declarations[s]}
                                    onChange={e => this.props.changeDeclaration(e.target.checked, currentView, s)}
                                    key={s}
                                >
                                    {chaptersLabelMap[s]}
                                </CheckboxExtended>
                            ))}
                        </div>
                    </Col>
                </Row>}

            </div>
        )
    };
    sectionS6 = () => {
        return (
            <div id="s6">
                <div className="p-4">
                    <div className="fontWeight500" style={{ fontSize: 20 }}>
                        Section 6: Acknowledgments and Agreements.
                    </div>
                    <div>
                        This section tells you about your legal obligations when you sign
                        this application.
                    </div>
                </div>
                <div className="form1003Title">Acknowledgments and Agreements</div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col className="px-0">
                            <div className="fontWeight500 mb-3">Definitions:</div>
                            <div>
                                <li>
                                    "Lender" includes the Lender's agents, service providers, and
                                    any of their successors and assigns.{" "}
                                </li>
                                <li>
                                    "Other Loan Participants" includes (i) any actual or potential
                                    owners of a loan resulting from this application (the "Loan"),
                                    (ii) acquirers of any beneficial or other interest in the
                                    Loan, (iii) any mortgage insurer, (iv) any guarantor, (v) any
                                    servicer of the Loan, and (vi) any of these parties' service
                                    providers, successors or assigns.
                                </li>
                            </div>
                            <div className="fontWeight500 my-3">
                                I agree to, acknowledge, and represent the following:
                            </div>
                            <div className="fontWeight500 mb-3">
                                (1) The Complete Information for this Application{" "}
                            </div>
                            <li>
                                The information I have provided in this application is true,
                                accurate, and complete as of the date I signed this application.
                            </li>
                            <li>
                                If the information I submitted changes or I have new information
                                before closing of the Loan, I must change and supplement this
                                application, including providing any updated/supplemented real
                                estate sales contract.{" "}
                            </li>
                            <li>
                                {" "}
                                For purchase transactions: The terms and conditions of any real
                                estate sales contract signed by me in connection with this
                                application are true, accurate, and complete to the best of my
                                knowledge and belief. I have not entered into any other
                                agreement, written or oral, in connection with this real estate
                                transaction
                            </li>
                            <li>
                                The Lender and Other Loan Participants may rely on the
                                information contained in the application before and after
                                closing of the Loan
                            </li>
                            <li>
                                {" "}
                                Any intentional or negligent misrepresentation of information
                                may result in the imposition of:{" "}
                            </li>
                            <div>
                                (a) civil liability on me, including monetary damages, if a
                                person suffers any loss because the person relied on any
                                misrepresentation that I have made on this application, and/or
                            </div>
                            <div>
                                (b) criminal penalties on me including, but not limited to, fine
                                or imprisonment or both under the provisions of Federal law (18
                                U.S.C. §§ 1001 et seq.).
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };
    sectionS7 = (currentView) => {
        let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
        // this.section1aDom('S7. Military Service', b,
        // [['declarations','servearmedforces']])
        let militaryServiceLabelMap = {
            "currentlyserving": "Currently serving on active duty with projected expiration date of service/tour",
            "currentlyretired":"Currently retired, discharged, or separated from service",
            "nonactive": "Only period of service was as a non-activated member of Reserve or National Guard",
            "survivingspouse": "Surviving spouse",
        }
        let changeMilitary = (verb, isdate) =>{
            let m = {...b.declarations.militaryservice}
            return e => {
                let value = isdate ? e.target.value : ""
                if (isdate){
                    if (/^[\d/]*$/.test(value)){
                        let formattedValue = value.replace(/\D/g,'')
                        if (formattedValue.length > 2){
                            formattedValue = formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4) + "/" + formattedValue.slice(4, 8)
                        } else if (formattedValue.length > 2){
                            formattedValue = formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4)
                        }
                        value = formattedValue
                    }
                }
                m[verb] = isdate ? value : e.target.checked
                this.props.changeDeclaration(m, currentView, "militaryservice")
            }
        }

        return (
            <div id="s7">
                <div className="p-4">
                    <div className="fontWeight500" style={{ fontSize: 20 }}>
                        Section 7: Military Service
                    </div>
                    <div>
                        This section asks questions about your (or your deceased spouse's)
                        military service.
                    </div>
                </div>
                <div className="form1003Title">Military Service of Borrower</div>
                <div className="p-4">
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.yesNoField(
                                "Did you (or your deceased spouse) ever serve, or are you currently serving, in the United States Armed Forces?",
                                b.declarations
                                    .servearmedforces === "yes"
                                    ? "yes"
                                    : "no",
                                (e) =>
                                    this.props.changeDeclaration(
                                        e,
                                        currentView,
                                        "servearmedforces"
                                    )
                            )}
                        </Col>
                    </Row>
                    {b.declarations.servearmedforces === "yes" && <Row className="mb-4">
                        <Col className="px-0">
                            <div className="d-flex flex-column">
                                {["currentlyserving", "currentlyretired", "nonactive", "survivingspouse"].map(s => (
                                    <div className="militaryServiceMultiCheckWrap" style={{display: s==="currentlyserving" ? "flex" : ""}}>
                                        <CheckboxExtended
                                            preview={!this.state.editMode}
                                            checked={b.declarations.militaryservice[s]}
                                            onChange={changeMilitary(s)}
                                            key={s}
                                            className="mb-2 w-100"
                                        >
                                            {militaryServiceLabelMap[s]}
                                        </CheckboxExtended>
                                        {s === "currentlyserving" && b.declarations.militaryservice.currentlyserving &&
                                            <div>
                                                <Input
                                                    value={b.declarations.militaryservice.projectedexpirationdate}
                                                    type="text"
                                                    placeholder="MM/DD/YYYY"
                                                    style={{width:"200px", marginLeft:"20px", marginBottom:"10px"}}
                                                    onChange={changeMilitary("projectedexpirationdate", true)}

                                                />
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>}
                </div>
            </div>
        )
    };
    sectionS8 = (currentView) => {
        let b = currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower
        let who = currentView === "borrower" ? "borrower" : "coborrower"
        let ethnicityOptions = [
            {key: "mexican", label: "Mexican"},
            {key: "puertorican", label: "Puerto Rican"},
            {key: "cuban", label:"Cuban"},
            {key: "other", label: "Other Hispanic or Latino"}
        ]
        let asianRaceOptions = [
            {key: "asianindian", label: "Asian Indian"},
            {key: "chinese", label: "Chinese"},
            {key: "filipino", label: "Filipino"},
            {key: "japanese", label: "Japanese"},
            {key: "korean", label: "Korean"},
            {key: "vietnamese", label: "Vietnamese"},
            {key: "otherasian", label: "Other Asian"}
        ]
        let pacificRaceOptions = [
            {key: "hawaian", label: "Native Hawaian"},
            {key: "guamanian", label: "Guamanian or Chamorro"},
            {key: "samoan", label: "Samoan"},
            {key: "other", label: "Other Pacific Islander"},
        ]
        let raceDetailsMap = {
            "asian": asianRaceOptions,
            "pacific": pacificRaceOptions,
            "americanindian": [],
            "black": [],
            "white": [],
            "notfurnished": [],
        }
        let raceOptions = [
            {key: "americanindian", label:"American Indian or Alaska Native"},
            {key: "asian", label: "Asian"},
            {key: "black", label: "Black or African American"},
            {key: "pacific", label: "Native Hawaiian or Other Pacific Islander"},
            {key: "white", label: "White"},
            {key: "notfurnished", label: "I do not wish to provide this information"},
        ]

        const getRace = () => {
            let r = currentView === "borrower" ? this.props.application.borrower.equalopportunity.race : this.props.application.coborrower.equalopportunity.race
            if (r.asian) {
                return "asian"
            } else if (r.black) {
                return "black"
            } else if (r.pacific) {
                return "pacific"
            } else if (r.white) {
                return "white"
            } else if (r.americanindian) {
                return "americanindian"
            } else if (r.notfurnished) {
                return "notfurnished"
            }
            return ""
        }

        const onOtherHispanic = (event) => {
            com.touch()

            this.props.updateEqualOpportunitySub(event.target.value, who, "hispanic", "otherdesctiption")
        }

        const onOtherAsian = (event) => {
            com.touch()

            this.props.updateEqualOpportunitySub(event.target.value, who, "race|asiandetails", "otherdesctiption")
        }

        const onPacific = (event) => {
            com.touch()

            this.props.updateEqualOpportunitySub(event.target.value, who, "race|pacificdetails", "otherdetails")
        }

        let onTribe = (event) => {
            com.touch()
            this.props.updateEqualOpportunitySub(event.target.value, who, "race", "indiantribe")
        }

        const updateEqualOpportunityCheck = (who, section, verb) =>{
            return e => {
                com.touch()

                const ischecked = e.target.checked
                this.props.updateEqualOpportunitySub(ischecked, who, section, verb)

                if (section === 'race') {
                    if (verb === 'notfurnished') {
                        if (ischecked) {
                            const clearOthers = {
                                asian: false,
                                pacific: false,
                                americanindian: false,
                                black: false,
                                white: false,
                                notfurnished: true
                            }
                            Object.entries(clearOthers).forEach(([key, value]) => {
                                this.props.updateEqualOpportunitySub(
                                    value,
                                    who,
                                    section,
                                    key
                                )
                            })
                        }
                    } else {
                        if (ischecked) {
                            this.props.updateEqualOpportunitySub(false, who, section, 'notfurnished')
                        }
                    }
                }
            }
        }

        const getEthnicityOptions = () => {
            const options = ethnicityOptions.map(e => {
                if (e.key !== "other"){
                    return <div className="mb-4 multiCheckboxWrapper">
                        <CheckboxExtended
                            preview={!this.state.editMode}
                            checked = {b.equalopportunity.hispanic[e.key]}
                            className="fontWeight500"
                            onChange={updateEqualOpportunityCheck(currentView, "hispanic", e.key)}
                        >
                            {e.label}
                        </CheckboxExtended>
                    </div>
                }
            })
            options.push(
                <div className="d-flex justify-content-start w-100">
                    <div className="mb-4 multiCheckboxWrapper">
                        <CheckboxExtended
                            checked = {
                                b.equalopportunity.hispanic.other
                            }
                            preview={!this.state.editMode}
                            className="fontWeight500 w-100"
                            onChange={updateEqualOpportunityCheck(currentView, "hispanic", "other")}
                        >
                            Other Hispanic or Latino
                        </CheckboxExtended>
                    </div>
                    {b.equalopportunity.hispanic.other && (
                        <div style={{ marginLeft: "20px", width: "calc((100% - 40px) / 3)" }}>
                            <Input
                                className="otherEthinicityInput"
                                value={b.equalopportunity.hispanic.otherdesctiption}
                                type="text"
                                placeholder="Chilean, Perivuan, and so on."
                                onChange={onOtherHispanic}
                            />
                        </div>
                    )}
                </div>
            )
            return options
        }

        const getRaceOptions = () => {
            let options = raceOptions.map(e =>{
                return <>
                    <Row className={`multiCheckboxWrapperVertical ${this.state.editMode ? 'multiCheckboxWrapperVertical-hover' : ''}`}>
                        <CheckboxExtended
                            preview={!this.state.editMode}
                            checked = {b.equalopportunity.race[e.key]}
                            className="fontWeight500 w-100"
                            onChange={updateEqualOpportunityCheck(currentView, "race", e.key)}
                        >
                            {e.label}
                        </CheckboxExtended>
                    </Row>
                    <Row className="mt-4">
                        {getRaceDetails(b.equalopportunity.race[e.key], e.key)}
                    </Row>
                </>
            })
            return options
        }

        const getRaceDetails = (checked, type) => {
            if (checked){
                if (type === "americanindian") {
                    return <Col md={12} xs={12} className="d-flex align-items-center mb-4">
                        <div className="mr-2">Print name of enrolled or principal tribe </div>
                        {this.state.editMode ? <Input
                            value={b.equalopportunity.race.indiantribe}
                            type="text"
                            style={{width:"220px"}}
                            onChange={onTribe}
                        /> : <span>{b.equalopportunity.race.indiantribe}</span>}
                    </Col>
                } else if (type !== "americanindian" && raceDetailsMap[type].length === 0) {
                    return ""
                } else {
                    let options = raceDetailsMap[type].map(e => {
                        if (e.key === "otherasian" || e.key === "other") {
                            return <Col md={12} xs={12} className="d-flex align-items-center mb-4">
                                <CheckboxExtended
                                    checked = {
                                        e.key === "otherasian"?
                                        b.equalopportunity.race.asiandetails.otherasian :
                                        b.equalopportunity.race.pacificdetails.other
                                    }
                                    preview={!this.state.editMode}
                                    className="fontWeight500"
                                    onChange={
                                        e.key === "otherasian"?
                                        updateEqualOpportunityCheck(currentView, "race|asiandetails", e.key) :
                                        updateEqualOpportunityCheck(currentView, "race|pacificdetails", e.key)
                                    }
                                >
                                    {e.label}
                                </CheckboxExtended>
                               {this.state.editMode ?  <Input
                                    value={
                                        e.key === "otherasian" ?
                                        b.equalopportunity.race.asiandetails.otherdesctiption :
                                        b.equalopportunity.race.pacificdetails.otherdetails
                                    }
                                    type="text"
                                    placeholder={
                                        e.key === "otherasian" ?
                                        "Hmong, Laotian, and so on..." :
                                        "Fijian, Tongan, and so on..."
                                    }
                                    style={{width: "220px"}}
                                    onChange={
                                        e.key === "otherasian" ?
                                        onOtherAsian :
                                        onPacific
                                    }
                                />:  <span style={{fontSize:14,marginLeft:10}}>{e.key === "otherasian" ?
                                        b.equalopportunity.race.asiandetails.otherdesctiption :
                                        b.equalopportunity.race.pacificdetails.otherdetails}</span>}
                            </Col>
                        } else {
                            return <Col md={4} xs={12} className="mb-4">
                                <CheckboxExtended
                                    checked = {
                                        type === "asian" ?
                                        b.equalopportunity.race.asiandetails[e.key] :
                                        b.equalopportunity.race.pacificdetails[e.key]
                                    }
                                    preview={!this.state.editMode}
                                    className="fontWeight500"
                                    onChange={
                                        type === "asian" ?
                                        updateEqualOpportunityCheck(currentView, "race|asiandetails", e.key) :
                                        updateEqualOpportunityCheck(currentView, "race|pacificdetails", e.key)
                                    }
                                >
                                    {e.label}
                                </CheckboxExtended>
                            </Col>
                        }
                    })
                    return options
                }
            } else {
                return ""
            }

        }

        this.section1aDom('S8. Demographic Information', b,
            [['equalopportunity', 'ethnicity'], ['equalopportunity', 'sex'], ['equalopportunity', getRace()]])
        return (
            <div id="s8">
                <div className="p-4">
                    <div className="fontWeight500" style={{ fontSize: 20 }}>
                        Section 8: Demographic Information
                    </div>
                    <div>This section asks about your ethnicity, sex, and race.</div>
                </div>
                <div className="form1003Title">Demographic Information of Borrower</div>
                <div className="p-4">
                    <div style={{ position: 'relative'}}>
                        <Row className="mb-4">
                            <Col className="px-0">
                                {this.ethnicityField(
                                    b.equalopportunity.ethnicity,
                                    (e) => this.props.updateEqualOpportunity(e, currentView, "ethnicity"),
                                    getEthnicityOptions()
                                )}
                            </Col>
                        </Row>
                    </div>
                    <Row className="mb-4">
                        <Col className="px-0">
                            {this.selectionField(
                                "Sex",
                                b.equalopportunity.sex,
                                [
                                    { value: "female", label: "Female" },
                                    { value: "male", label: "Male" },
                                    { value: "other", label: "Other" },
                                    { value: "donttell", label: "I do not wish to provide this information" },
                                ],
                                (e) => this.props.updateEqualOpportunity(e, currentView, "sex"),
                                false,
                                true
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <div className="d-flex flex-column w-100">
                            <div className="mb-3">Race</div>
                            {getRaceOptions()}
                        </div>
                    </Row>
                </div>
            </div>
        )
    };

    sectionS9 = () => {
        let b = this.props.application.brokerinfo

        this.section1aDom('S9. Loan Originator Information (to be completed by the loan originator)', b,
            ["name", "nmls", "licenseid", "loanofficername", "loanofficernmls", "loanofficerlicenseid", "email", "phone"])

        const onBrokerAddressCompletion = (address) => {
            let num = com.getSubaddress(address, "street_number", "long_name")

            let city = com.getSubaddress(address, "locality", "long_name")
            let state = com.getSubaddress(
                address,
                "administrative_area_level_1",
                "short_name"
            )
            let zip = com.getSubaddress(address, "postal_code", "long_name")

            let county = com.getSubaddress(
                address,
                "administrative_area_level_2",
                "long_name"
            )
            let longstate = com.getSubaddress(
                address,
                "administrative_area_level_1",
                "long_name"
            )

            this.props.updateBrokerInfo(city, "city")
            this.props.updateBrokerInfo(county, "county")
            this.props.updateBrokerInfo(com.capitalize(com.convertAbbStateToFull(state)), "state")
            this.props.updateBrokerInfo(zip, "zip")
            let short = com.getSubaddress(address, "route", "short_name")

            let stradd = num + " " + short
            this.props.updateBrokerInfo(stradd, "street")
        }

        return (
            <div id="s9">
                <div className="p-4">
                    <div className="fontWeight500" style={{ fontSize: 20 }}>
                        Section 9: Loan Originator Information
                    </div>
                    <div>
                        To be completed by the loan originator.
                    </div>
                </div>
                <div className="form1003Title">Loan Originator Information</div>
                <div className="p-4">
                    <Row>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Loan originator organization name",
                                b.name,
                                (e) => this.props.updateBrokerInfo(e.target.value, "name")
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Loan originator organization NMLSR ID",
                                b.nmls,
                                (e) => this.props.updateBrokerInfo(e.target.value, "nmls")
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "State license ID",
                                b.licenseid,
                                (e) => this.props.updateBrokerInfo(e.target.value, "licenseid")
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-2">
                            {this.state.editMode ? <AddressAutocomplete
                                id="brokerAddress"
                                border={true}
                                style={b.street === "" && this.state.companyInfo.companyAddressstreet === "" && this.props.mode !== 'document' ? { border: '1px solid #faad14' } : {}}
                                label={<div className="fontWeight500">Address</div>}
                                required={true}
                                name="addessline"
                                defaultValue={b.street}
                                onChange={(e) => this.props.updateBrokerInfo(e.target.value, "street")}
                                pattern="^[0-9]+\s[\p{L}\p{N} !:,&()'?#+\/@-]+$"
                                placeholder="Please choose from the suggested addresses generated based on the input."
                                goodfeedback="Looks good!"
                                badfeedback="Please provide your street address."
                                size="md"
                                onCompletion={e => onBrokerAddressCompletion(e)}
                            /> : <div className="fontSize16">{b.street}</div>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mb-4">
                            {this.dropdownField(
                                "State",
                                b.state,
                                this.getStateOptions(),
                                (e) => this.props.updateBrokerInfo(e.target.value, "state")
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "City",
                                b.city,
                                (e) => this.props.updateBrokerInfo(e.target.value, "city"),
                                null,
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Zip",
                                b.zip,
                                (e) => this.props.updateBrokerInfo(e.target.value, "zip"),
                                null,
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Loan originator name",
                                b.loanofficername,
                                (e) => this.props.updateBrokerInfo(e.target.value, "loanofficername")
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Loan originator NMLSR ID",
                                b.loanofficernmls,
                                (e) => this.props.updateBrokerInfo(e.target.value, "loanofficernmls")
                            )}
                        </Col>
                        <Col md={4} className="mb-4">
                            {this.inputField(
                                "Loan originator state license ID",
                                b.loanofficerlicenseid,
                                (e) => this.props.updateBrokerInfo(e.target.value, "loanofficerlicenseid")
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="mb-4">
                            {this.inputField(
                                "Email",
                                b.email,
                                (e) => this.props.updateBrokerInfo(e.target.value, "email")
                            )}
                        </Col>
                        <Col md={6} className="mb-4">
                            {this.inputField(
                                "Phone",
                                com.fixPhoneInput(b.phone),
                                (e) => {
                                    let phone = com.fixPhoneInput(e.target.value)
                                    this.props.updateBrokerInfo(phone, "phone")
                                }
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    };



    updateAnchorActiveState = (activeKey) => {
        // 移除所有锚点的active类
        const allAnchorLinks = document.querySelectorAll('.ant-anchor-link')
        allAnchorLinks.forEach(link => {
            link.classList.remove('ant-anchor-link-active')
        })
        
        // 为当前激活的锚点添加active类
        const activeAnchor = document.querySelector(`[href="#${activeKey}"]`)
        if (activeAnchor) {
            const anchorLink = activeAnchor.closest('.ant-anchor-link')
            if (anchorLink) {
                anchorLink.classList.add('ant-anchor-link-active')
            }
        }
    }
    setOffsetTop = () => {
        const screenWidth = window.innerWidth || document.documentElement.clientWidth

        let offsetTop

        if (screenWidth >= 1200) {
            offsetTop = 63
        } else if (screenWidth >= 768) {
            offsetTop = 107
        } else {
            offsetTop = 107 // 默认值
        }

        this.setState({ offsetTop })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.view !== this.props.view) {
            this.setState({ currentView: this.props.view || 'borrower' })
        }
        if (!prevState.loading && this.state.loading) {
            if (this.props.targetHref) {
                this.scrollToAnchor(this.props.targetHref)
            }
        }
        
        // 如果loading状态变为false且还没有设置Intersection Observer，则设置它
        if (prevState.loading && !this.state.loading && !this.intersectionObserver) {
            console.log('Loading finished, setting up Intersection Observer...')
            setTimeout(() => {
                this.setupIntersectionObserver()
            }, 100)
        }
    }


    componentWillUnmount() {
        // 清理 Intersection Observer
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect()
        }
        window.removeEventListener('resize', this.setOffsetTop)
    }

    convertIncome(who) {
        let whoseincome = this.props.application[who].occupation.income
        let all = ["base", "overtime", "bonuses", "commissions", "military", "other"]
        for (let t of all) {
            if (whoseincome[t + "monthly"] === "yearly") {
                let monthlyincome = Math.round(parseFloat(whoseincome[t]) / 12).toFixed(0)
                this.updateIncomeMonthly(monthlyincome, who, t)
                this.updateIncomeMonthly("monthly", who, t + "monthly")
            }
        }

        if (this.props.application[who].occupation.incomeorlossperiod === "yearly") {
            let monthlyincome = Math.round(parseFloat(this.props.application[who].occupation.incomeorloss) / 12).toFixed(0)
            this.props.changeOccupationInfoByValue(monthlyincome, who, "incomeorloss")
            this.props.changeOccupationInfoByValue("monthly", who, "incomeorlossperiod")
        } else if (this.props.application[who].occupation.incomeorlossperiod === "") {
            this.props.changeOccupationInfoByValue("monthly", who, "incomeorlossperiod")
        }

        let otherIncome = this.props.application[who].otheroccupations
        if (otherIncome !== null && otherIncome !== undefined) {
            for (let i = 0; i < otherIncome.length; i++) {
                let income = otherIncome[i]
                if (income.incomeorlossperiod === "yearly") {
                    let monthlyincome = Math.round(parseFloat(income.incomeorloss) / 12).toFixed(0)
                    this.props.changeBorrowerOtherOccupationValue(monthlyincome, i, who, "incomeorloss")
                    this.props.changeBorrowerOtherOccupationValue("monthly", i, who, "incomeorlossperiod")
                }
                for (let t of all) {
                    let income = otherIncome[i].income
                    if (income[t + "monthly"] === "yearly") {
                        let monthlyincome = Math.round(parseFloat(income[t]) / 12).toFixed(0)
                        this.props.changeBorrowerOtherOccupationIncome(monthlyincome, i, who, t)
                        this.props.changeBorrowerOtherOccupationIncome("monthly", i, who, t + "monthly")
                    }
                }
            }
        }

    }
    
    // 更新 insurancemaintenancetaxes 字段，使其等于四个子字段的总和
    updateInsuranceMaintenancetaxes = () => {
        const property = this.props.application.property
        const insurance = parseFloat(property.insurancemain) || 0
        const tax = parseFloat(property.insurancetax) || 0
        const hoa = parseFloat(property.insurancehoa) || 0
        const pmi = parseFloat(property.insurancepmi) || 0
        const total = insurance + tax + hoa + pmi
        
        // 更新 insurancemaintenancetaxes 字段
        this.props.changeMainProperty(total, "insurancemaintenancetaxes")
    }
    
    // 使用新值更新 insurancemaintenancetaxes 字段，避免异步更新问题
    updateInsuranceMaintenancetaxesWithNewValue = (fieldName, newValue) => {
        const property = this.props.application.property
        let insurance = parseFloat(property.insurancemain) || 0
        let tax = parseFloat(property.insurancetax) || 0
        let hoa = parseFloat(property.insurancehoa) || 0
        let pmi = parseFloat(property.insurancepmi) || 0
        
        // 使用新值替换对应字段的当前值
        switch (fieldName) {
            case "insurancemain":
                insurance = newValue
                break
            case "insurancetax":
                tax = newValue
                break
            case "insurancehoa":
                hoa = newValue
                break
            case "insurancepmi":
                pmi = newValue
                break
            default:
                break
        }
        
        const total = insurance + tax + hoa + pmi
        
        // 更新 insurancemaintenancetaxes 字段
        this.props.changeMainProperty(total, "insurancemaintenancetaxes")
    }
    
    // 更新 owned properties 中的 insurancemaintenancetaxes 字段
    updateInsuranceMaintenancetaxesForProperty = (propertyIndex, fieldName, newValue) => {
        const currentView = this.state.currentView
        const properties = this.props.application[currentView].ownedproperties
        const property = properties[propertyIndex]
        
        let insurance = parseFloat(property.insurancemain) || 0
        let tax = parseFloat(property.insurancetax) || 0
        let hoa = parseFloat(property.insurancehoa) || 0
        
        // 使用新值替换对应字段的当前值
        switch (fieldName) {
            case "insurancemain":
                insurance = newValue
                break
            case "insurancetax":
                tax = newValue
                break
            case "insurancehoa":
                hoa = newValue
                break
            default:
                break
        }
        
        const total = insurance + tax + hoa
        
        // 更新 insurancemaintenancetaxes 字段
        // 注意：这里不能直接调用 changeAttribute，因为它是在 renderOwnedProperty 方法中定义的局部函数
        // 我们需要通过 props 中的方法来更新
        this.props.changeMainPropertyAttribute(total, propertyIndex, "insurancemaintenancetaxes")
    }
    
    scrollToAnchor = (href) => {
        const escapeSelector = (selector) => {
            return selector.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1')
        }
        const retryScroll = (attempts) => {
            const safeHref = escapeSelector(href)
            const target = document.querySelector(safeHref)
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' })
                // 更新activeKey以保持同步
                const anchorId = href.replace('#', '')
                if (this.state.activeKey !== anchorId) {
                    this.setState({ activeKey: anchorId })
                }
            } else if (attempts > 0) {
                setTimeout(() => retryScroll(attempts - 1), 100)
            } else {
                window.location.hash = href
            }
        }
    
        retryScroll(5)
    }
    componentDidMount() {
        this.props.updateStatus("initial")
        this.getLoanLimits()
        // this.getXml()
        this.getCreditReport()
        const {currentStage,currentStatus} = this.props.application;
        if((currentStage===st.LS_Disposed||currentStatus===st.LS_LoanFunded) && !checkAccess([st.UR_Owner,st.UR_LoanOfficerManager])){
            this.setState({editMode: false})
        }
        if (this.props.application.borrower.occupation.hasoccupation === null) {
            this.props.changeOccupationInfoByValue("employed", "borrower", "hasoccupation")
        }
        if (this.props.application.coborrower.occupation.hasoccupation === null) {
            this.props.changeOccupationInfoByValue("employed", "coborrower", "hasoccupation")
        }

        if (this.props.application.borrower.dependentsages === "") {
            if (this.props.application.borrower.numberofdependents !== "") {
                const numberOfDependents = parseInt(this.props.application.borrower.numberofdependents, 10);
                if (!isNaN(numberOfDependents) && numberOfDependents > 0) {
                    const newDependentAges = Array(numberOfDependents).fill(" ");
                    this.setState({ bodependentages: newDependentAges });
                }
            } else {
                this.setState({ bodependentages: [] });
            }
        } else {
            const newDependentAges = this.props.application.borrower.dependentsages.split(',').map(age => age.trim());
            this.setState({ bodependentages: newDependentAges});
        }

        if (this.props.application.coborrower.dependentsages === "") {
            if (this.props.application.coborrower.numberofdependents !== "") {
                const numberOfDependents = parseInt(this.props.application.coborrower.numberofdependents, 10);
                if (!isNaN(numberOfDependents) && numberOfDependents > 0) {
                    const newDependentAges = Array(numberOfDependents).fill(" ");
                    this.setState({ codependentages: newDependentAges });
                }
            } else {
                this.setState({ codependentages: [] });
            }
        } else {
            const newDependentAges = this.props.application.coborrower.dependentsages.split(',').map(age => age.trim());
            this.setState({ codependentages: newDependentAges});
        }


        if (this.props.handingOff) {
            this.setState({ loading: true })
            let state = deepcopy({ borrower: this.props.borrower, application: this.props.application })
            let previousState = JSON.parse(sessionStorage.getItem("originalstate"))
            let token = window.sessionStorage.getItem("ZeitroA")
            let pathname = window.location.pathname
            let loanid = pathname.substring(pathname.lastIndexOf('/') + 1)
            let { id } = state.borrower
            if (id === "")
                return
            return new Promise((resolve, reject) => {
                fetch("/los/borrowerstate/" + id + "/" + loanid, {
                    cache: 'no-cache',
                    method: 'GET',
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache"
                    },
                }).then(response => {
                    if (!response.ok) {
                    } else {
                        response.json().then(js => {
                            if (js.Status !== "OK") {
                                console.log("State Update Error: " + js.Status)
                                reject('rejected')
                            } else {
                                //console.log("State Update Success: " + js.Status)
                                //debugger
                                mergeState(id, js.Text, state, previousState)
                                resolve('resolved')
                                this.getCompanyProfile()
                                this.getLOProfile()
                                if (this.props.application.borrower.email === "") {
                                    let email = sessionStorage.getItem("email")
                                    if (email !== null && email !== "undefined") {
                                        this.props.changeBorrowerInfo({target: {value: email}}, "borrower", "email")
                                    } else {
                                        this.props.changeBorrowerInfo({target: {value: ""}}, "borrower", "email")
                                    }
                                }
                            }
                        })
                    }
                }).catch(error => {
                })
            })
        } else {
            this.getCompanyProfile()
            this.getLOProfile()
            if (this.props.application.borrower.email === "") {
                let email = sessionStorage.getItem("email")
                if (email !== null && email !== "undefined") {
                    this.props.changeBorrowerInfo({target: {value: email}}, "borrower", "email")
                } else {
                    this.props.changeBorrowerInfo({target: {value: ""}}, "borrower", "email")
                }
            }

        }


        if (this.props.application.borrower.income.hasdividends === null) {
            this.props.updateIncomeAtttribute(false, "borrower", "hasdividends")
        }
        if (this.props.application.assetsandliabilities.ownedproperties === null) {
            this.props.clearBorrowerOwnedProperty()
        }

        // convert yearly income to monthly income
        this.convertIncome("borrower")
        this.convertIncome("coborrower")


        this.setOffsetTop()
        window.addEventListener('resize', this.setOffsetTop)
        
        // 延迟设置 Intersection Observer，确保DOM已加载
        setTimeout(() => {
            console.log('Setting up Intersection Observer...')
            this.setupIntersectionObserver()
            // 初始化高亮状态
            this.updateAnchorActiveState(this.state.activeKey)
        }, 1000)
    }
    tabItems = [
        { key: 's1', title: 'S1. Borrower Information' },
        { key: '1a', title: "1a. Personal Information" },
        { key: '1b', title: '1b. Current Employment/Self-Employment and Income' },
        { key: '1c', title: '1c. Additional Employment/Self-Employment and Income' },
        { key: '1d', title: '1d. Previous Employment/Self-Employment and Income' },
        { key: '1e', title: '1e. Income from Other Sources' },
        { key: 's2', title: 'S2. Financial Information' },
        { key: '2a', title: '2a. Assets' },
        { key: '2b', title: '2b. Other Assets and Credits You Have' },
        { key: '2c', title: '2c. Liabilities – Credit Cards, Other Debts, and Leases that You Owe' },
        { key: '2d', title: '2d. Other Liabilities and Expenses' },
        { key: 's3', title: 'S3. Financial Information — Real Estate' },
        { key: '3a', title: '3a. Property You Own' },
        { key: '3b', title: '3b. Additional Property' },
        { key: '3c', title: '3c. Additional Property' },
        { key: 's4', title: 'S4. Loan and Property Information' },
        { key: '4a', title: '4a. Loan and Property Information' },
        { key: '4b', title: '4b. Other New Mortgage Loans on the Property' },
        { key: '4c', title: '4c. Rental Income on the Property' },
        { key: '4d', title: '4d. Gifts or Grants' },
        { key: 's5', title: 'S5. Declarations.' },
        { key: '5a', title: '5a. About this Property and Your Money for this Loan' },
        { key: '5b', title: '5b. About Your Finances' },
        { key: 's6', title: 'S6. Acknowledgments and Agreements' },
        { key: 's7', title: 'S7. Military Service' },
        { key: 's8', title: 'S8. Demographic Information' },
        { key: 's9', title: 'S9. Loan Originator Information' },
        { key: 'lenderLoanForm', title: 'Lender Loan Information'},
        { key: 'L1', title: 'L1. Property & Loan Info'},
        { key: 'L2', title: 'L2. Title Info'},
        { key: 'L3', title: 'L3. Mortgage Loan Info'},
        { key: 'L4', title: 'L4. Qualifying the Borrower'},
    ]
    getCreditReport = async () => {
        let token = sessionStorage.getItem("ZeitroA")
        const urlParams = window.location.pathname.replace('/app/borrower/', '')
        const response = await fetch(`/api/v1/credit/getReports?loanId=${encodeURIComponent(urlParams)}`, {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        const { code, data, errMessage } = await response.json()
        if (code !== 0) {
            alert(errMessage)
            return

        } else {
            if (data.length > 0) {
                this.setState({ requestedTime: data[0].createdAt })
                const creditReport = data[0]
                this.setCreditReport(creditReport)
            }

        }
    }
    setCreditReport = (data) => {
        const { currentView } = this.state
        let liabilities = data.liabilities || []
        // if (currentView === 'borrower') {
        //     liabilities = liabilities.filter(item => item.ownership !== 'CoBorrower')
        // } else if (currentView === 'coborrower') {
        //     liabilities = liabilities.filter(item => item.ownership !== 'Borrower')
        // }
        this.setState({ creditLiability: liabilities })
    }
    setXml = (xml) => {
        var parser = new DOMParser()
        var xmlDoc = parser.parseFromString(xml, 'text/xml')
        const CREDIT_LIABILITIES = xmlDoc.getElementsByTagName("CREDIT_LIABILITIES")
        const liability = CREDIT_LIABILITIES.length > 0 ? xmlDoc.getElementsByTagName("CREDIT_LIABILITIES")[0].childNodes : []
        this.getSummary(liability)
    }
    getXml = async () => {
        const urlParams = window.location.pathname.replace('/app/borrower/', '')
        let token = sessionStorage.getItem("ZeitroA")
        this.setState({ creditReportLoading: true })
        const response = await fetch(`/los/getcreditreport/${urlParams}`, {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        })
        const { Error, Status, CreditReports } = await response.json()
        // setTimeout(() => {
        //     this.setXml(mockXML.CreditReportXML)
        //     this.setState({ creditReportLoading: false })
        // }, 2000)
        // return
        if (Status === 'Error') {
            alert('An unexpected error occurred. Please try again later.')
        } else {
            if (CreditReports.length !== 0) {
                this.setXml(CreditReports[0].CreditReportXML)
                this.setState({ requestedTime: CreditReports[0].RequestedTime })
                this.setState({ creditReportLoading: false })
            }

        }
    }
    getSummary = (to) => {
        const CREDIT_LIABILITY = Array.from({ length: to.length }, () => {
            return {
                Category: '',
                Type: '',
                CompanyName: '',
                Count: '',
                Balance: '',
                Payment: "",
                Status: '',
                Ownership: ''
            }
        })

        for (let i = 0; i < to.length; i++) {
            const content = to[i].childNodes

            for (let j = 0; j < content.length; j++) {
                const creditor = content[j].childNodes
                //category
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityAccountType') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Category = creditor[k].innerHTML
                        }
                    }
                }
                //account type
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLoanType') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Type = creditor[k].innerHTML
                        }
                    }
                }
                //name
                if (content[j].tagName === 'CREDIT_LIABILITY_CREDITOR') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'NAME') {
                            CREDIT_LIABILITY.find((item, index) => index === i).CompanyName = creditor[k].children[0].innerHTML
                        }
                    }
                }
                //count
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityAccountIdentifier') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Count = creditor[k].innerHTML
                        }
                    }
                }
                //balance
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityUnpaidBalanceAmount') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Balance = creditor[k].innerHTML
                        }
                    }
                }
                //payment
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityMonthlyPaymentAmount') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Payment = creditor[k].innerHTML
                        }
                    }
                }
                //status
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityAccountStatusType') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Status = creditor[k].innerHTML
                        }
                    }
                }
                //ownership
                if (content[j].tagName === 'CREDIT_LIABILITY_DETAIL') {

                    for (let k = 0; k < creditor.length; k++) {
                        if (creditor[k].tagName === 'CreditLiabilityAccountOwnershipType') {
                            CREDIT_LIABILITY.find((item, index) => index === i).Ownership = creditor[k].innerHTML
                        }
                    }
                }

            }
        }
        const validOwnershipTypes = [
            'Borrower',
            'Co-Borrower',
            // 'Co-Signer',
            // 'Individual',
            // 'Maker'
        ]
    
        const filteredCreditLiability = CREDIT_LIABILITY.filter(liability => 
            validOwnershipTypes.includes(liability.Ownership) || 
            (liability.Ownership && liability.Ownership.toLowerCase().includes('joint'))
        )
        this.setState({ creditLiability: filteredCreditLiability })
    }
    render = () => {

        const items = [
            {
                label: (
                    <a
                        rel="noopener noreferrer"
                        onClick={() => {
                            this.setState({ editMode: true })
                            sessionStorage.setItem("edit", "false")
                        }}
                    >
                        editing
                    </a>
                ),
                key: "0",
            },
            {
                label: (
                    <a
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ editMode: false })}
                    >
                        viewing
                    </a>
                ),
                key: "1",
            },
        ]
        const tabsChange = (key) => {
            document.getElementById(`${key}`).scrollIntoView()
            window.scrollTo({
                top: window.scrollY - 340,
            })
            // 更新activeKey以保持同步
            if (this.state.activeKey !== key) {
                this.setState({ activeKey: key })
            }
        }

        let borrowerName = this.props.application.borrower.firstname + " " + this.props.application.borrower.lastname
        let coborrowerName = this.props.application.coborrower.firstname !== "" ? this.props.application.coborrower.firstname + " " + this.props.application.coborrower.lastname : "Coborrower"

        const showSavingStatus = () => {
            switch (this.props.status) {
                case "saving":
                    return <div className="mr-3"><Spin active className="mr-1" />Saving</div>
                    break
                case "saved":
                    return <div className="mr-3">Change saved</div>
                    break
                default:
                    return ""
            }
        }
        const flattenArray = (data) => {
            let result = []
            const flatten = (items) => {
                items.forEach(item => {
                    const { children, title, ...rest } = item
                    result.push({ ...rest, title: title.substring(0, 2) })

                    if (children && children.length > 0) {
                        flatten(children)
                    }
                })
            }
            flatten(data)
            return result
        }
        const previewCancel = () => {
            this.setState({ currentIncome: {type: '', index: ''}})
            this.setState({ IncomeCalModal: false })
        }
        const previewCancelBusiness = () => {
            this.setState({ currentBusinessName: '' })
            this.setState({ BusinessIncomeCalModal: false })
        }
        const updateIncomeCalculation = (selected, startDate) => {
            console.log('updateIncomeCalculation', selected, startDate) 
            if(this.state.currentIncome.type === '1c') {
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.base || 0)), this.state.currentIncome.index, this.state.currentView, "base")
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.overtime || 0)), this.state.currentIncome.index, this.state.currentView, "overtime")
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.bonus || 0)), this.state.currentIncome.index, this.state.currentView, "bonuses")
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.commission || 0)), this.state.currentIncome.index, this.state.currentView, "commissions")
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.military || 0)), this.state.currentIncome.index, this.state.currentView, "military")
                this.props.changeBorrowerOtherOccupationIncome(String(Math.round(selected.amount.other || 0)), this.state.currentIncome.index, this.state.currentView, "other")
                this.props.changeBorrowerOtherOccupationValue(
                    startDate,
                    this.state.currentIncome.index,
                    this.state.currentView,
                    "from"
                )
            } else if(this.state.currentIncome.type === '1d') {
                const totalIncome = Math.round(selected.amount.base || 0) + Math.round(selected.amount.overtime || 0) + Math.round(selected.amount.bonus || 0) + Math.round(selected.amount.commission || 0) + Math.round(selected.amount.military || 0) + Math.round(selected.amount.other || 0)
                this.props.changeBorrowerPreviousOccupationValue(
                    String(totalIncome * 12),
                    this.state.currentIncome.index,
                    this.state.currentView,
                    "income"
                )
                this.props.changeBorrowerPreviousOccupationValue(
                    startDate,
                    this.state.currentIncome.index,
                    this.state.currentView,
                    "from"
                )
            }
        }
        const updateBusinessIncomeCalculation = (income) => {
            console.log('updateBusinessIncomeCalculation', income)
            if(this.state.currentIncome.type === '1c') {
                this.props.changeBorrowerOtherOccupationValue(
                    income,
                    this.state.currentIncome.index,
                    this.state.currentView,
                    "incomeorloss"
                )
            } else if(this.state.currentIncome.type === '1d') {
                this.props.changeBorrowerPreviousOccupationValue(
                    income,
                    this.state.currentIncome.index,
                    this.state.currentView,
                    "income"
                )
            }
        }
        const menuItems = () => {
            let list = [
                {
                    key: '1',
                    href: '#s1',
                    title: 'S1. Borrower Information',
                    children: [
                        {
                            key: '2',
                            href: '#1a',
                            title: '1a. Personal Information',
                        },
                        {
                            key: '3',
                            href: '#1b',
                            title: '1b. Current Employment/Self-Employment and Income',
                        },
                        {
                            key: '4',
                            href: '#1c',
                            title: '1c. Additional Employment/Self-Employment and Income',
                        },
                        {
                            key: '5',
                            href: '#1d',
                            title: '1d. Previous Employment/Self-Employment and Income',
                        },
                        {
                            key: '6',
                            href: '#1e',
                            title: '1e. Income from Other Sources',
                        },

                    ]
                },
                {
                    key: '7',
                    href: '#s2',
                    title: 'S2. Financial Information',
                    children: [
                        {
                            key: '8',
                            href: '#2a',
                            title: '2a. Assets',
                        },
                        {
                            key: '9',
                            href: '#2b',
                            title: '2b. Other Assets and Credits You Have',
                        },
                        {
                            key: '10',
                            href: '#2c',
                            title: '2c. Liabilities – Credit Cards, Other Debts, and Leases that You Owe',
                        },
                        {
                            key: '11',
                            href: '#2d',
                            title: '2d. Other Liabilities and Expenses',
                        },


                    ]
                },
                {
                    key: '12',
                    href: '#s3',
                    title: 'S3. Financial Information — Real Estate',
                    children: [
                        {
                            key: '13',
                            href: '#3a',
                            title: '3a. Property You Own',
                        },
                        {
                            key: '14',
                            href: '#3b',
                            title: '3b. Additional Property',
                        },
                        {
                            key: '15',
                            href: '#3c',
                            title: '3c. Additional Property',
                        },



                    ]
                },
                {
                    key: '16',
                    href: '#s4',
                    title: 'S4. Loan and Property Information',
                    children: [
                        {
                            key: '17',
                            href: '#4a',
                            title: '4a. Loan and Property Information',
                        },
                        {
                            key: '18',
                            href: '#4b',
                            title: '4b. Other New Mortgage Loans on the Property',
                        },
                        {
                            key: '19',
                            href: '#4c',
                            title: '4c. Rental Income on the Property',
                        },
                        {
                            key: '99',
                            href: '#4d',
                            title: '4d. Gifts or Grants',
                        },
                    ]
                },
                {
                    key: '20',
                    href: '#s5',
                    title: 'S5. Declarations.',
                    children: [
                        {
                            key: '21',
                            href: '#5a',
                            title: '5a. About this Property and Your Money for this Loan',
                        },
                        {
                            key: '22',
                            href: '#5b',
                            title: '5b. About Your Finances',
                        },
                    ]
                },
                {
                    key: '23',
                    href: '#s6',
                    title: 'S6. Acknowledgments and Agreements',

                },
                {
                    key: '24',
                    href: '#s7',
                    title: 'S7. Military Service',

                },
                {
                    key: '25',
                    href: '#s8',
                    title: 'S8. Demographic Information',

                },
                {
                    key: '26',
                    href: '#s9',
                    title: 'S9. Loan Originator Information (to be completed by the loan originator)',
                },
            ]
            // console.log('------------', localStorage.getItem("configurations"), JSON.parse(localStorage.getItem("configurations"))?.enableLenderLoanInformation)
            if(
                localStorage.getItem("configurations") && JSON.parse(localStorage.getItem("configurations"))?.enableLenderLoanInformation
            ) {
                list.push(                {
                    key: 'LenderLoanForm',
                    href: '#LenderLoanForm',
                    title: 'Lender Loan Information',
                    children: [
                        {
                            key: 'L1',
                            href: '#L1',
                            title: 'L1. Property & Loan Info',
                        },
                        {
                            key: 'L2',
                            href: '#L2',
                            title: 'L2. Title Info',
                        },
                        {
                            key: 'L3',
                            href: '#L3',
                            title: 'L3. Mortgage Loan Info',
                        },
                        {
                            key: 'L4',
                            href: '#L4',
                            title: 'L4. Qualifying the Borrower',
                        },
                    ]   
                })
            }
            return this.props.mode === 'document' ? flattenArray(list) : list
        }

        return (
            <>
            { this.state.loading ? <div className="p-4">
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                </div>
                :
                <div className="text-left">
                    {
                        this.props.mode !== 'document' && (
                            <div className="title1003 title1003-mobile d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center" style={{ fontSize: 16 }}>
                                    {this.props.application.hascoborrower === "withcoborrower" ? "Uniform Residential Loan Application -" : "Uniform Residential Loan Application"}
                                    {/* <div className="mt-4 d-flex justify-content-between align-items-center">
                    <a
                        className="mr-3"
                        style={this.state.currentView === "borrower" ? { color: "#325CEB", textDecoration:"underline"} : {}}
                        onClick = {() => this.setState({currentView: "borrower"})}
                    >
                        {this.props.application.borrower.firstname + " " + this.props.application.borrower.lastname}
                    </a>
                    {this.props.application.hascoborrower && <a
                        onClick = {() => this.setState({currentView: "coborrower"})}
                        style={this.state.currentView === "coborrower" ? { color: "#325CEB", textDecoration:"underline"} : {}}
                    >
                        {this.props.application.coborrower.firstname + " " + this.props.application.coborrower.lastname}
                    </a>}
                    </div> */}
                                    {this.props.application.hascoborrower === "withcoborrower" && <div className="ml-2">
                                        <Select
                                            style={{ fontWeight: 500, minWidth: 150 }}
                                            onChange={(e) => {this.setState({ currentView: e }); this.props.changeView(e)}}
                                            options={[
                                                { label: borrowerName, value: "borrower" },
                                                { label: coborrowerName, value: "coborrower" }
                                            ]}
                                            value={this.state.currentView}
                                        />
                                    </div>}

                                </div>
                                <div className="editing-btn d-flex align-items-center">
                                    {showSavingStatus()}
                                    {this.props.handingOff && this.props.handingOffType === "newaccount" && <Button loading={this.state.handingOff} type="primary" className="mr-3" onClick={() => this.notifyBorrowerAboutNewAccount()}>Notify borrower</Button>}
                                    {this.props.handingOff && this.props.handingOffType === "newloan" && <Button loading={this.state.handingOff} type="primary" className="mr-3" onClick={() => this.notifyBorrowerAboutNewAccount()}>Notify borrower</Button>}
                                    <div>
                                        You are{" "}
                                        <Dropdown
                                            menu={{
                                                items,
                                            }}
                                        >
                                            <a onClick={(e) => e.preventDefault()}>
                                                <Space style={{ color: "#325CEB" }}>
                                                    {this.state.editMode ? "editing" : "viewing"}
                                                    <DownOutlined style={{ color: "#325CEB" }} />
                                                </Space>
                                            </a>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    <div className="loanInterview-tabs-wrap">
                        <Tabs activeKey={this.state.activeKey} onChange={tabsChange}>
                            {
                                this.tabItems.map(item => (
                                    <Tabs.Tab title={item.key} key={item.key}></Tabs.Tab>
                                ))
                            }
                        </Tabs>
                    </div>
                    <Row style={{ height: "100%" }}>
                        <Col
                            className={
                                `expanded loans-left-anchor pl-0 ${this.props.mode !== 'document' ? 'col-9' : 'document-left-anchor'}`
                            }
                        >
                            {this.sectionS1()}
                            {this.section1a(this.state.currentView)}
                            {this.section1b(this.state.currentView)}
                            {this.section1c(this.state.currentView)}
                            {this.section1d(this.state.currentView)}
                            {this.section1e(this.state.currentView)}
                            {this.sectionS2()}
                            {this.section2a()}
                            {this.section2b()}
                            {this.section2c(this.state.currentView)}
                            {this.section2d(this.state.currentView)}
                            {this.sectionS3()}
                            {this.section3a(this.state.currentView)}
                            {this.section3b(this.state.currentView)}
                            {this.section3c(this.state.currentView)}
                            <div className="px-4 pb-2">Any more properties declared below will be considered as extra properties and recorded into the URLA Continuation Sheet. </div>
                            {this.section3Extra(this.state.currentView)}
                            {this.sectionS4()}
                            {this.section4a()}
                            {this.section4b()}
                            {this.section4c()}
                            {this.section4d()}
                            {this.sectionS5()}
                            {this.section5a(this.state.currentView)}
                            {this.section5b(this.state.currentView)}
                            {this.sectionS6()}
                            {this.sectionS7(this.state.currentView)}
                            {this.sectionS8(this.state.currentView)}
                            {this.sectionS9()}
                            {
                                localStorage.getItem("configurations") && JSON.parse(localStorage.getItem("configurations"))?.enableLenderLoanInformation &&
                                <LenderLoanForm  currentView={this.state.currentView} editMode={this.state.editMode} application={this.props.application}/>}
                        </Col>
                        <Col
                            className={
                                `expanded loans-rigth-anchor ${this.props.mode !== 'document' ? 'col-3' : 'document-rigth-anchor pl-0 pr-0'}`
                            }
                        >
                            {
                                this.props.mode !== 'document' && (
                                    <div className="d-flex">
                                        {/* <Button
                        shape="circle"
                        onClick={() =>
                        this.setState({ expandedAnchor: !this.state.expandedAnchor })
                        }
                        size="large"
                        className="mt-4"
                        icon={
                        !this.state.expandedAnchor ? (
                            <LeftOutlined />
                        ) : (
                            <RightOutlined />
                        )
                        }
                        style={{ marginLeft: "-20px" }}
                    ></Button> */}
                                        <div style={{ color: "#6E6E70", marginLeft: 10, marginTop: 36 }}>
                                            QUICK GUIDE
                                        </div>
                                    </div>
                                )
                            }
                            <Anchor
                                affix={false}
                                offsetTop={this.state.offsetTop}
                                items={menuItems()}
                                onChange={(currentActiveLink) => {
                                    // 当用户点击Anchor链接时，更新activeKey
                                    const anchorId = currentActiveLink.replace('#', '')
                                    if (this.state.activeKey !== anchorId) {
                                        this.setState({ activeKey: anchorId })
                                        this.updateAnchorActiveState(anchorId)
                                    }
                                }}
                                onClick={(e, link) => {
                                    // 防止默认的滚动行为，使用我们自己的滚动方法
                                    e.preventDefault()
                                    const anchorId = link.href.replace('#', '')
                                    this.scrollToAnchor(`#${anchorId}`)
                                    this.setState({ activeKey: anchorId })
                                    this.updateAnchorActiveState(anchorId)
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            }
            <IncomeCalculationModal
                employerName={this.state.currentBusinessName}
                open={this.state.IncomeCalModal}
                borrowerId={this.props.borrower.id}
                currentView={this.state.currentView}
                onCancel={previewCancel}
                onUpdate={updateIncomeCalculation}
                incomeType={this.state.currentIncome.type}
                currentEmpData={this.state.currentIncome.currentEmpData}
            >

            </IncomeCalculationModal>
            <BusinessIncomeCalculationModal
                currentEmpData={this.state.currentIncome.currentEmpData}
                incomeType={this.state.currentIncome.type}
                businessName={this.state.currentBusinessName}
                borrower={this.state.currentView === "borrower" ? this.props.application.borrower : this.props.application.coborrower}
                open={this.state.BusinessIncomeCalModal}
                borrowerId={this.props.borrower.id}
                currentView={this.state.currentView}
                onCancel={previewCancelBusiness}
                onUpdate={updateBusinessIncomeCalculation}
            >
            </BusinessIncomeCalculationModal>
            <CreditSummaryReview
                loading={this.state.creditReportLoading}
                defaultCheckedType={this.state.creditCheckType}
                propertySource={this.state.currentView}
                open={this.state.creditSummaryReviewOpen}
                accounts={this.state.creditLiability}
                onCancel={() => this.setState({ creditSummaryReviewOpen: false, creditReportLoading: false })}
                // onConfirm={() => {this.setState({ creditSummaryReviewOpen: false })}}
                onConfirm={(link) => {this.setState({ creditSummaryReviewOpen: false });this.scrollToAnchor(link)}}
            >
            </CreditSummaryReview>
            <LinkModal
                open={this.state.linkModalOpen}
                linkType={this.state.linkType}
                currentView={this.state.currentView}
                onCancel={() => this.setState({ linkModalOpen: false })}
                onConfirm={() => this.setState({ linkModalOpen: false })}
            />
            </>
        )
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Interview)
)
